webpackJsonp([1],{

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/table/_table.js
var _table = __webpack_require__("fnDg");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/table/table.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var table = (_table["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/table/table.vue
function injectStyle (ssrContext) {
  __webpack_require__("4veK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  table,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var table_table = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2ww/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4veK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H1nm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HKQM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form-input/_form-input.js
var _form_input = __webpack_require__("qRo1");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var form_input = (_form_input["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
function injectStyle (ssrContext) {
  __webpack_require__("n9mN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_input,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_input_form_input = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/modal/_modal.js
var _modal = __webpack_require__("rKsW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/modal/modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var modal = (_modal["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/modal/modal.vue
function injectStyle (ssrContext) {
  __webpack_require__("xBwK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  modal,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var modal_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form-file/_form-file.js
var _form_file = __webpack_require__("9NuQ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-file/form-file.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var form_file = (_form_file["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-file/form-file.vue
function injectStyle (ssrContext) {
  __webpack_require__("Y9O/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_file,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_file_form_file = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PKif":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y9O/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zr7l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("/5sW");

// EXTERNAL MODULE: ./src/-service-app/styles/main-begin.scss
var main_begin = __webpack_require__("zoSq");
var main_begin_default = /*#__PURE__*/__webpack_require__.n(main_begin);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/index.js
var lib = __webpack_require__("ESwS");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/index.js + 121 modules
var es = __webpack_require__("e6fC");

// EXTERNAL MODULE: ./node_modules/vue-charts/dist/vue-charts.common.js
var vue_charts_common = __webpack_require__("mbGJ");
var vue_charts_common_default = /*#__PURE__*/__webpack_require__.n(vue_charts_common);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/configAxios.js



/* harmony default export */ var configAxios = (function (store) {
  // REQUEST
  axios_default.a.interceptors.request.use(function (config) {
    config.headers = config.headers || {};

    // AUTH
    var token = store.state.users.csrfToken;
    if (token) {
      config.headers['X-CSRF-Token'] = token;
    }
    config.withCredentials = true;

    // Config for POST
    switch (config.method) {
      case 'patch':
      case 'post':
        config.headers['Content-Type'] = 'application/json';
        break;
    }

    return config;
  });

  // RESPONSE
  axios_default.a.interceptors.response.use(function (response) {
    return response.data;
  }, function (errorObj) {
    if (errorObj.response.status === 401) {
      // The user session is not valid or expired
      store.dispatch('logout');
    }
    return promise_default.a.reject(errorObj.response.data);
  });
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/papaparse/papaparse.min.js
var papaparse_min = __webpack_require__("afOB");
var papaparse_min_default = /*#__PURE__*/__webpack_require__.n(papaparse_min);

// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__("t4zo");
var FileSaver_min_default = /*#__PURE__*/__webpack_require__.n(FileSaver_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var App = ({
  data: function data() {
    return {
      i18n: {
        lang: this.$t('lang')
      },
      isDev: true,
      isUpdate: true,
      buildTimestamp: 1710776305597
    };
  },

  methods: {
    logout: function logout() {
      this.$store.dispatch('logout');
    },
    deleteAllTransactions: function deleteAllTransactions() {
      if (window.confirm('Are you sure you want to delete all transactions?')) {
        this.$store.dispatch('deleteAllTransactions').then(function () {
          window.location.reload(true);
          window.alert('All transactions are deleted successfully.');
        });
      }
    },
    generateCSV: function generateCSV(data) {
      // let transactionId = parseFloat(this.transactionId) || 0
      // const date = this.customFormatter(this.date)
      var rows = [['Date', 'Counterparty', 'Client ID', 'Portfolio ID', 'Transaction ID', 'Type', 'Currency 1 Amount', 'Currency 1', 'Currency 2 Amount', 'Currency 2', 'Value in BGN']];
      // Fees
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tx = _step.value;

          rows.push([this.customFormatter(tx.date), tx.counterparty.user.firstName + ' ' + tx.counterparty.user.lastName, tx.counterparty.user.clientId, tx.portfolioId, tx.transactionId, tx.type, tx.currency1Amount, tx.currency1, tx.currency2Amount, tx.currency2, tx.bgnAmount]);
          // tx.details.pricesPieces.forEach((el, i) => {
          //   rows.push([
          //     date,
          //     `${client.firstName} ${client.lastName}`,
          //     client.clientId,
          //     client.portfolios[0].id,
          //     transactionId++,
          //     'blockchain fee',
          //     this.customFixed(client.details.blockchainFees[i], 14),
          //     this.tableValues[i + 1].baseAsset,
          //     '',
          //     '',
          //   ])
          // })
          //
          // client.details.pricesPieces.forEach((el, i) => {
          //   rows.push([
          //     date,
          //     `${client.firstName} ${client.lastName}`,
          //     client.clientId,
          //     client.portfolios[0].id,
          //     transactionId++,
          //     'change',
          //     this.customFixed(client.details.ccy1Arr[i], 14),
          //     this.tableValues[i + 1].baseAsset,
          //     this.customFixed(client.details.ccy2Arr[i], 14),
          //     this.tableValues[0].baseAsset,
          //   ])
          // })
        }
        // console.log(rows)
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return !data ? rows : papaparse_min_default.a.unparse(rows, { delimiter: ',' });
    },
    exportAllTransactions: function exportAllTransactions() {
      var _this = this;

      this.$store.dispatch('exportAllTransactions').then(function (res) {
        FileSaver_min_default.a.saveAs(new Blob([_this.generateCSV(res)], { type: 'text/csv;charset=utf-8' }), 'All-Transactions-' + _this.customFormatter(_this.date) + '.csv');
      });
    },
    customFixed: function customFixed(str) {
      var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;

      var rgx = new RegExp('-?\\d+\\.?\\d{0,' + num + '}');
      str = ('' + str).match(rgx);
      return str ? parseFloat(str[0]).toFixed(num) : parseFloat(0).toFixed(num);
    },
    customFormatter: function customFormatter(date) {
      return moment_default()(date).format('DD.MM.YYYY');
    }
  },
  computed: {
    user: function user() {
      return this.$store.getters.getLoggedUser;
    }
  },
  watch: {
    '$i18n.locale': function $i18nLocale() {
      this.i18n.lang = this.$t('lang');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e38d6b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',{class:{ debug: _vm.isDev, update: _vm.isUpdate }},[_c('header',[_c('b-navbar',{attrs:{"toggleable":"md","type":"light","variant":"light","id":"top-bar"}},[_c('b-navbar-brand',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/static/images/logo-sphere-h53.png","alt":""}}),_vm._v("\n            Service App\n        ")]),_vm._v(" "),(_vm.user)?[_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',[_c('b-nav-item',{attrs:{"to":"/","exact":""}},[_vm._v("Home")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/clients","exact":""}},[_vm._v("Clients")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/fund","exact":""}},[_vm._v("Fund")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/rebalance","exact":""}},[_vm._v("Rebalance")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/prices","exact":""}},[_vm._v("Prices")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/currencies","exact":""}},[_vm._v("Currencies")])],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item-dropdown',{attrs:{"text":"Settings","right":""}},[_c('b-dropdown-item',{attrs:{"to":"/groups"}},[_vm._v("Groups")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":"/users"}},[_vm._v("Users")])],1),_vm._v(" "),_c('b-nav-item-dropdown',{attrs:{"text":_vm.user.name,"right":""}},[_c('b-dropdown-item',{attrs:{"to":"/change"}},[_vm._v("Change Password")])],1),_vm._v(" "),_c('b-nav-item',{on:{"click":_vm.logout}},[_vm._v("Logout")])],1)],1)]:_vm._e()],2)],1),_vm._v(" "),_c('router-view'),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.isDev && (_vm.user && (_vm.user.email === 'dimitar.velev17@gmail.com' || _vm.user.email === 'tsvetan@tsvetan.com' || _vm.user.email === 'antonova.teodora@gmail.com')))?_c('div',{attrs:{"id":"dev-toolbox"}},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapseDevToolbox",modifiers:{"collapseDevToolbox":true}}],attrs:{"variant":"outline-danger"}},[_vm._v("* Dev Toolbox")]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapseDevToolbox"}},[_c('b-card',[_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"button"},on:{"click":_vm.exportAllTransactions}},[_vm._v("Export Transactions\n            ")]),_vm._v(" "),(_vm.isDev)?_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":_vm.deleteAllTransactions}},[_vm._v("Delete All\n                Transactions\n            ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_vm._v("\n                "+_vm._s(_vm.buildTimestamp)+"\n            ")])])],1)],1):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"text-center"},[_c('img',{attrs:{"src":"/static/images/logo-horizontal-h53.png","alt":"Blockchain.bg"}})])}]
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var _service_app_App = (esExports);
// CONCATENATED MODULE: ./src/-service-app/App.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  _service_app_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src__service_app_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./src/services/userService.js



var API_V1_URL = "https://updateapi.blockchain.bg/v1";

/* harmony default export */ var userService = (function (apiToUser) {
  return {
    updateUser: function updateUser(id, update) {
      return axios_default.a.patch(API_V1_URL + '/user/' + id, update);
    },

    // AUTH
    login: function login(email, password, role) {
      var credentials = { email: email, password: password };
      return axios_default.a.post(API_V1_URL + '/session', credentials).then(function (res) {
        if (res.data.role === role) {
          // Allow only users with the specified role to login
          return {
            user: apiToUser(res.data),
            csrfToken: res.csrfToken
          };
        } else {
          // Do NOT allow other users to login
          var err = new Error('There is no such user');
          err.wrongAppErr = true;
          return promise_default.a.reject(err);
        }
      });
    },
    logout: function logout() {
      return axios_default.a.delete(API_V1_URL + '/session');
    },
    setNewPass: function setNewPass(token, userId, password) {
      // The args are taken from the URL for password reset
      var postData = { token: token, userId: userId, password: password };
      return axios_default.a.patch(API_V1_URL + '/credentials/reset', postData);
    },
    changePass: function changePass(oldPassword, newPassword) {
      // The user changes the password themselves
      var postData = { oldPassword: oldPassword, newPassword: newPassword };
      return axios_default.a.patch(API_V1_URL + '/credentials/change', postData);
    }
  };
});
// CONCATENATED MODULE: ./src/helpers/numUtils.js
function precisionRound(number, precision) {
  var factor = Math.pow(10, precision);
  return Math.round(number * factor) / factor;
}

function roundTo(n) {
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var negative = false;
  if (n < 0) {
    negative = true;
    n = n * -1;
  }
  var multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  n = (Math.round(n) / multiplicator).toFixed(digits);
  if (negative) {
    n = (n * -1).toFixed(digits);
  }

  return format(+n, digits);
}

function format(number, minimumFractionDigits) {
  return number.toLocaleString('bg-BG', {
    minimumFractionDigits: minimumFractionDigits
  });
}

function formatStrNum(str) {
  return parseFloat(str).toString().split('.').join(',');
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round#Decimal_rounding
function decimalAdjust(type, value, exp) {
  // If the exp is undefined or zero...
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value);
  }
  value = +value;
  exp = +exp;
  // If the value is not a number or the exp is not an integer...
  if (value === null || isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }
  // If the value is negative...
  if (value < 0) {
    return -decimalAdjust(type, -value, exp);
  }
  // Shift
  value = value.toString().split('e');
  value = Math[type](+(value[0] + 'e' + (value[1] ? +value[1] - exp : -exp)));
  // Shift back
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? +value[1] + exp : exp));
}

function round(value, exp) {
  return decimalAdjust('round', value, exp);
}

/* harmony default export */ var numUtils = ({
  precisionRound: precisionRound,
  roundTo: roundTo,
  round: round,
  format: format,
  formatStrNum: formatStrNum
});
// CONCATENATED MODULE: ./src/helpers/dateUtils.js
function formatDate(date) {
  var year = date.getUTCFullYear();
  var month = addLeadingZero(date.getUTCMonth() + 1);
  var day = addLeadingZero(date.getUTCDate());

  return year + '-' + month + '-' + day;
}

function formatDateTime(date) {
  var fDate = formatDate(date);
  var hours = addLeadingZero(date.getUTCHours());
  var min = addLeadingZero(date.getUTCMinutes());
  var sec = addLeadingZero(date.getUTCSeconds());
  return fDate + ', ' + hours + ':' + min + ':' + sec;
}

function addLeadingZero(n) {
  return n < 10 ? '0' + n : n;
}

/* harmony default export */ var dateUtils = ({
  formatDate: formatDate,
  formatDateTime: formatDateTime
});
// CONCATENATED MODULE: ./src/services/converters.js



function apiToTransaction(data) {
  return {
    id: data.transactionId,
    type: data.type,
    date: dateUtils.formatDate(new Date(data.date)),
    c1Amount: data.currency1Amount ? numUtils.formatStrNum(data.currency1Amount) : null,
    c1: data.currency1,
    c2Amount: data.currency2Amount ? numUtils.formatStrNum(data.currency2Amount) : null,
    c2: data.currency2,
    valueBGN: +data.bgnAmount ? numUtils.formatStrNum(data.bgnAmount) : null
  };
}

function apiToPortfolio(data) {
  var totals = data.totals;

  var portfolio = {
    id: data.id,
    assets: data.assets.filter(function (asset) {
      return asset.pieces > 0;
    }).map(function (asset) {
      asset.valueBGNstr = numUtils.roundTo(asset.valueBGN, 2);
      asset.valueBGN = numUtils.round(asset.valueBGN, 0);
      asset.priceBGNstr = numUtils.roundTo(asset.priceBGN, 2);
      asset.shareStr = numUtils.roundTo(asset.share * 100, 2);
      asset.piecesStr = numUtils.formatStrNum(numUtils.precisionRound(asset.pieces, 8));
      return asset;
    }),
    stats: {
      roi: {},
      totalValueBGN: numUtils.roundTo(+totals.totalValueBGN, 2),
      totalDepositsBGN: numUtils.roundTo(+totals.totalDepositsBGN, 2),
      totalWithdrawalsBGN: numUtils.roundTo(+totals.totalWithdrawalsBGN, 2),
      totalCommissionsBGN: numUtils.roundTo(+totals.totalCommissionsBGN, 2),
      netProfitBGN: numUtils.roundTo(+totals.totalValueBGN + +totals.totalWithdrawalsBGN - +totals.totalDepositsBGN, 2)
    },
    updateTime: data.updateTime ? dateUtils.formatDateTime(new Date(data.updateTime)) : null
  };

  for (var periodKey in data.ROI) {
    var periodValues = data.ROI[periodKey];
    if (periodValues) {
      portfolio.stats.roi[periodKey] = {};
      for (var valueKey in periodValues) {
        portfolio.stats.roi[periodKey][valueKey] = numUtils.roundTo(periodValues[valueKey], 2);
      }
    }
  }

  return portfolio;
}


// CONCATENATED MODULE: ./src/-service-app/services/converters.js



function apiToUpload(data) {
  return {
    id: data.id,
    status: data.status,
    filename: data.meta.fileName,
    uploadTime: dateUtils.formatDateTime(new Date(data.created)),
    errorMsg: data.output ? data.output.reason : null,
    user: converters_apiToUser(data.creator)
  };
}

function apiToGroup(_ref) {
  var id = _ref.id,
      name = _ref.name;

  return { id: id, name: name };
}

function converters_apiToUser(data) {
  var user = data;
  user.name = data.firstName + ' ' + data.lastName;
  if (data.role === 'client') {
    user.portfolios = data.portfolios ? data.portfolios.map(function (portfolio) {
      return portfolio.id;
    }) : [];
    user.cgroups = user.cgroups ? user.cgroups.map(function (g) {
      return g.id;
    }) : [];
  }
  return user;
}


// CONCATENATED MODULE: ./src/-service-app/services/userService.js





var userService_API_V1_URL = "https://updateapi.blockchain.bg/v1";
var userService_userService = userService(converters_apiToUser);

function _createUser(user) {
  return axios_default.a.post(userService_API_V1_URL + '/users', user).then(function (res) {
    return converters_apiToUser(res.data);
  });
}

function getUsersByRole(role) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

  var query = [['role', role], ['offset', offset], ['limit', limit]].map(function (pair) {
    return pair.join('=');
  }).join('&');

  return axios_default.a.get(userService_API_V1_URL + '/users?' + query).then(function (res) {
    return {
      users: res.data.map(converters_apiToUser),
      total: res.count
    };
  });
}

/* harmony default export */ var services_userService = (extends_default()({}, userService_userService, {
  getUser: function getUser(id) {
    return axios_default.a.get(userService_API_V1_URL + '/user/' + id).then(function (res) {
      return converters_apiToUser(res.data);
    });
  },
  createUser: function createUser(user) {
    user.role = 'admin';
    return _createUser(user).catch(function (errObj) {
      return errObj.error;
    });
  },
  createClient: function createClient(client) {
    client.role = 'client';
    return _createUser(client);
  },
  getClients: function getClients(offset, limit) {
    return getUsersByRole('client', offset, limit);
  },
  getUsers: function getUsers(offset, limit) {
    return getUsersByRole('admin', offset, limit);
  },
  updateClientGroups: function updateClientGroups(id, cgroups) {
    return axios_default.a.patch(userService_API_V1_URL + '/user/' + id, { cgroups: cgroups }).then(function (res) {
      return res.data;
    });
  },

  // AUTH
  sendMailForNewPass: function sendMailForNewPass(email) {
    // It will trigger the server to send an email with a link for password reset
    return axios_default.a.post(userService_API_V1_URL + '/credentials/lost', { email: email });
  }
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/tables/AssetsTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var AssetsTable = ({
  props: ['coins']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a92bdf3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/tables/AssetsTable.vue
var AssetsTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-bordered",attrs:{"id":"assets_table_fund"}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.coins),function(coin){return _c('tr',[_c('td',[_vm._v(_vm._s(coin.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(coin.ticker))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(coin.shareStr)+"%")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(coin.valueBGNstr))]),_vm._v(" "),_c('td',{staticClass:"text-right formatnum",style:({ msonumberformat: '0\.000000000000'})},[_vm._v(_vm._s(coin.piecesStr))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(coin.priceBGNstr))])])}))])}
var AssetsTable_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Cryptocurrency")]),_vm._v(" "),_c('th',[_vm._v("Ticker")]),_vm._v(" "),_c('th',[_vm._v("Share")]),_vm._v(" "),_c('th',[_vm._v("Value (BGN)")]),_vm._v(" "),_c('th',[_vm._v("Number of coins")]),_vm._v(" "),_c('th',[_vm._v("Price (BGN)")])])])}]
var AssetsTable_esExports = { render: AssetsTable_render, staticRenderFns: AssetsTable_staticRenderFns }
/* harmony default export */ var tables_AssetsTable = (AssetsTable_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/tables/AssetsTable.vue
var AssetsTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AssetsTable___vue_template_functional__ = false
/* styles */
var AssetsTable___vue_styles__ = null
/* scopeId */
var AssetsTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AssetsTable___vue_module_identifier__ = null
var AssetsTable_Component = AssetsTable_normalizeComponent(
  AssetsTable,
  tables_AssetsTable,
  AssetsTable___vue_template_functional__,
  AssetsTable___vue_styles__,
  AssetsTable___vue_scopeId__,
  AssetsTable___vue_module_identifier__
)

/* harmony default export */ var components_tables_AssetsTable = (AssetsTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/tables/ClientTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ClientTable = ({
  props: ['client', 'groups'],
  data: function data() {
    return {
      cgroups: this.client.cgroups[0],
      ans: false
    };
  },

  watch: {
    client: function client() {
      this.cgroups = this.client.cgroups[0];
    }
  },
  methods: {
    toggleCheck: function toggleCheck(event) {
      if (confirm('Are you sure?')) {
        event.target.checked = true;
      } else {
        event.preventDefault();
      }
    },
    toggleGroup: function toggleGroup() {
      // event.preventDefault()
      // this.ans = confirm('Are you sure?')
      // event.target.checked = this.ans
      // if (this.ans) {
      this.$store.dispatch('updateClientGroups', {
        id: this.client.id,
        cgroups: this.cgroups
      });
      // }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-560f9c7f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/tables/ClientTable.vue
var ClientTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-bordered"},[_c('tbody',[_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Name:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.client.name))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Client ID:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.client.clientId))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Email:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.client.email))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Phone:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.client.phone))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Contract Id:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.client.contractId))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Portfolio Id:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.client.portfolios[0]))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v("Groups:")]),_vm._v(" "),_c('td',[_c('ul',_vm._l((_vm.groups),function(group){return _c('li',[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cgroups),expression:"cgroups"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"groupscheckbox","id":group.id},domProps:{"value":group.id,"checked":_vm._q(_vm.cgroups,group.id)},on:{"click":_vm.toggleCheck,"change":[function($event){_vm.cgroups=group.id},_vm.toggleGroup]}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":group.id}},[_vm._v(_vm._s(group.name))])])])}))])])])])}
var ClientTable_staticRenderFns = []
var ClientTable_esExports = { render: ClientTable_render, staticRenderFns: ClientTable_staticRenderFns }
/* harmony default export */ var tables_ClientTable = (ClientTable_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/tables/ClientTable.vue
var ClientTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ClientTable___vue_template_functional__ = false
/* styles */
var ClientTable___vue_styles__ = null
/* scopeId */
var ClientTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ClientTable___vue_module_identifier__ = null
var ClientTable_Component = ClientTable_normalizeComponent(
  ClientTable,
  tables_ClientTable,
  ClientTable___vue_template_functional__,
  ClientTable___vue_styles__,
  ClientTable___vue_scopeId__,
  ClientTable___vue_module_identifier__
)

/* harmony default export */ var components_tables_ClientTable = (ClientTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/tables/PortfolioTotalsTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PortfolioTotalsTable = ({
  props: ['data']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73fa2978","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/tables/PortfolioTotalsTable.vue
var PortfolioTotalsTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table table-bordered"},[_c('tr',[_c('th',[_vm._v("Total Deposits:")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.data.totalDepositsBGN))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Total Withdrawals:")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.data.totalWithdrawalsBGN))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Total Commissions:")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.data.totalCommissionsBGN))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Net Profit:")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.data.netProfitBGN))])])])])}
var PortfolioTotalsTable_staticRenderFns = []
var PortfolioTotalsTable_esExports = { render: PortfolioTotalsTable_render, staticRenderFns: PortfolioTotalsTable_staticRenderFns }
/* harmony default export */ var tables_PortfolioTotalsTable = (PortfolioTotalsTable_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/tables/PortfolioTotalsTable.vue
var PortfolioTotalsTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PortfolioTotalsTable___vue_template_functional__ = false
/* styles */
var PortfolioTotalsTable___vue_styles__ = null
/* scopeId */
var PortfolioTotalsTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PortfolioTotalsTable___vue_module_identifier__ = null
var PortfolioTotalsTable_Component = PortfolioTotalsTable_normalizeComponent(
  PortfolioTotalsTable,
  tables_PortfolioTotalsTable,
  PortfolioTotalsTable___vue_template_functional__,
  PortfolioTotalsTable___vue_styles__,
  PortfolioTotalsTable___vue_scopeId__,
  PortfolioTotalsTable___vue_module_identifier__
)

/* harmony default export */ var components_tables_PortfolioTotalsTable = (PortfolioTotalsTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/tables/TransactionsTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TransactionsTable = ({
  created: function created() {
    this.loadTransaction(this.portfolioId);
  },

  props: ['portfolioId'],
  data: function data() {
    return {
      loading: false,
      error: null,
      currentPage: 1,
      itemsPerPage: 20
    };
  },

  computed: {
    transactions: function transactions() {
      return this.$store.getters.getSPTransactions;
    },
    total: function total() {
      return this.$store.getters.getSPTransactionsTotal;
    }
  },
  methods: {
    loadTransaction: function loadTransaction(portfolioId) {
      var _this = this;

      var params = {
        portfolioId: portfolioId,
        page: this.currentPage,
        itemsPerPage: this.itemsPerPage
      };

      this.error = null;
      this.loading = true;

      this.$store.dispatch('loadPortfolioTransactions', params).catch(function (errMsg) {
        _this.error = errMsg;
      }).finally(function () {
        _this.loading = false;
      });
    }
  },
  watch: {
    portfolioId: function portfolioId(newId) {
      if (newId) {
        this.currentPage = 1;
        this.loadTransaction(newId);
      }
    },
    currentPage: function currentPage() {
      this.loadTransaction(this.portfolioId);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6105d9cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/tables/TransactionsTable.vue
var TransactionsTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('div',{staticClass:"alert alert-danger text-center"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.total)?_c('table',{staticClass:"table table-striped"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.transactions[_vm.currentPage]),function(transaction){return _c('tr',[_c('td',[_vm._v(_vm._s(transaction.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.date))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(transaction.c1Amount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.c1))]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(transaction.c2Amount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(transaction.c2))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(transaction.valueBGN))])])}))]):_vm._e(),_vm._v(" "),(!_vm.total)?_c('div',[_vm._v("There are no transactions.")]):_vm._e(),_vm._v(" "),(_vm.total > _vm.itemsPerPage)?_c('b-pagination',{attrs:{"size":"md","total-rows":_vm.total,"per-page":_vm.itemsPerPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e(),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)}
var TransactionsTable_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Type")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Date")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Currency 1 Amount")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Currency 1")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Currency 2 Amount")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Currency 2")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Value in BGN")])])])}]
var TransactionsTable_esExports = { render: TransactionsTable_render, staticRenderFns: TransactionsTable_staticRenderFns }
/* harmony default export */ var tables_TransactionsTable = (TransactionsTable_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/tables/TransactionsTable.vue
var TransactionsTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TransactionsTable___vue_template_functional__ = false
/* styles */
var TransactionsTable___vue_styles__ = null
/* scopeId */
var TransactionsTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TransactionsTable___vue_module_identifier__ = null
var TransactionsTable_Component = TransactionsTable_normalizeComponent(
  TransactionsTable,
  tables_TransactionsTable,
  TransactionsTable___vue_template_functional__,
  TransactionsTable___vue_styles__,
  TransactionsTable___vue_scopeId__,
  TransactionsTable___vue_module_identifier__
)

/* harmony default export */ var components_tables_TransactionsTable = (TransactionsTable_Component.exports);

// EXTERNAL MODULE: ./node_modules/decimal.js/decimal.js
var decimal = __webpack_require__("wbDN");
var decimal_default = /*#__PURE__*/__webpack_require__.n(decimal);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/tables/TaxinfoTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





decimal_default.a.set({ toExpNeg: -14 });
/* harmony default export */ var TaxinfoTable = ({
  created: function created() {
    this.loadTransaction(this.portfolioId);
  },

  props: ['portfolioId'],
  data: function data() {
    return {
      loading: false,
      error: null,
      years: {
        // selected: 1,
        options: []
      },
      pId: null,
      ready: false,
      transactions: null,
      days: null,
      currencies: null,
      endsums: null,
      endresult: null,
      total: null,
      selectedyear: null,
      enddate: null
    };
  },

  methods: {
    loadTransaction: function loadTransaction(portfolioId) {
      var _this = this;

      this.pId = portfolioId;
      var yearsId = 0;
      axios_default.a.get("https://updateapi.blockchain.bg/v1" + '/portfolio/' + portfolioId + '/tx/years').then(function (res) {
        _this.years.options = [{ value: '', text: '' }].concat(res.data.map(function (date, i) {
          return { value: ++yearsId, text: date };
        }));
      });
    },
    customFixed: function customFixed(str) {
      var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;

      var rgx = new RegExp('-?\\d+\\.?\\d{0,' + num + '}');
      str = ('' + str).match(rgx);
      return str ? parseFloat(str[0]).toFixed(num) : parseFloat(0).toFixed(num);
    },
    onSelect: function onSelect(v) {
      var _this2 = this;

      this.ready = false;
      this.error = null;
      this.loading = true;

      if (this.years.options[v]) {
        return axios_default.a.get("https://updateapi.blockchain.bg/v1" + '/portfolio/' + this.pId + '/tx' + (this.years.options[v].text ? '/year/' + this.years.options[v].text : '')).then(function (res) {
          _this2.transactions = res.data.transactions;
          _this2.days = res.data.days;
          _this2.currencies = res.data.currencies;
          _this2.endsums = res.data.endsums;
          _this2.endresult = res.data.endresult;
          _this2.total = res.count;
          _this2.selectedyear = _this2.years.options[v].text;
          _this2.enddate = res.data.enddate;
        }).catch(function (errMsg) {
          _this2.error = errMsg;
        }).finally(function () {
          _this2.loading = false;
          _this2.ready = true;
        });
      } else {
        this.ready = false;
        this.transactions = false;
        this.error = null;
        this.loading = false;
        return true;
      }
    },
    pdf: function pdf() {
      var pdfMake = __webpack_require__("EWlk");
      if (pdfMake.vfs === undefined) {
        var pdfFonts = __webpack_require__("u1n8");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      var logoimg = 'data:image/jpeg;base64,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';
      var daysdata = [[{ text: 'Дата', style: 'tableHeader' }, { text: 'Продажна цена', style: 'tableHeader' }, { text: 'Цена на придобиване', style: 'tableHeader' }, { text: 'Обща печалба', style: 'tableHeader' }, { text: 'Обща загуба', style: 'tableHeader' }]];
      for (var day in this.days) {
        var profit = 0;
        var loss = 0;
        if (this.days[day].profitLoss > 0) {
          profit = this.days[day].profitLoss.toFixed(2).toString();
        } else if (this.days[day].profitLoss < 0) {
          loss = this.days[day].profitLoss.toFixed(2).toString();
        } else {
          profit = 0;
          loss = 0;
        }
        daysdata.push([day, { text: this.days[day].proceeds.toFixed(2).toString(), alignment: 'right' }, { text: this.days[day].price.toFixed(2).toString(), alignment: 'right' }, { text: profit, alignment: 'right' }, { text: loss, alignment: 'right' }]);
      }
      var dealsdata = [[{ text: 'Дата', style: 'tableHeader' }, { text: 'Номер', style: 'tableHeader' }, { text: 'Вид транзакция', style: 'tableHeader' }, { text: 'Продадена валута', style: 'tableHeader' }, { text: 'Количество продадена валута', style: 'tableHeader' }, { text: 'Продажна цена (лв.)', style: 'tableHeader' }, { text: 'Цена на придобиване (лв.)', style: 'tableHeader' }, { text: 'Резултат от сделката (лв.)', style: 'tableHeader' }]];
      for (var tx in this.transactions) {
        dealsdata.push([this.transactions[tx].date, this.transactions[tx].transactionId, this.$t(this.transactions[tx].type, 'bg'), this.transactions[tx].soldCcy, { text: this.transactions[tx].soldCcyAmount.toFixed(8).toString(), alignment: 'right' }, { text: this.transactions[tx].salesProceedsBGN.toFixed(2).toString(), alignment: 'right' }, { text: this.transactions[tx].costBasisBGN.toFixed(2).toString(), alignment: 'right' }, { text: this.transactions[tx].profitLoss.toFixed(2).toString(), alignment: 'right' }]);
      }
      dealsdata.push([{ colSpan: 8, text: 'Нетен резултат: ' + this.endresult.toFixed(2).toString(), alignment: 'right' }]);
      // console.log(this.$store.getters.getClient)
      var docDefinition = {
        info: {
          title: 'Tax info',
          author: 'blockchain.bg'
        },
        pageMargins: [60, 40, 40, 80],
        pageSize: 'A4',
        footer: function footer(currentPage, pageCount) {
          return {
            table: {
              body: [[{ text: currentPage.toString() + ' / ' + pageCount, alignment: 'right', style: 'smallText', margin: [60, 20, 50, 40] }]]
            },
            widths: ['auto'],
            layout: 'noBorders'
          };
        },
        content: [{
          style: 'tablePagehead',
          table: {
            headerRows: 1,
            widths: ['*', 'auto', '*'],
            body: [['', '', { image: logoimg, width: 100, alignment: 'right' }], [{ text: this.$store.getters.getClient.firstName + ' ' + this.$store.getters.getClient.lastName + '\n' + this.$store.getters.getClient.email + '\n#клиентска сметка: ' + this.pId }, '', { text: 'Блокчейн-БГ ООД\nЕИК: 204853211\nул. Шипка 6, ет. 3\nСофия 1504, България', alignment: 'right' }]]
          },
          layout: {
            hLineWidth: function hLineWidth(i, node) {
              return 0;
            },
            vLineWidth: function vLineWidth(i, node) {
              return 0;
            }
          }
        }, { text: 'Извлечение за ' + this.selectedyear + ' Данъчна година', style: 'header', alignment: 'center' }, { text: 'Свалено на ' + moment_default()().format('DD.MM.YYYY HH:mm') + ' от app.blockchain.bg', alignment: 'center' }, { text: 'Таблица 1: Данъчен резултат по дата\n', style: 'subheader', margin: [0, 20, 0, 10] }, {
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto'],
            body: daysdata
          },
          layout: {
            fillColor: function fillColor(rowIndex, node, columnIndex) {
              return (rowIndex - 1) % 2 === 0 && rowIndex !== 0 ? '#e9ecef' : null;
            },
            hLineWidth: function hLineWidth(i, node) {
              return i === 0 || i === node.table.body.length ? 1 : 1;
            },
            vLineWidth: function vLineWidth(i, node) {
              return i === 0 || i === node.table.widths.length ? 0 : 0;
            },
            hLineColor: function hLineColor(i, node) {
              return i === 0 || i === node.table.body.length ? 'none' : 'gray';
            },
            vLineColor: function vLineColor(i, node) {
              return i === 0 || i === node.table.widths.length ? 'none' : 'gray';
            },
            paddingLeft: function paddingLeft(i, node) {
              return 4;
            },
            paddingRight: function paddingRight(i, node) {
              return 4;
            },
            paddingTop: function paddingTop(i, node) {
              return 3;
            },
            paddingBottom: function paddingBottom(i, node) {
              return 3;
            }
          }
        }, { text: 'Таблица 2: Данъчен резултат по сделка\n', style: 'subheader', margin: [0, 20, 0, 10] }, {
          style: 'tableExample',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: dealsdata
          },
          layout: {
            fillColor: function fillColor(rowIndex, node, columnIndex) {
              return (rowIndex - 1) % 2 === 0 && rowIndex !== 0 ? '#e9ecef' : null;
            },
            hLineWidth: function hLineWidth(i, node) {
              return i === 0 || i === node.table.body.length ? 1 : 1;
            },
            vLineWidth: function vLineWidth(i, node) {
              return i === 0 || i === node.table.widths.length ? 0 : 0;
            },
            hLineColor: function hLineColor(i, node) {
              return i === 0 || i === node.table.body.length ? 'none' : 'gray';
            },
            vLineColor: function vLineColor(i, node) {
              return i === 0 || i === node.table.widths.length ? 'none' : 'gray';
            },
            paddingLeft: function paddingLeft(i, node) {
              return 4;
            },
            paddingRight: function paddingRight(i, node) {
              return 4;
            },
            paddingTop: function paddingTop(i, node) {
              return 3;
            },
            paddingBottom: function paddingBottom(i, node) {
              return 3;
            }
          }
        }, { text: '\nВажни бележки и инструкции за попълване на годишна данъчна декларация:\n\n', style: 'bold' }, {
          ul: ['Изготвихме горната информация с цел максимално да Ви улесним при попълване на годишната данъчна декларация (ГДД).', 'Бихме искали да подчертаем, че данните ще са Ви полезни и правилно изчислени само ако това са единствените Ви сделки с криптовалути - тоест ако сте търгували за собствена сметка извън услугата, която ние предлагаме ще трябва да включите и останалите сделки.', 'На база на запитване направено от нас към НАП и отговора, който получихме става ясно, че доходите от продажба или замяна на финансови активи, в т.ч. и криптовалута, са в обхвата на доходите, които подлежат на облагане с данък върху общата годишна данъчна основа, като печалбите/загубите се декларират в годишната данъчна декларация по чл. 50 от ЗДДФЛ за годината, през която се смятат за продобити доходите. Казано с по-прости думи - кросовите сделки, които извършваме за Ваша сметка при всяко едно ребалансиране на портфейла са данъчно събитие и реализирания резултат трябва да се декларира в НАП. Ако е положителен се дължи данък, а ако е отрицателен остава само задължението да се декларира.', 'За целта е необходимо да попълните Приложение № 5 - Доходи от прехвърляне на права или имущество и по конкретно Таблица 2 с код 508 (в поле 2) от ГДД.', 'Данните в Таблица 1 (Данъчен резултат по дата) от извлечението, което може да свалите от нашата системата са готови за попълване в полета 3-7 в Таблица 2, Приложение № 5 от ГДД.', 'Понеже ребалансиранията се извършват от нас на чуждестранни борси полета 8-9  “Данни за платеца” се оставят празни и се слага тик на поле 2.2. Ако обаче през данъчната година сте продали криптовалути за фиатни пари чрез българско дружество се слага тик на поле 2.1 и съответно се попълват полета 8 и 9.', 'При изчислението на данъчния резултат сме използвали цени от следните източници:', {
            ul: ['Курс “Долар/Лев” – референтен курс на БНБ за конкретната дата. При липса на наличен курс се използва предхождащия курс обявен от БНБ.', 'Курс “Биткойн/Долар” – цена на затваряне от сайта coinmarketcap.com за конкретната дата']
          }, 'В заключение, бихме искали да подчертаем, че ние не сме специалисти по данъчно право и Ви препоръчваме да ползвате услугите на професионален счетоводител при изготвяне и подаване на годишната данъчна декларация. Оставаме на разположение при въпроси от Ваша страна.'],
          style: 'mediumText'
        }],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 5]
          },
          subheader: {
            fontSize: 14,
            bold: true,
            margin: [0, 5, 0, 3]
          },
          tableExample: {
            fontSize: 9,
            margin: [0, 5, 0, 10]
          },
          tablePagehead: {
            margin: [0, 0, 0, 40]
          },
          tableHeader: {
            bold: true,
            fontSize: 9,
            color: 'black',
            alignment: 'center'
          },
          bold: {
            bold: true
          },
          smallText: {
            fontSize: 9
          },
          mediumText: {
            fontSize: 10
          }
        },
        defaultStyle: {
          // alignment: 'justify'
        }
      };
      pdfMake.createPdf(docDefinition).download('tax_info_' + this.selectedyear + '_' + moment_default()().format('DD-MM-YYYY') + '.pdf');
    },
    csvExport: function csvExport() {
      var csvContent = '';
      csvContent += '"Блокчейн-БГ ООД ЕИК:204853211, ул.Шипка 6, ет.3, София 1504 България"\n\n"Извлечение за ' + this.selectedyear + ' Данъчна година"\n"Свалено на ' + moment_default()().format('DD.MM.YYYY HH:mm') + ' от app.blockchain.bg"\n';
      csvContent += '"' + this.$store.getters.getClient.firstName + ' ' + this.$store.getters.getClient.lastName + ', ' + this.$store.getters.getClient.email + ', клиентска сметка: ' + this.pId + '"\n\n';
      csvContent += 'Таблица 1: Данъчен резултат по дата\n';
      csvContent += 'Дата;Продажна цена;Цена на придобиване;Обща печалба;Обща загуба\n\n';
      for (var day in this.days) {
        var profit = 0;
        var loss = 0;
        if (this.days[day].profitLoss > 0) {
          profit = this.days[day].profitLoss.toFixed(2).toString();
        } else if (this.days[day].profitLoss < 0) {
          loss = this.days[day].profitLoss.toFixed(2).toString();
        } else {
          profit = 0;
          loss = 0;
        }
        csvContent += day + ';' + this.days[day].proceeds.toFixed(2).toString() + ';' + this.days[day].price.toFixed(2).toString() + ';' + profit + ';' + loss + '\n';
      }
      csvContent += '\n\nТаблица 2: Данъчен резултат по сделка\n';
      csvContent += 'Дата;Номер;Вид транзакция;Продадена валута;Количество продадена валута;Продажна цена (лв.);Цена на придобиване (лв.);Резултат от сделката (лв.)\n';
      for (var tx in this.transactions) {
        csvContent += this.transactions[tx].date + ';' + this.transactions[tx].transactionId + ';' + this.$t(this.transactions[tx].type, 'bg') + ';' + this.transactions[tx].soldCcy + ';' + this.transactions[tx].soldCcyAmount.toFixed(8).toString() + ';' + this.transactions[tx].salesProceedsBGN.toFixed(2).toString() + ';' + this.transactions[tx].costBasisBGN.toFixed(2).toString() + ';' + this.transactions[tx].profitLoss.toFixed(2).toString() + '\n';
      }
      csvContent += '\nНетен резултат: ' + this.endresult.toFixed(2).toString();
      csvContent += '\n\nВажни бележки и инструкции за попълване на годишна данъчна декларация:\n';
      csvContent += '"- Изготвихме горната информация с цел максимално да Ви улесним при попълване на годишната данъчна декларация (ГДД)."\n"- Бихме искали да подчертаем, че данните ще са Ви полезни и правилно изчислени само ако това са единствените Ви сделки с криптовалути - тоест ако сте търгували за собствена сметка извън услугата, която ние предлагаме ще трябва да включите и останалите сделки."\n"- На база на запитване направено от нас към НАП и отговора, който получихме става ясно, че доходите от продажба или замяна на финансови активи, в т.ч. и криптовалута, са в обхвата на доходите, които подлежат на облагане с данък върху общата годишна данъчна основа, като печалбите/загубите се декларират в годишната данъчна декларация по чл. 50 от ЗДДФЛ за годината, през която се смятат за продобити доходите. Казано с по-прости думи - кросовите сделки, които извършваме за Ваша сметка при всяко едно ребалансиране на портфейла са данъчно събитие и реализирания резултат трябва да се декларира в НАП. Ако е положителен се дължи данък, а ако е отрицателен остава само задължението да се декларира."\n"- За целта е необходимо да попълните Приложение № 5 - Доходи от прехвърляне на права или имущество и по конкретно Таблица 2 с код 508 (в поле 2) от ГДД."\n"- Данните в Таблица 1 (Данъчен резултат по дата) от извлечението, което може да свалите от нашата системата са готови за попълване в полета 3-7 в Таблица 2, Приложение № 5 от ГДД."\n"- Понеже ребалансиранията се извършват от нас на чуждестранни борси полета 8-9  “Данни за платеца” се оставят празни и се слага тик на поле 2.2. Ако обаче през данъчната година сте продали криптовалути за фиатни пари чрез българско дружество се слага тик на поле 2.1 и съответно се попълват полета 8 и 9."\n"- При изчислението на данъчния резултат сме използвали цени от следните източници:"\n" - Курс “Долар/Лев” – референтен курс на БНБ за конкретната дата. При липса на наличен курс се използва предхождащия курс обявен от БНБ."\n" - Курс “Биткойн/Долар” – цена на затваряне от сайта coinmarketcap.com за конкретната дата"\n"- В заключение, бихме искали да подчертаем, че ние не сме специалисти по данъчно право и Ви препоръчваме да ползвате услугите на професионален счетоводител при изготвяне и подаване на годишната данъчна декларация. Оставаме на разположение при въпроси от Ваша страна."';
      csvContent.replace(/(^\[)|(\]$)/gm, '');
      var data = encodeURIComponent('\uFEFF' + csvContent);
      var link = document.createElement('a');
      // link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + data)
      link.setAttribute('href', 'data:text/csv;charset=utf-8,' + data);
      link.setAttribute('download', 'tax_info_' + this.selectedyear + '_' + moment_default()().format('DD-MM-YYYY') + '.csv');
      link.click();
    }
  },
  watch: {
    portfolioId: function portfolioId(newId) {
      if (newId) {
        this.loadTransaction(newId);
      }
    },

    '$i18n.locale': function $i18nLocale() {
      this.i18n = {
        silentTranslationWarn: false
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24944606","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/tables/TaxinfoTable.vue
var TaxinfoTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('div',{staticClass:"alert alert-danger text-center"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"form-inline"},[_c('label',{staticClass:"mr-4",attrs:{"for":"year"}},[_vm._v("Select a tax year:")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"year","options":_vm.years.options},on:{"input":_vm.onSelect}})],1)]),_vm._v(" "),(_vm.transactions && _vm.transactions.length !== 0)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row my-3 justify-content-center"},[(_vm.ready)?_c('table',{staticClass:"table table-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.transactions),function(tx){return _c('tr',[_c('td',[_vm._v(_vm._s(tx.date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(tx.transactionId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(tx.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(tx.soldCcy))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(parseFloat(tx.soldCcyAmount).toFixed(8)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(parseFloat(tx.salesProceedsBGN).toFixed(2)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[(tx.costBasisBGN)?_c('span',[_vm._v(_vm._s(parseFloat(tx.costBasisBGN).toFixed(2)))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-right"},[(tx.profitLoss)?_c('span',[_vm._v(_vm._s(parseFloat(tx.profitLoss).toFixed(2)))]):_c('span',[_vm._v("0.00")])])])})),_vm._v(" "),_c('tfoot',[_c('tr',[_vm._m(2),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('b',[_vm._v(_vm._s(parseFloat(_vm.endresult).toFixed(2)))])])])])]):_vm._e()]),_vm._v(" "),_vm._m(3),_vm._v(" "),(_vm.days)?_c('div',{staticClass:"row my-3 justify-content-center"},[_c('table',{staticClass:"table table-striped"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.days),function(value,name){return _c('tr',[_c('td',[_vm._v(_vm._s(name))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[(value.proceeds)?_c('span',[_vm._v(_vm._s(parseFloat(value.proceeds).toFixed(2)))]):_c('span',[_vm._v("0.00")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[(value.price)?_c('span',[_vm._v(_vm._s(parseFloat(value.price).toFixed(2)))]):_c('span',[_vm._v("0.00")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[(value.profitLoss >= 0)?_c('span',[_vm._v(_vm._s(parseFloat(value.profitLoss).toFixed(2)))]):_c('span',[_vm._v("0.00")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[(value.profitLoss <= 0)?_c('span',[_vm._v(_vm._s(parseFloat(value.profitLoss).toFixed(2)))]):_c('span',[_vm._v("0.00")])])])}))])]):_vm._e(),_vm._v(" "),(_vm.endsums)?_c('div',{staticClass:"row my-5 justify-content-center"},[(_vm.ready)?_c('table',{staticClass:"table table-striped text-right"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-left",attrs:{"scope":"col"}},[_vm._v("Currency")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Quantity"),_c('br'),_vm._v("on "+_vm._s(_vm.enddate))]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Average cost basis"),_c('br'),_vm._v("on "+_vm._s(_vm.enddate))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.endsums),function(value,name){return [_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(name))]),_vm._v(" "),_c('td',[(value.quantity)?_c('span',[_vm._v(_vm._s(parseFloat(value.quantity).toFixed(8)))]):_vm._e()]),_vm._v(" "),_c('td',[(value.price && parseFloat(value.quantity).toFixed(8) !== '0.00000000')?_c('span',[_vm._v(_vm._s(parseFloat(value.price).toFixed(2)))]):_c('span',[_vm._v("0.00")])])])]})],2)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row my-5 justify-content-center"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.pdf()}}},[_c('span',{staticClass:"glyphicon glyphicon-download-alt"}),_vm._v(" Download as PDF")]),_vm._v("  \n          "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.csvExport()}}},[_c('span',{staticClass:"glyphicon glyphicon-download-alt"}),_vm._v(" Download as CSV")])])]):_c('div',[(_vm.ready)?_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6 py-4 text-center"},[_vm._v("There is no tax event in the selected tax year")])]):_vm._e()]),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)}
var TaxinfoTable_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('h3',{staticClass:"mt-5"},[_vm._v("Tax result by transactions")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"130px"},attrs:{"scope":"col"}},[_vm._v("Date")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Transaction number")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Transaction type")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Sold currency")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Sold currency"),_c('br'),_vm._v("amount")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Sale proceeds (BGN)")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Cost basis (BGN)")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Profit/Loss (BGN)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-right",attrs:{"colspan":"7"}},[_c('b',[_vm._v("Net result:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center",attrs:{"id":"pafdm"}},[_c('h3',{staticClass:"mt-5"},[_vm._v("Tax result by date")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Date")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Sale proceeds")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Cost basis")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Total profit")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Total loss")])])])}]
var TaxinfoTable_esExports = { render: TaxinfoTable_render, staticRenderFns: TaxinfoTable_staticRenderFns }
/* harmony default export */ var tables_TaxinfoTable = (TaxinfoTable_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/tables/TaxinfoTable.vue
function injectStyle (ssrContext) {
  __webpack_require__("ww1v")
}
var TaxinfoTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var TaxinfoTable___vue_template_functional__ = false
/* styles */
var TaxinfoTable___vue_styles__ = injectStyle
/* scopeId */
var TaxinfoTable___vue_scopeId__ = "data-v-24944606"
/* moduleIdentifier (server only) */
var TaxinfoTable___vue_module_identifier__ = null
var TaxinfoTable_Component = TaxinfoTable_normalizeComponent(
  TaxinfoTable,
  tables_TaxinfoTable,
  TaxinfoTable___vue_template_functional__,
  TaxinfoTable___vue_styles__,
  TaxinfoTable___vue_scopeId__,
  TaxinfoTable___vue_module_identifier__
)

/* harmony default export */ var components_tables_TaxinfoTable = (TaxinfoTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/charts/AssetsPieChart.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var AssetsPieChart = ({
  props: ['assets'],
  data: function data() {
    return {
      columns: [{
        'type': 'string',
        'label': 'Coin'
      }, {
        'type': 'number',
        'label': 'Value in BGN'
      }, {
        'type': 'string',
        'role': 'tooltip',
        'p': { 'html': true }
      }],
      options: {
        width: 800,
        height: 500,
        is3D: true,
        legend: 'labeled',
        pieSliceText: 'none',
        tooltip: {
          isHtml: true
        }
      }
    };
  },

  computed: {
    rows: function rows() {
      return this.assets.map(function (asset) {
        return [asset.name, asset.valueBGN, '<div class="assets-tooltip">' + asset.valueBGN + ' BGN</div>'];
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a257ef2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/charts/AssetsPieChart.vue
var AssetsPieChart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-chart',{attrs:{"chart-type":"PieChart","columns":_vm.columns,"rows":_vm.rows,"options":_vm.options}})],1)}
var AssetsPieChart_staticRenderFns = []
var AssetsPieChart_esExports = { render: AssetsPieChart_render, staticRenderFns: AssetsPieChart_staticRenderFns }
/* harmony default export */ var charts_AssetsPieChart = (AssetsPieChart_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/charts/AssetsPieChart.vue
var AssetsPieChart_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AssetsPieChart___vue_template_functional__ = false
/* styles */
var AssetsPieChart___vue_styles__ = null
/* scopeId */
var AssetsPieChart___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AssetsPieChart___vue_module_identifier__ = null
var AssetsPieChart_Component = AssetsPieChart_normalizeComponent(
  AssetsPieChart,
  charts_AssetsPieChart,
  AssetsPieChart___vue_template_functional__,
  AssetsPieChart___vue_styles__,
  AssetsPieChart___vue_scopeId__,
  AssetsPieChart___vue_module_identifier__
)

/* harmony default export */ var components_charts_AssetsPieChart = (AssetsPieChart_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/ClientPage.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var ClientPage = ({
  components: {
    ClientTable: components_tables_ClientTable,
    TotalsTable: components_tables_PortfolioTotalsTable,
    TransactionsTable: components_tables_TransactionsTable,
    TaxinfoTable: components_tables_TaxinfoTable,
    AssetsTable: components_tables_AssetsTable,
    PieChart: components_charts_AssetsPieChart
  },
  created: function created() {
    var _this = this;

    this.loading = true;
    var clients = this.$store.getters.getClients();
    var client = void 0;
    var clientPromise = void 0;
    var groupPromise = void 0;
    groupPromise = this.$store.dispatch('loadGroups');

    if (clients && clients.length) {
      client = clients.find(function (cl) {
        return cl.id === _this.clientId;
      });
    }

    if (!client) {
      client = this.$store.getters.getClient;
    }

    if (!client || client.id !== this.clientId) {
      // We have to fetch the client
      clientPromise = this.$store.dispatch('getClient', this.clientId);
    } else {
      // We alrady have the client
      clientPromise = this.$store.dispatch('setClient', client);
    }

    clientPromise.then(function (client) {
      return client.portfolios;
    }).then(function (portfolioIds) {
      if (!portfolioIds || !portfolioIds.length) {
        return promise_default.a.reject(new Error('The client does not have any portfolio.'));
      }
      return _this.$store.dispatch('loadPortfolioDetails', portfolioIds[0]);
    }).then(function () {
      _this.hasPortfolio = true;
    }).finally(function () {
      _this.loading = false;
    }).catch(function () {
      _this.hasPortfolio = false;
    });

    promise_default.a.all([clientPromise, groupPromise]).finally(function () {});
  },

  props: ['id'],
  data: function data() {
    return {
      loading: false,
      tabIndex: null,
      hasPortfolio: null,
      copyVisible: false
    };
  },

  methods: {
    resetPass: function resetPass() {
      if (window.confirm('Are you sure you want to reset the password of ' + this.client.name + ' with Client ID: ' + this.client.clientId + '? If \'YES\', the user will receive an email with a link to set a new password.')) {
        services_userService.sendMailForNewPass(this.client.email);
      }
    },
    deactivate: function deactivate() {
      if (window.confirm('Are you sure you want to deactivate user ' + this.client.name + ' with Client ID: ' + this.client.id + '?')) {
        services_userService.deactivate(this.client.email);
      }
    },
    onCopy: function onCopy() {
      var _this2 = this;

      var assettable = document.getElementById('assets_table_fund');
      var toformat = assettable.querySelectorAll('.formatnum');
      toformat.forEach(function (element) {
        element.setAttribute('style', 'mso-number-format: \'0\\.00000000\'');
      });
      var el = document.createElement('textarea');
      document.body.appendChild(el);
      el.value = assettable.outerHTML.replace(new RegExp('&nbsp;', 'g'), '').replace(/,/g, '.');
      // el.setAttribute('readonly', '')
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.copyVisible = true;
      setTimeout(function () {
        _this2.copyVisible = false;
      }, 1000);
    }
  },
  computed: {
    clientId: function clientId() {
      return +this.id;
    },
    client: function client() {
      return this.$store.getters.getClient;
    },
    portfolioStats: function portfolioStats() {
      return this.$store.getters.getSPStats;
    },
    portfolioAssets: function portfolioAssets() {
      return this.$store.getters.getSPAssets;
    },
    updateTime: function updateTime() {
      return this.$store.getters.getUpdateTime;
    },
    groups: function groups() {
      return this.$store.getters.getGroups;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-680e555c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/ClientPage.vue
var ClientPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.client)?_c('client-table',{attrs:{"client":_vm.client,"groups":_vm.groups}}):_vm._e()],1),_vm._v(" "),(_vm.hasPortfolio)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card portfolio-card"},[_c('div',{staticClass:"card-header"},[_c('h2',[_vm._v("Portfolio #"+_vm._s(_vm.client.portfolios[0])+": "+_vm._s(_vm.portfolioStats ? _vm.portfolioStats.totalValueBGN : null)+" BGN")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('b-tabs',{model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{staticClass:"pt-5",attrs:{"title":"Overview","active":""}},[(_vm.portfolioAssets && _vm.portfolioAssets.length)?_c('div',{staticClass:"mb-5 clearfix"},[_c('pie-chart',{attrs:{"assets":_vm.portfolioAssets}}),_vm._v(" "),_c('assets-table',{attrs:{"coins":_vm.portfolioAssets}}),_vm._v(" "),_c('p',[_vm._v("* The prices are taken from "),_c('a',{attrs:{"href":"https://coingecko.com/"}},[_vm._v("https://coingecko.com/")]),_vm._v(" on "+_vm._s(_vm.updateTime)+" UTC.")]),_vm._v(" "),_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){_vm.onCopy(this)}}},[_vm._v("copy table")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.copyVisible),expression:"copyVisible"}],staticClass:"text-muted ml-2"},[_vm._v("copied!")])],1):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("Return on Investment (BGN)")]),_vm._v(" "),(_vm.portfolioStats)?_c('totals-table',{attrs:{"data":_vm.portfolioStats}}):_vm._e(),_vm._v(" "),(!_vm.portfolioStats)?_c('div',{staticClass:"alert text-center"},[_vm._v("No Data")]):_vm._e()],1),_vm._v(" "),_c('b-tab',{staticClass:"pt-5",attrs:{"title":"Transactions"}},[(_vm.tabIndex === 1)?_c('transactions-table',{attrs:{"portfolioId":_vm.client.portfolios[0]}}):_vm._e()],1),_vm._v(" "),_c('b-tab',{staticClass:"pt-5",attrs:{"title":"Tax Info"}},[(_vm.tabIndex === 2)?_c('taxinfo-table',{attrs:{"portfolioId":_vm.client.portfolios[0]}}):_vm._e()],1)],1)],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 mt-5"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){_vm.resetPass()}}},[_vm._v("Reset Password")])]),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)])}
var ClientPage_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row py-3"},[_c('div',{staticClass:"col-md-12"},[_c('h1',{staticClass:"text-center"},[_vm._v("Client details")])])])}]
var ClientPage_esExports = { render: ClientPage_render, staticRenderFns: ClientPage_staticRenderFns }
/* harmony default export */ var pages_ClientPage = (ClientPage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/ClientPage.vue
var ClientPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ClientPage___vue_template_functional__ = false
/* styles */
var ClientPage___vue_styles__ = null
/* scopeId */
var ClientPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ClientPage___vue_module_identifier__ = null
var ClientPage_Component = ClientPage_normalizeComponent(
  ClientPage,
  pages_ClientPage,
  ClientPage___vue_template_functional__,
  ClientPage___vue_styles__,
  ClientPage___vue_scopeId__,
  ClientPage___vue_module_identifier__
)

/* harmony default export */ var _service_app_pages_ClientPage = (ClientPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/tables/ClientsTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ClientsTable = ({
  props: ['clients']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4931d3e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/tables/ClientsTable.vue
var ClientsTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-bordered"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.clients),function(client,index){return _c('tr',[_c('td',[_vm._v(_vm._s(client.clientId))]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":'/clients/' + client.id}},[_vm._v(_vm._s(client.name))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(client.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(client.phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(client.contractId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(client.portfolios[0]))])])}))])}
var ClientsTable_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Client ID")]),_vm._v(" "),_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',[_vm._v("Phone")]),_vm._v(" "),_c('th',[_vm._v("Contract ID")]),_vm._v(" "),_c('th',[_vm._v("Portfolio ID")])])])}]
var ClientsTable_esExports = { render: ClientsTable_render, staticRenderFns: ClientsTable_staticRenderFns }
/* harmony default export */ var tables_ClientsTable = (ClientsTable_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/tables/ClientsTable.vue
var ClientsTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ClientsTable___vue_template_functional__ = false
/* styles */
var ClientsTable___vue_styles__ = null
/* scopeId */
var ClientsTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ClientsTable___vue_module_identifier__ = null
var ClientsTable_Component = ClientsTable_normalizeComponent(
  ClientsTable,
  tables_ClientsTable,
  ClientsTable___vue_template_functional__,
  ClientsTable___vue_styles__,
  ClientsTable___vue_scopeId__,
  ClientsTable___vue_module_identifier__
)

/* harmony default export */ var components_tables_ClientsTable = (ClientsTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/ClientsPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ClientsPage = ({
  components: {
    ClientsTable: components_tables_ClientsTable
  },
  created: function created() {
    var clients = this.$store.getters.getClients(this.currentPage);

    if (!clients.length) {
      this.loadClients(this.currentPage);
    }
  },
  data: function data() {
    return {
      loading: false,
      currentPage: 1,
      itemsPerPage: 20
    };
  },

  computed: {
    clients: function clients() {
      return this.$store.getters.getClients(this.currentPage);
    },
    total: function total() {
      return this.$store.getters.getClientsTotal;
    }
  },
  methods: {
    loadClients: function loadClients(page) {
      var _this = this;

      this.loading = true;
      this.$store.dispatch('getClients', { page: page, itemsPerPage: this.itemsPerPage }).finally(function () {
        _this.loading = false;
      });
    }
  },
  watch: {
    currentPage: function currentPage() {
      this.loadClients(this.currentPage);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48e34382","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/ClientsPage.vue
var ClientsPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"col-md-12 d-flex"},[_c('b-button',{attrs:{"variant":"success","to":"/clients/create"}},[_vm._v("Create client")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('clients-table',{attrs:{"clients":_vm.clients}}),_vm._v(" "),(_vm.total > _vm.itemsPerPage)?_c('b-pagination',{attrs:{"size":"md","total-rows":_vm.total,"per-page":_vm.itemsPerPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e(),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)])])}
var ClientsPage_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row py-3"},[_c('div',{staticClass:"col-md-12"},[_c('h1',{staticClass:"text-center"},[_vm._v("Clients")])])])}]
var ClientsPage_esExports = { render: ClientsPage_render, staticRenderFns: ClientsPage_staticRenderFns }
/* harmony default export */ var pages_ClientsPage = (ClientsPage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/ClientsPage.vue
var ClientsPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ClientsPage___vue_template_functional__ = false
/* styles */
var ClientsPage___vue_styles__ = null
/* scopeId */
var ClientsPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ClientsPage___vue_module_identifier__ = null
var ClientsPage_Component = ClientsPage_normalizeComponent(
  ClientsPage,
  pages_ClientsPage,
  ClientsPage___vue_template_functional__,
  ClientsPage___vue_styles__,
  ClientsPage___vue_scopeId__,
  ClientsPage___vue_module_identifier__
)

/* harmony default export */ var _service_app_pages_ClientsPage = (ClientsPage_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/validators/index.js
var validators = __webpack_require__("+cKO");
var validators_default = /*#__PURE__*/__webpack_require__.n(validators);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/forms/CreateClientForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CreateClientForm = ({
  props: ['groups'],
  validations: {
    formData: {
      firstName: {
        required: validators["required"]
      },
      lastName: {
        required: validators["required"]
      },
      email: {
        required: validators["required"],
        email: validators["email"]
      },
      phone: {
        required: validators["required"]
      },
      clientId: {
        required: validators["required"]
      },
      portfolioId: {
        required: validators["required"]
      },
      contractId: {
        required: validators["required"]
      }
    }
  },
  data: function data() {
    return {
      formData: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        clientId: null,
        portfolioId: null,
        contractId: null,
        cgroups: []
      },
      loading: false,
      errMsg: null
    };
  },

  methods: {
    submitHandler: function submitHandler() {
      var _this = this;

      if (!this.$v.formData.$invalid) {
        this.loading = true;
        this.$store.dispatch('createClient', this.formData).then(function () {
          _this.$emit('createSuccess');
        }).catch(function (errRes) {
          _this.errMsg = errRes.error;
        }).finally(function () {
          _this.loading = false;
        });
      }
    },
    toggleGroup: function toggleGroup() {
      this.$store.dispatch('updateGroups', {
        id: this.client.id,
        groups: this.groups
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eaaadf6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/forms/CreateClientForm.vue
var CreateClientForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();_vm.submitHandler($event)}}},[(_vm.errMsg)?_c('div',{staticClass:"alert alert-danger text-center"},[_vm._v("\n    "+_vm._s(_vm.errMsg)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("First name:")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.firstName),expression:"formData.firstName"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': !_vm.$v.formData.firstName.required && _vm.$v.formData.firstName.$dirty }],attrs:{"type":"text","placeholder":"First name"},domProps:{"value":(_vm.formData.firstName)},on:{"blur":function($event){_vm.$v.formData.firstName.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "firstName", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n        Please, enter client first name.\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Last name:")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.lastName),expression:"formData.lastName"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': !_vm.$v.formData.lastName.required && _vm.$v.formData.lastName.$dirty }],attrs:{"type":"text","placeholder":"Last name"},domProps:{"value":(_vm.formData.lastName)},on:{"blur":function($event){_vm.$v.formData.lastName.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "lastName", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n        Please, enter client last name.\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Email:")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.email),expression:"formData.email"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': (!_vm.$v.formData.email.required && _vm.$v.formData.email.$dirty) || !_vm.$v.formData.email.email }],attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.formData.email)},on:{"blur":function($event){_vm.$v.formData.email.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v(_vm._s(_vm.$v.formData.email.required ? 'Please, enter a valid email.' : 'Please, enter a client email.'))])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Phone:")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.phone),expression:"formData.phone"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': !_vm.$v.formData.phone.required && _vm.$v.formData.phone.$dirty }],attrs:{"type":"text","placeholder":"Phone"},domProps:{"value":(_vm.formData.phone)},on:{"blur":function($event){_vm.$v.formData.phone.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "phone", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please, enter a client phone.")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Client ID:")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.clientId),expression:"formData.clientId"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': !_vm.$v.formData.clientId.required && _vm.$v.formData.clientId.$dirty }],attrs:{"type":"text","placeholder":"Client ID"},domProps:{"value":(_vm.formData.clientId)},on:{"blur":function($event){_vm.$v.formData.clientId.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "clientId", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please, enter a client ID.")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Portfolio ID:")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.portfolioId),expression:"formData.portfolioId"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': !_vm.$v.formData.portfolioId.required && _vm.$v.formData.portfolioId.$dirty }],attrs:{"type":"text","placeholder":"Portfolio ID"},domProps:{"value":(_vm.formData.portfolioId)},on:{"blur":function($event){_vm.$v.formData.portfolioId.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "portfolioId", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please, enter an portfolio ID.")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Contract ID:")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.contractId),expression:"formData.contractId"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': !_vm.$v.formData.contractId.required && _vm.$v.formData.contractId.$dirty }],attrs:{"type":"text","placeholder":"Contract ID"},domProps:{"value":(_vm.formData.contractId)},on:{"blur":function($event){_vm.$v.formData.contractId.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "contractId", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please, enter an contract ID.")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Groups:")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('ul',_vm._l((_vm.groups),function(group){return _c('li',[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.cgroups),expression:"formData.cgroups"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"groupscheckbox","id":group.id},domProps:{"value":group.id,"checked":_vm._q(_vm.formData.cgroups,group.id)},on:{"change":function($event){_vm.$set(_vm.formData, "cgroups", group.id)}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":group.id}},[_vm._v(_vm._s(group.name))])])])}))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-block btn-success",attrs:{"type":"submit","disabled":_vm.$v.formData.$invalid}},[_vm._v("Create Client")]),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)}
var CreateClientForm_staticRenderFns = []
var CreateClientForm_esExports = { render: CreateClientForm_render, staticRenderFns: CreateClientForm_staticRenderFns }
/* harmony default export */ var forms_CreateClientForm = (CreateClientForm_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/forms/CreateClientForm.vue
var CreateClientForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateClientForm___vue_template_functional__ = false
/* styles */
var CreateClientForm___vue_styles__ = null
/* scopeId */
var CreateClientForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreateClientForm___vue_module_identifier__ = null
var CreateClientForm_Component = CreateClientForm_normalizeComponent(
  CreateClientForm,
  forms_CreateClientForm,
  CreateClientForm___vue_template_functional__,
  CreateClientForm___vue_styles__,
  CreateClientForm___vue_scopeId__,
  CreateClientForm___vue_module_identifier__
)

/* harmony default export */ var components_forms_CreateClientForm = (CreateClientForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/CreateClientPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CreateClientPage = ({
  components: {
    CreateClientForm: components_forms_CreateClientForm
  },
  created: function created() {
    var _this = this;

    this.loading = true;
    this.$store.dispatch('loadGroups').finally(function () {
      _this.loading = false;
    });
  },
  data: function data() {
    return {
      createMode: true,
      loading: false
    };
  },

  computed: {
    groups: function groups() {
      return this.$store.getters.getGroups;
    }
  },
  methods: {
    toggleMode: function toggleMode() {
      this.createMode = !this.createMode;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e81fc422","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/CreateClientPage.vue
var CreateClientPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-lg-8 col-xl-6 mx-auto pt-3"},[(_vm.createMode)?_c('div',[_c('create-client-form',{attrs:{"groups":_vm.groups},on:{"createSuccess":_vm.toggleMode}})],1):_c('div',{staticClass:"text-center"},[_c('h2',[_vm._v("The client was created successfully")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-success",attrs:{"type":"button"},on:{"click":_vm.toggleMode}},[_vm._v("Create new client")])]),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)])])}
var CreateClientPage_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row py-3"},[_c('div',{staticClass:"col-md-12"},[_c('h1',{staticClass:"text-center"},[_vm._v("Create client")])])])}]
var CreateClientPage_esExports = { render: CreateClientPage_render, staticRenderFns: CreateClientPage_staticRenderFns }
/* harmony default export */ var pages_CreateClientPage = (CreateClientPage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/CreateClientPage.vue
var CreateClientPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateClientPage___vue_template_functional__ = false
/* styles */
var CreateClientPage___vue_styles__ = null
/* scopeId */
var CreateClientPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreateClientPage___vue_module_identifier__ = null
var CreateClientPage_Component = CreateClientPage_normalizeComponent(
  CreateClientPage,
  pages_CreateClientPage,
  CreateClientPage___vue_template_functional__,
  CreateClientPage___vue_styles__,
  CreateClientPage___vue_scopeId__,
  CreateClientPage___vue_module_identifier__
)

/* harmony default export */ var _service_app_pages_CreateClientPage = (CreateClientPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/forms/CreateUserForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CreateUserForm = ({
  validations: {
    formData: {
      firstName: {
        required: validators["required"]
      },
      lastName: {
        required: validators["required"]
      },
      email: {
        required: validators["required"],
        email: validators["email"]
      }
    }
  },
  data: function data() {
    return {
      formData: {
        firstName: null,
        lastName: null,
        email: null
      },
      loading: false,
      errMsg: null
    };
  },

  methods: {
    submitHandler: function submitHandler() {
      var _this = this;

      if (!this.$v.formData.$invalid) {
        this.loading = true;
        this.$store.dispatch('createUser', this.formData).then(function () {
          _this.$emit('createSuccess');
        }).catch(function (err) {
          if (err.response.status === 400) {
            _this.errMsg = 'Email already exist';
          } else {
            _this.errMsg = 'OOPSS! Something goes wrong. Try again.';
          }
        }).finally(function () {
          _this.loading = false;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e9c360f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/forms/CreateUserForm.vue
var CreateUserForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();_vm.submitHandler($event)}}},[(_vm.errMsg)?_c('div',{staticClass:"alert alert-danger text-center"},[_vm._v("\n    "+_vm._s(_vm.errMsg)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("First name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.firstName),expression:"formData.firstName"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': !_vm.$v.formData.firstName.required && _vm.$v.formData.firstName.$dirty }],attrs:{"type":"text","placeholder":"First name"},domProps:{"value":(_vm.formData.firstName)},on:{"blur":function($event){_vm.$v.formData.firstName.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "firstName", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n        Please, enter user first name.\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Last name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.lastName),expression:"formData.lastName"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': !_vm.$v.formData.lastName.required && _vm.$v.formData.lastName.$dirty }],attrs:{"type":"text","placeholder":"Last name"},domProps:{"value":(_vm.formData.lastName)},on:{"blur":function($event){_vm.$v.formData.lastName.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "lastName", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n        Please, enter user last name.\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.email),expression:"formData.email"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': (!_vm.$v.formData.email.required && _vm.$v.formData.email.$dirty) || !_vm.$v.formData.email.email }],attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.formData.email)},on:{"blur":function($event){_vm.$v.formData.email.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.$v.formData.email.required ? 'Please, enter valid email' : 'Please, enter user email')+"\n      ")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-block btn-success",attrs:{"type":"submit","disabled":_vm.$v.formData.$invalid}},[_vm._v("Create User")]),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)}
var CreateUserForm_staticRenderFns = []
var CreateUserForm_esExports = { render: CreateUserForm_render, staticRenderFns: CreateUserForm_staticRenderFns }
/* harmony default export */ var forms_CreateUserForm = (CreateUserForm_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/forms/CreateUserForm.vue
var CreateUserForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateUserForm___vue_template_functional__ = false
/* styles */
var CreateUserForm___vue_styles__ = null
/* scopeId */
var CreateUserForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreateUserForm___vue_module_identifier__ = null
var CreateUserForm_Component = CreateUserForm_normalizeComponent(
  CreateUserForm,
  forms_CreateUserForm,
  CreateUserForm___vue_template_functional__,
  CreateUserForm___vue_styles__,
  CreateUserForm___vue_scopeId__,
  CreateUserForm___vue_module_identifier__
)

/* harmony default export */ var components_forms_CreateUserForm = (CreateUserForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/CreateUserPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CreateUserPage = ({
  components: {
    CreateUserForm: components_forms_CreateUserForm
  },
  data: function data() {
    return {
      createMode: true
    };
  },

  methods: {
    toggleMode: function toggleMode() {
      this.createMode = !this.createMode;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e122b5d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/CreateUserPage.vue
var CreateUserPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-lg-8 col-xl-6 mx-auto pt-3"},[(_vm.createMode)?_c('div',[_c('h1',{staticClass:"text-center pb-3"},[_vm._v("Create user")]),_vm._v(" "),_c('create-user-form',{on:{"createSuccess":_vm.toggleMode}})],1):_c('div',{staticClass:" text-center"},[_c('h2',[_vm._v("Success")]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-success",attrs:{"type":"button"},on:{"click":_vm.toggleMode}},[_vm._v("Add user")])])])])])}
var CreateUserPage_staticRenderFns = []
var CreateUserPage_esExports = { render: CreateUserPage_render, staticRenderFns: CreateUserPage_staticRenderFns }
/* harmony default export */ var pages_CreateUserPage = (CreateUserPage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/CreateUserPage.vue
var CreateUserPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateUserPage___vue_template_functional__ = false
/* styles */
var CreateUserPage___vue_styles__ = null
/* scopeId */
var CreateUserPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreateUserPage___vue_module_identifier__ = null
var CreateUserPage_Component = CreateUserPage_normalizeComponent(
  CreateUserPage,
  pages_CreateUserPage,
  CreateUserPage___vue_template_functional__,
  CreateUserPage___vue_styles__,
  CreateUserPage___vue_scopeId__,
  CreateUserPage___vue_module_identifier__
)

/* harmony default export */ var _service_app_pages_CreateUserPage = (CreateUserPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/FundPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var FundPage = ({
  components: {
    PieChart: components_charts_AssetsPieChart,
    AssetsTable: components_tables_AssetsTable,
    TotalsTable: components_tables_PortfolioTotalsTable
  },
  created: function created() {
    var _this = this;

    this.loading = true;
    this.$store.dispatch('loadTotalPortfolios').finally(function () {
      _this.loading = false;
    });
  },
  data: function data() {
    return {
      loading: false,
      copyVisible: false
    };
  },

  methods: {
    onCopy: function onCopy() {
      var _this2 = this;

      var assettable = document.getElementById('assets_table_fund');
      var toformat = assettable.querySelectorAll('.formatnum');
      toformat.forEach(function (element) {
        element.setAttribute('style', 'mso-number-format: \'0\\.00000000\'');
      });
      var el = document.createElement('textarea');
      document.body.appendChild(el);
      el.value = assettable.outerHTML.replace(new RegExp('&nbsp;', 'g'), '').replace(/,/g, '.');
      // el.setAttribute('readonly', '')
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.copyVisible = true;
      setTimeout(function () {
        _this2.copyVisible = false;
      }, 1000);
    }
  },
  computed: {
    stats: function stats() {
      return this.$store.getters.getTPStats;
    },
    assets: function assets() {
      return this.$store.getters.getTPAssets;
    },
    totalValueBGN: function totalValueBGN() {
      return this.stats ? this.stats.totalValueBGN : 0;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5768032e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/FundPage.vue
var FundPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"fund-page"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7 mx-auto"},[_c('h1',{staticClass:"text-center mt-3"},[_vm._v("Total Value: "+_vm._s(_vm.totalValueBGN)+" BGN")]),_vm._v(" "),(_vm.assets)?_c('div',{staticClass:"mb-4 clearfix"},[_c('pie-chart',{attrs:{"assets":_vm.assets}}),_vm._v(" "),_c('assets-table',{attrs:{"coins":_vm.assets}}),_vm._v(" "),_c('b-btn',{staticClass:"float-left",attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){_vm.onCopy(this)}}},[_vm._v("copy table")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.copyVisible),expression:"copyVisible"}],staticClass:"text-muted ml-2"},[_vm._v("copied!")])],1):_vm._e(),_vm._v(" "),(!_vm.assets && !_vm.loading)?_c('div',{staticClass:"alert alert-danger text-center"},[_vm._v("No Chart Data")]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"mt-5"},[_vm._v("Return on Investment (BGN)")]),_vm._v(" "),(_vm.stats)?_c('totals-table',{attrs:{"data":_vm.stats}}):_vm._e(),_vm._v(" "),(!_vm.stats && !_vm.loading)?_c('div',{staticClass:"alert alert-danger text-center"},[_vm._v("No ROI Data")]):_vm._e()],1),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)])}
var FundPage_staticRenderFns = []
var FundPage_esExports = { render: FundPage_render, staticRenderFns: FundPage_staticRenderFns }
/* harmony default export */ var pages_FundPage = (FundPage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/FundPage.vue
var FundPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FundPage___vue_template_functional__ = false
/* styles */
var FundPage___vue_styles__ = null
/* scopeId */
var FundPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FundPage___vue_module_identifier__ = null
var FundPage_Component = FundPage_normalizeComponent(
  FundPage,
  pages_FundPage,
  FundPage___vue_template_functional__,
  FundPage___vue_styles__,
  FundPage___vue_scopeId__,
  FundPage___vue_module_identifier__
)

/* harmony default export */ var _service_app_pages_FundPage = (FundPage_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/vuejs-datepicker.esm.js
var vuejs_datepicker_esm = __webpack_require__("IC97");

// EXTERNAL MODULE: ./node_modules/vue-multiselect/dist/vue-multiselect.min.js
var vue_multiselect_min = __webpack_require__("RUzx");
var vue_multiselect_min_default = /*#__PURE__*/__webpack_require__.n(vue_multiselect_min);

// CONCATENATED MODULE: ./src/-service-app/services/uploadService.js



var uploadService_API_V1_URL = "https://updateapi.blockchain.bg/v1";

/* harmony default export */ var uploadService = ({
  uploadCSV: function uploadCSV(csv) {
    return axios_default.a.post(uploadService_API_V1_URL + '/tx/bulk', csv).then(function (res) {
      return res.data;
    });
  },
  getRecentUploadsSummary: function getRecentUploadsSummary() {
    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

    return axios_default.a.get(uploadService_API_V1_URL + '/operations?offset=' + offset + '&limit=' + limit).then(function (res) {
      return res.data.map(apiToUpload);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/forms/RebalanceForm.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var RebalanceForm_API_V1_URL = "https://updateapi.blockchain.bg/v1";
/* Decimal.set({ rounding: 5 }) */
decimal_default.a.set({ toExpNeg: -14 });

/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* harmony default export */ var RebalanceForm = ({
  components: {
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    Multiselect: vue_multiselect_min_default.a
  },
  data: function data() {
    return {
      loading: false,
      canSubmit: false,
      transactionId: '',
      date: '',
      // Objects to keep in memory
      assets: {},
      clients: {},
      currencies: {},
      // Select value
      baseAsset: null,
      baseAssets: [],
      portfolios: {},
      pricesSelect: null,
      pricesSelectArr: [],
      clientsSelect: null,
      clientsSelectArr: [],
      checkedRoles: [],
      // Table values
      tableValues: [{
        isSelected: false,
        checkLTE: false,
        baseAsset: '',
        before: 0,
        ccy1: 0,
        ccy2: 0,
        exchangeFee: 0,
        fx: 0,
        blockchainFee: 0,
        after: 0,
        coldStorage: 0,
        csCheck: '',
        check: '',
        checkneg: false
      }],
      checkbaseasseteq: true,
      remark: '',
      computedClients: [],
      csvBreakpoints: null
    };
  },

  computed: {
    checkedCount: function checkedCount() {
      if (this.clientsSelect) {
        return this.clientsSelect.length;
      } else {
        return 0;
      }
    },
    selectall: function selectall() {
      if (this.clientsSelect && this.clientsSelect.length !== 0) {
        return 'clear all';
      } else {
        return 'select all';
      }
    },
    getClients: function getClients() {
      var _this = this;

      if (!this.checkValues()) {
        return [];
      }
      /**
       * Calculate everything with a cloned object in order to not get render loops!
       */
      if (this.clientsSelect && this.clientsSelect.length) {
        var funds = this.tableValues;
        // Clone of the selected clients
        this.computedClients = JSON.parse(stringify_default()(this.clientsSelect));
        var allClientsCCY2 = new decimal_default.a(0);
        var allClientsAssetsSums = [];
        // Total assets in base currency
        var totalBase = new decimal_default.a(0);
        // Total assets in base currency plus fees
        var totalBasePlusFee = new decimal_default.a(0);
        // Array total assets in base per customer
        var totalBaseArr = [];
        // Array total assets in base per customer incl fees
        var totalBasePlusFeeArr = [];
        // Total amount not included in percentage calculations
        var totalInBaseExcluded = new decimal_default.a(0);
        // Flag for any customers without an asset if not all of the asset is sold
        var notallsold = 0;
        // Flag for any customers without an asset which is being bought
        var newbought = 0;
        // Number of assets which must not be included in percentage calculations
        var notcounted = new decimal_default.a(0);
        /**
         Find out what the FX per asset is
         */
        JSON.parse(stringify_default()(this.pricesSelect)).forEach(function (prices, i) {
          // Calculate the final fx for this assets
          // We do it here cause we need it for the new total quantity in base asset
          if (funds[i + 1].ccy1 !== 0) {
            if (_this.tableValues[i + 1].exchangeFeeValue !== _this.tableValues[0].baseAsset) {
              funds[i + 1].fx = parseFloat(funds[i + 1].ccy2) ? new decimal_default.a(funds[i + 1].ccy2).abs().div(parseFloat(new decimal_default.a(funds[i + 1].ccy1).plus(parseFloat(funds[i + 1].exchangeFee)).abs())) : 1;
            } else {
              funds[i + 1].fx = parseFloat(funds[i + 1].ccy2) ? new decimal_default.a(funds[i + 1].ccy2).plus(parseFloat(funds[i + 1].exchangeFee)).div(parseFloat(new decimal_default.a(funds[i + 1].ccy1))).abs() : 1;
            }
          }
        });

        /**
         * Iterate through the selected customers
         * for the first row of the base asset
         */
        this.computedClients.forEach(function (el, index) {
          var totalInBase = new decimal_default.a(0);
          var totalInBasePlusFee = new decimal_default.a(0);
          var client = el.details;
          if (!client.assets[_this.baseAsset.ticker]) {
            client.assets[_this.baseAsset.ticker] = { pieces: 0 };
          }

          // Find the BEFORE values for the base asset
          client.baseAssetPieces = new decimal_default.a(client.assets[_this.baseAsset.ticker].pieces);
          // Iterate through each selected asset (ccy2s)
          // in order to find the total new base asset quantity and prepare for share calculations later
          JSON.parse(stringify_default()(_this.pricesSelect)).forEach(function (prices, i) {
            // If the client doesn't have the currency but it's completely sold
            // this currency should not be counted to the distribution of fees
            if (!client.assets[prices.symbol]) {
              if (parseFloat(funds[i + 1].after) === 0) {
                notcounted = notcounted.plus(1);
              } else {
                if (funds[i + 1].ccy1 < 0) {
                  notallsold = 1;
                } else {
                  newbought = 1;
                }
              }
            }
            // if the client doesn't have this currency
            if (!client.assets[prices.symbol]) {
              client.assets[prices.symbol] = { pieces: 0 };
            } else {
              // Before value of the current asset if there is one
              client.pricesPieces[i] = client.assets[prices.symbol] ? new decimal_default.a(client.assets[prices.symbol].pieces) : new decimal_default.a(0);
              var weight = new decimal_default.a(client.pricesPieces[i]).div(funds[i + 1].before);
              var bfee = new decimal_default.a(funds[i + 1].blockchainFee).mul(weight);
              // Sum up the new base asset quantity
              // Multiply the asset by the fx to find the new base asset quantity
              totalInBasePlusFee = totalInBasePlusFee.plus(new decimal_default.a(client.pricesPieces[i]).plus(bfee).times(funds[i + 1].fx));
              totalInBase = totalInBase.plus(new decimal_default.a(client.pricesPieces[i]).times(funds[i + 1].fx));
            }
          });
          // Array of all base asset quantities per customer
          totalBaseArr[index] = totalInBase.plus(client.assets[_this.baseAsset.ticker].pieces);
          totalBasePlusFeeArr[index] = totalInBasePlusFee.plus(client.assets[_this.baseAsset.ticker].pieces);
          client.baseAssetEqual = totalBaseArr[index];
          // Total new base asset quantity
          totalBase = totalBase.plus(totalInBase).plus(client.assets[_this.baseAsset.ticker].pieces);
          totalBasePlusFee = totalBasePlusFee.plus(totalInBasePlusFee).plus(client.assets[_this.baseAsset.ticker].pieces);
          // Total in base excluded from calculations
          if (parseFloat(notcounted) === parseFloat(_this.pricesSelect.length) && parseFloat(client.baseAssetPieces) === parseFloat(totalBaseArr[index])) {
            totalInBaseExcluded = totalInBaseExcluded.plus(totalBaseArr[index]);
          }
        });
        /**
         * Iterate through the selected customers
         * the code before the assets loop is only for the first row
         */
        // calculate afters based on sums of ccy2s - custom case
        var calcaftersumccy2 = false;
        this.computedClients.forEach(function (el, index) {
          var client = el.details;
          var sumofprod = new decimal_default.a(0);
          // Find the BEFORE values for the base asset
          client.baseAssetPieces = new decimal_default.a(client.assets[_this.baseAsset.ticker].pieces);
          // Client percentage based on base asset
          client.percentage = parseFloat(totalBaseArr[index]) ? totalBaseArr[index].div(totalBase) : new decimal_default.a(1);
          // Find out what percentage of the total currency position does the client have
          // so that we can calculate the resulting blockchain fee and after of the base asset
          if (parseFloat(client.baseAssetPieces) !== parseFloat(totalBaseArr[index])) {
            var assetpercentage = totalBasePlusFeeArr[index].div(totalBasePlusFee.minus(totalInBaseExcluded));
            // console.log(parseFloat(totalBasePlusFeeArr[index]) + ' ' + parseFloat(totalBasePlusFee))
            // console.log('notcounted ' + parseFloat(notcounted) + ' totalInBaseExcluded ' + parseFloat(totalInBaseExcluded) + ' newbought ' + parseFloat(newbought) + ' notallsold ' + parseFloat(notallsold) + ' ')
            // some customer doesn't have an asset and it's completely sold
            // TODO: calculate the after by summing up before with ccy2 ? maybe
            if (parseFloat(totalInBaseExcluded) !== 0) {
              // This is the asset-based percentage including fees when everything is sold
              client.blockchainFee = new decimal_default.a(funds[0].blockchainFee || 0).times(assetpercentage);
              client.after = new decimal_default.a(funds[0].after || 0).minus(totalInBaseExcluded).times(assetpercentage);
              // no currency is being excluded
            } else {
              // TODO: here should thing about an extension - the three currencies
              if (parseFloat(notallsold) !== 0) {
                client.blockchainFee = new decimal_default.a(funds[0].blockchainFee || 0).times(client.percentage);
                calcaftersumccy2 = true;
                // client.after = (new Decimal(funds[0].after || 0)).times(client.percentage)
              } else {
                // extremely custom case where one asset is completely sold and one asset is being newly bought
                if (parseFloat(newbought) !== 0) {
                  client.blockchainFee = new decimal_default.a(funds[0].blockchainFee || 0).times(client.percentage);
                  calcaftersumccy2 = true;
                  // client.after = (new Decimal(funds[0].after || 0)).times(client.percentage)
                } else {
                  // usual case - currencies being bought
                  // check if there is an excluded position in any client
                  if (parseFloat(notcounted) === 0) {
                    client.blockchainFee = new decimal_default.a(funds[0].blockchainFee || 0).times(client.percentage);
                    client.after = new decimal_default.a(funds[0].after || 0).times(client.percentage);
                  } else {
                    client.blockchainFee = new decimal_default.a(funds[0].blockchainFee || 0).times(client.percentage);
                    calcaftersumccy2 = true;
                    // client.after = (new Decimal(funds[0].after || 0)).times(assetpercentage)
                  }
                }
              }
            }
          } else {
            if (parseFloat(notallsold) !== 0) {
              client.blockchainFee = new decimal_default.a(funds[0].blockchainFee || 0).times(client.percentage);
              client.after = new decimal_default.a(funds[0].after || 0).times(client.percentage);
            } else {
              // extremely custom case where one asset is completely sold and one asset is being newly bought
              if (parseFloat(newbought) !== 0) {
                client.blockchainFee = new decimal_default.a(funds[0].blockchainFee || 0).times(client.percentage);
                calcaftersumccy2 = true;
                // client.after = (new Decimal(funds[0].after || 0)).times(client.percentage)
              } else {
                client.blockchainFee = new decimal_default.a(0);
                client.after = totalBaseArr[index];
              }
            }
          }

          // count CCY2 for the check => BEFORE + BFee ( + all clients' CCY2)
          allClientsCCY2 = allClientsCCY2.plus(parseFloat(client.baseAssetPieces)).plus(parseFloat(client.blockchainFee));
          /**
           * LOOP THROUGH ASSETS to generate the next rows
           */
          JSON.parse(stringify_default()(_this.pricesSelect)).forEach(function (prices, i) {
            // BEFORE
            client.pricesPieces[i] = client.assets[prices.symbol] ? new decimal_default.a(client.assets[prices.symbol].pieces) : new decimal_default.a(0);
            // AFTER = FUND[AFTER] * PERCENTAGE
            client.afters[i] = new decimal_default.a(funds[i + 1].after || 0).times(parseFloat(client.percentage));

            // if client has SOME of that currency
            if (parseFloat(client.pricesPieces[i]) !== 0) {
              var _assetpercentage = client.pricesPieces[i].div(funds[i + 1].before);
              // and it is being sold
              if (funds[i + 1].ccy1 < 0) {
                // if not completely - those who have none of it will get some of it
                if (parseFloat(notallsold) === 1) {
                  if (parseFloat(funds[i + 1].after) !== 0) {
                    client.blockchainFees[i] = new decimal_default.a(funds[i + 1].blockchainFee || 0).times(parseFloat(client.percentage));
                  } else {
                    client.blockchainFees[i] = new decimal_default.a(funds[i + 1].blockchainFee || 0).times(parseFloat(_assetpercentage));
                  }
                  // if completely
                } else {
                  // if there is a customer who is not going to be counted
                  if (parseFloat(notcounted) !== 0) {
                    client.blockchainFees[i] = new decimal_default.a(funds[i + 1].blockchainFee || 0).times(parseFloat(_assetpercentage));
                    // standard case
                  } else {
                    client.blockchainFees[i] = new decimal_default.a(funds[i + 1].blockchainFee || 0).times(parseFloat(client.percentage));
                  }
                }
                // if currency is bought
              } else {
                client.blockchainFees[i] = new decimal_default.a(funds[i + 1].blockchainFee || 0).times(parseFloat(client.percentage));
              }
              // if client has NONE of that currency
            } else {
              // if it's being sold
              if (funds[i + 1].ccy1 < 0) {
                // if not completely - those who have none of it will get some of it
                if (parseFloat(notallsold) === 1 && parseFloat(funds[i + 1].after) !== 0) {
                  client.blockchainFees[i] = new decimal_default.a(funds[i + 1].blockchainFee || 0).times(parseFloat(client.percentage));
                  // if completely - there should be no fee
                } else {
                  client.blockchainFees[i] = new decimal_default.a(0);
                }
                // if currency is bought
              } else {
                client.blockchainFees[i] = new decimal_default.a(funds[i + 1].blockchainFee || 0).times(parseFloat(client.percentage));
              }
            }
            // CCY1 = AFTER - BEFORE + BFee
            client.ccy1Arr[i] = client.afters[i].minus(client.pricesPieces[i]).minus(client.blockchainFees[i]);
            // CCY2 = FUND[FX] * -CCY1
            client.ccy2Arr[i] = new decimal_default.a(parseFloat(funds[i + 1].fx)).times(parseFloat(client.ccy1Arr[i] || 0)).times(-1);
            // FX = CCY2 / CCY1
            client.fxArr[i] = Math.abs(parseFloat(parseFloat(client.ccy2Arr[i]) ? client.ccy2Arr[i].div(parseFloat(client.ccy1Arr[i])) : new decimal_default.a(0)));
            // Add + all clients' CCY2 to the check
            allClientsCCY2 = allClientsCCY2.plus(parseFloat(client.ccy2Arr[i]));
            // FUND CHECK (summed for all clients) = BEFORE + CCY1 + BFee
            allClientsAssetsSums[i] = client.pricesPieces[i].plus(parseFloat(client.ccy1Arr[i])).plus(parseFloat(client.blockchainFees[i])).plus(parseFloat(allClientsAssetsSums[i] || 0));
            // After === CCY1 + B fee + Before
            client.afterCheck = client.afters[i].toDP(8).eq(client.ccy1Arr[i].plus(client.blockchainFees[i]).plus(client.pricesPieces[i]).toDP(8));
            // Add to summ of products
            sumofprod = sumofprod.plus(client.afters[i].times(client.fxArr[i]).minus(client.blockchainFees[i].times(client.fxArr[i])));
          });

          // CHECK CCY2 IN THE FIRST ROW OF A CLIENT'S TABLE
          var ccy2 = new decimal_default.a(0);
          client.ccy2Arr.forEach(function (el) {
            ccy2 = ccy2.plus(parseFloat(el));
          });
          if (client.ccy2Arr.length) {
            if (calcaftersumccy2) {
              client.after = new decimal_default.a(client.baseAssetPieces.plus(parseFloat(client.blockchainFee)).plus(ccy2));
            }
            client.ccy2 = new decimal_default.a(client.baseAssetPieces.plus(parseFloat(client.blockchainFee)).plus(ccy2)).toDP(8).eq(client.after.toDP(8));
          }
          sumofprod = sumofprod.plus(client.after.minus(client.blockchainFee));
          // console.log(parseFloat(sumofprod) + ' ' + parseFloat(client.baseAssetEqual))
          if (sumofprod.toDP(12).eq(parseFloat(client.baseAssetEqual.toDP(12)))) {
            client.baseAssetCheck = true;
          }
        });
        // CHECK FUNDS[0].Before + FUNDS[1+].CCY2 <= FUNDS[0].Before
        funds[0].checkLTE = new decimal_default.a(funds[0].before).plus(funds[0].blockchainFee).lte(Math.abs(funds[0].ccy1));
        // CHECK FUNDS[0].AFTER === CLIENTS[CCY2]
        funds[0].check = allClientsCCY2.toDP(8).eq(parseFloat(new decimal_default.a(funds[0].after).toDP(8)));
        // CHECK FUNDS[1+].AFTER === allClientsAssetsSums
        JSON.parse(stringify_default()(this.pricesSelect)).forEach(function (prices, i) {
          funds[i + 1].check = allClientsAssetsSums[i].toDP(8).eq(parseFloat(new decimal_default.a(funds[i + 1].after).toDP(8)));
        });
        // Find out if there is a customer with faild baseAssetCheck
        if (this.computedClients.find(function (fruit) {
          return fruit.details.baseAssetCheck === false;
        })) {
          this.checkbaseasseteq = false;
        } else {
          this.checkbaseasseteq = true;
        }

        // this.checkbaseasseteq = this.computedClients.find((id) => {
        // })

        this.canSubmit = true;
        return this.computedClients;
      }
    },
    getPrices: function getPrices() {
      return JSON.parse(stringify_default()(this.pricesSelect));
    },
    getCsvTable: function getCsvTable() {
      if (!this.checkValues()) {
        return [];
      }
      /**
       * Calculate everything with a cloned object in order to not get render loops!
       */
      var csv = null;
      if (this.clientsSelect && this.clientsSelect.length) {
        csv = this.generateCSV(true);
        this.csvBreakpoints = [];
        for (var i = 1; i < csv.length; i++) {
          this.csvBreakpoints[i] = csv[i][1] !== csv[i - 1][1];
        }
      } else {
        this.canSubmit = false;
      }
      return csv;
    }
  },
  created: function created() {
    var _this2 = this;

    // this.loadRecentUploads()
    // axios.get(API_V1_URL + '/portfolio/0/tx')
    //   .then((res) => {
    //     console.log(res)
    //   })
    /**
     * Start loading
     */
    this.loading = true;
    this.$store.dispatch('loadTotalPortfolios')
    /**
     * Load Portfolios
     */
    .then(function (data) {
      var assets = _this2.$store.getters.getTPAssets;
      assets.forEach(function (el) {
        el.format = el.name + ' - ' + _this2.customFixed(el.pieces);
        _this2.currencies[el.name] = el;
      });
      _this2.baseAssets = assets;
    })
    /**
     * Load Prices
     */
    .then(function () {
      axios_default.a.get(RebalanceForm_API_V1_URL + '/prices/?limit=4000&offset=0').then(function (res) {
        var prices = [];
        var fullPrices = [];
        res.data.forEach(function (el) {
          if (_this2.currencies[el.name]) {
            el.format = el.id + ' [' + el.symbol + ']' + ' - ' + _this2.customFixed(_this2.currencies[el.name].pieces);
            fullPrices.push(el);
          } else {
            el.format = el.id + ' [' + el.symbol + ']';
            prices.push(el);
          }
        });
        _this2.pricesSelectArr = fullPrices.concat(prices);
      });
    })
    /**
     * Load Clients
     */
    .then(function () {
      axios_default.a.get(RebalanceForm_API_V1_URL + '/users?role=client&offset=0&limit=1000').then(function (res) {
        res.data.forEach(function (el) {
          el.fullName = el.firstName + ' ' + el.lastName + ' [' + el.clientId + ']';
          el.details = {
            assets: {},
            after: 0,
            baseAssetPieces: 0,
            baseAssetEqual: 0,
            baseAssetCheck: false,
            pricesPieces: [],
            percentage: 0,
            blockchainFees: [],
            afters: [],
            ccy1Arr: [],
            ccy2Arr: [],
            fxArr: []
          };
          _this2.clients[el.id] = el;
        });
      })
      /**
       * Load Portfolio data
       */
      .then(function () {
        var _ref;

        var requests = keys_default()(_this2.clients).map(function (id) {
          var ids = [];
          _this2.clients[id].portfolios.forEach(function (portfolio) {
            ids.push(axios_default.a.get(RebalanceForm_API_V1_URL + '/portfolio/' + portfolio.id + '/data/noroi'));
          });
          return ids;
        });
        // Search in all assets
        var reqs = (_ref = []).concat.apply(_ref, toConsumableArray_default()(requests));
        axios_default.a.all(reqs).then(function (responses) {
          _this2.portfolios = responses;
        })
        /**
         * Stop loading
         */
        .finally(function () {
          _this2.loading = false;
        });
      });
    });
  },

  methods: {
    /**
     * Select all clients link
     */
    checkAll: function checkAll() {
      var _this3 = this;

      if (this.selectall !== 'clear all') {
        this.clientsSelect = [];
        this.clientsSelectArr.forEach(function (el) {
          _this3.onSelectClient(el);
          _this3.clientsSelect.push(el);
        });
      } else {
        this.clientsSelect.forEach(function (el) {
          _this3.onRemoveClient(el);
        });
        this.clientsSelect = [];
      }
    },
    copyToClipboard: function copyToClipboard(elementId) {
      var temp = document.createElement('input');
      var text = elementId;
      temp.setAttribute('value', text);
      document.body.appendChild(temp);
      temp.select();
      document.execCommand('copy');
      document.body.removeChild(temp);
    },

    /**
     * Reset some values in order to not have bugs
     */
    onSelectBaseAsset: function onSelectBaseAsset(value) {
      var _this4 = this;

      // Prepare table
      this.tableValues[0].isSelected = false;
      this.tableValues[0].baseAsset = this.currencies[value.name].ticker;
      // Make sure the user can't select the same prices
      var found = this.pricesSelectArr.find(function (el) {
        return el['$isDisabled'] === true;
      });
      if (found) {
        found['$isDisabled'] = false;
      }
      var found2 = this.pricesSelectArr.find(function (el) {
        return value.ticker === el.symbol;
      });
      if (found2) {
        found2['$isDisabled'] = true;
      }
      // Reset values
      if (this.clientsSelect && this.clientsSelect.length) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(this.tableValues), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var values = _step.value;

            values.before = 0;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.clientsSelect.forEach(function (el) {
          _this4.onSelectClient(el);
        });
      }
      if (this.pricesSelect) {
        this.tableValues.forEach(function (el, i) {
          if (i) {
            el.price = 0;
          }
        });
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = get_iterator_default()(entries_default()(this.pricesSelect)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _ref2 = _step2.value;

            var _ref3 = slicedToArray_default()(_ref2, 2);

            var key = _ref3[0];
            var price = _ref3[1];

            if (key !== this.tableValues[0].symbol) {
              this.onSelectPrice(price, 0, true);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      this.generateReqs(value);
    },

    /**
     * Load Clients who have the currency in their assets
     */
    generateReqs: function generateReqs(value) {
      var _this5 = this;

      var clients = [];
      var pricesSelect = this.pricesSelect ? this.pricesSelect.slice() : [];
      this.portfolios.forEach(function (res) {
        _this5.assets[res.data.userId] = res.data.assets;

        var _loop = function _loop(asset) {
          if (asset.name === value.name || pricesSelect.findIndex(function (el) {
            return el.name === asset.name;
          }) !== -1) {
            var client = _this5.clients[res.data.userId];
            if (clients.findIndex(function (el) {
              return el === client;
            }) === -1) {
              var hasNoMoney = _this5.assets[res.data.userId].every(function (el) {
                return _this5.customFixed(el.pieces, 8) < 0.000001;
              });
              if (!hasNoMoney) {
                clients.push(client);
              }
            }
          }
        };

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = get_iterator_default()(res.data.assets), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var asset = _step3.value;

            _loop(asset);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      });
      clients.sort(function (a, b) {
        return a.fullName.localeCompare(b.fullName);
      });
      this.clientsSelectArr = clients;
      this.loading = false;
      // Show the table
      this.tableValues[0].isSelected = true;
    },

    /**
     * Client select methods
     */
    onSelectClient: function onSelectClient(value) {
      var _this6 = this;

      var _loop2 = function _loop2(portfolio) {
        _this6.tableValues.forEach(function (el) {
          if (portfolio.ticker === el.baseAsset) {
            el.before = parseFloat(new decimal_default.a(portfolio.pieces).plus(el.before));
            value.details['assets'][el.baseAsset] = portfolio;
          }
        });
      };

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(this.assets[value.id]), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var portfolio = _step4.value;

          _loop2(portfolio);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.onInput();
    },
    onRemoveClient: function onRemoveClient(value) {
      var _this7 = this;

      var _loop3 = function _loop3(portfolio) {
        _this7.tableValues.forEach(function (el) {
          if (portfolio.ticker === el.baseAsset) {
            el.before = parseFloat(new decimal_default.a(el.before).minus(portfolio.pieces));
            delete value.details['assets'][el.baseAsset];
          }
        });
      };

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(this.assets[value.id]), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var portfolio = _step5.value;

          _loop3(portfolio);
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.onInput();
    },

    /**
     * Price select methods
     */
    onSelectPrice: function onSelectPrice(value, id, hasBaseAssetChanged) {
      var _this8 = this;

      // Make sure the user can't select the same assets
      keys_default()(this.currencies).forEach(function (key) {
        if (value.symbol === _this8.currencies[key].ticker) {
          _this8.currencies[key]['$isDisabled'] = !_this8.currencies[key]['$isDisabled'];
        }
      });
      var options = [value.symbol, this.tableValues[0].baseAsset];
      // Create new row
      if (!hasBaseAssetChanged) {
        this.tableValues.push({
          baseAsset: value.symbol,
          before: 0,
          ccy1: 0,
          ccy2: 0,
          exchangeFee: 0,
          fx: 0,
          blockchainFee: 0,
          after: 0,
          coldStorage: 0,
          csCheck: '',
          check: '',
          exchangeFeeValue: options[0],
          exchangeFeeOptions: options
        });
      }
      /**
       * Calculate "before" field for each client
       */
      if (this.clientsSelect) {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = get_iterator_default()(entries_default()(this.clientsSelect)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var _ref4 = _step6.value;

            var _ref5 = slicedToArray_default()(_ref4, 2);

            var client = _ref5[1];
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
              for (var _iterator7 = get_iterator_default()(client.portfolios), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var portfolio = _step7.value;

                var found = this.assets[portfolio.userId].find(function (el) {
                  return el.ticker === value.symbol;
                });
                if (found) {
                  var _iteratorNormalCompletion8 = true;
                  var _didIteratorError8 = false;
                  var _iteratorError8 = undefined;

                  try {
                    for (var _iterator8 = get_iterator_default()(this.tableValues), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                      var row = _step8.value;

                      if (row.baseAsset === value.symbol) {
                        row.before = parseFloat(new decimal_default.a(found.pieces).plus(row.before));
                        client.details['assets'][value.symbol] = found;
                      }
                    }
                  } catch (err) {
                    _didIteratorError8 = true;
                    _iteratorError8 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion8 && _iterator8.return) {
                        _iterator8.return();
                      }
                    } finally {
                      if (_didIteratorError8) {
                        throw _iteratorError8;
                      }
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError7 = true;
              _iteratorError7 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                  _iterator7.return();
                }
              } finally {
                if (_didIteratorError7) {
                  throw _iteratorError7;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      }
      this.generateReqs(this.baseAsset);
    },
    onRemovePrice: function onRemovePrice(value) {
      var _this9 = this;

      // Make sure the user can't select the same assets
      keys_default()(this.currencies).forEach(function (key) {
        if (value.symbol === _this9.currencies[key].ticker) {
          _this9.currencies[key]['$isDisabled'] = !_this9.currencies[key]['$isDisabled'];
        }
      });
      // Remove row from fund table
      this.tableValues.splice(this.tableValues.findIndex(function (val) {
        return val.baseAsset === value.symbol;
      }), 1);
      this.generateReqs(this.baseAsset);
      this.onInput();
    },

    /**
     * Calculations
     */
    onInput: function onInput(e) {
      var _this10 = this;

      if (e && e.target) {
        if (!RegExp('^-?[0-9]+([\\.][0-9]+)?$').test(e.target.value)) {
          e.target.value = e.target.value.replace(',', '.');
          e.target.closest('td').classList.add('table-danger');
        } else {
          e.target.closest('td').classList.remove('table-danger');
        }
      }

      if (this.checkValues()) {
        // CCY1 Calculate
        this.tableValues[0].ccy1 = 0;
        this.tableValues.forEach(function (el, i) {
          if (i) {
            _this10.tableValues[0].ccy1 = parseFloat(new decimal_default.a(_this10.tableValues[0].ccy1 || 0).plus(el.ccy2 || 0));
          }
        });

        // AFTER Calculate
        var sumCCY2 = 0;
        this.tableValues.forEach(function (el, i) {
          if (i) {
            sumCCY2 = new decimal_default.a(parseFloat(sumCCY2)).plus(el.ccy2);
          }
        });
        this.tableValues[0].after = parseFloat(new decimal_default.a(this.tableValues[0].before || 0).plus(parseFloat(sumCCY2) || 0).plus(this.tableValues[0].blockchainFee || 0)).toFixed(14);
        this.tableValues.forEach(function (el, i) {
          if (i) {
            sumCCY2 = new decimal_default.a(parseFloat(sumCCY2)).plus(el.ccy2);
            _this10.tableValues[i].after = parseFloat(new decimal_default.a(el.before).plus(el.ccy1).plus(el.blockchainFee)) || 0;
            if (_this10.tableValues[i].exchangeFeeValue !== _this10.tableValues[0].baseAsset) {
              // FUND[i].AFTER = Before + CCY1 + ExchangeFee
              _this10.tableValues[i].after = parseFloat(new decimal_default.a(_this10.tableValues[i].after).plus(el.exchangeFee || 0)).toFixed(14);
            } else {
              // FUND[0].AFTER += FUND[i].ExchangeFee
              _this10.tableValues[0].after = parseFloat(new decimal_default.a(_this10.tableValues[0].after).plus(_this10.tableValues[i].exchangeFee || 0)).toFixed(14);
            }
            // Negative value check
            if (_this10.tableValues[i].after < 0) {
              _this10.tableValues[i].checkneg = 1;
            } else {
              _this10.tableValues[i].checkneg = false;
            }
            // Cold storage check
            _this10.tableValues[i].csCheck = new decimal_default.a(_this10.tableValues[i].coldStorage).toDP(8).eq(new decimal_default.a(_this10.tableValues[i].after).toDP(8));
          }
        });
        // Cold storage check for base asset
        this.tableValues[0].csCheck = new decimal_default.a(this.tableValues[0].coldStorage).toDP(8).eq(new decimal_default.a(this.tableValues[0].after).toDP(8));
        // Negative value check
        if (this.tableValues[0].after < 0) {
          this.tableValues[0].checkneg = 1;
        } else {
          this.tableValues[0].checkneg = false;
        }
      }
    },
    customFixed: function customFixed(str) {
      var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;

      var rgx = new RegExp('-?\\d+\\.?\\d{0,' + num + '}');
      str = ('' + str).match(rgx);
      return str ? parseFloat(str[0]).toFixed(num) : parseFloat(0).toFixed(num);
    },
    customFormatter: function customFormatter(date) {
      return moment_default()(date).format('DD.MM.YYYY');
    },
    onSubmit: function onSubmit(e) {
      var _this11 = this;

      var ans = confirm('Are you sure you want to submit the transactions?');
      if (!ans) {
        return;
      }

      this.loading = true;

      var fd = new FormData();
      fd.append('file', new File([new Blob([this.generateCSV()], { type: 'text/csv;charset=utf-8' })], 'Rebalance-' + this.customFormatter(this.date) + '.csv', { type: 'text/csv' }));

      uploadService.uploadCSV(fd).then(function () {
        _this11.$parent.showModal = true;
      }).catch(function (errRes) {
        _this11.errMsg = errRes.error;
      }).finally(function () {
        _this11.loading = false;
      });
    },
    generateCSV: function generateCSV(notParsed) {
      var _this12 = this;

      var transactionId = parseFloat(this.transactionId) || 0;
      var date = this.customFormatter(this.date);
      var rows = [['Date', 'Counterparty', 'Client ID', 'Portfolio ID', 'Transaction ID', 'Type', 'Currency 1 Amount', 'Currency 1', 'Currency 2 Amount', 'Currency 2']];

      var _loop4 = function _loop4(client) {
        // Fees
        // console.log(this.customFixed(client.details.blockchainFee, 14))
        if (parseFloat(client.details.blockchainFee) !== 0) {
          rows.push([date, client.firstName + ' ' + client.lastName, client.clientId, client.portfolios[0].id, transactionId++, 'blockchain fee', _this12.customFixed(client.details.blockchainFee, 14), _this12.tableValues[0].baseAsset, '', '']);
        }

        client.details.pricesPieces.forEach(function (el, i) {
          // console.log(this.customFixed(client.details.blockchainFees[i], 14))
          if (parseFloat(client.details.blockchainFees[i]) !== 0) {
            rows.push([date, client.firstName + ' ' + client.lastName, client.clientId, client.portfolios[0].id, transactionId++, 'blockchain fee', _this12.customFixed(client.details.blockchainFees[i], 14), _this12.tableValues[i + 1].baseAsset, '', '']);
          }
        });
        // Changes
        client.details.pricesPieces.forEach(function (el, i) {
          if (parseFloat(client.details.ccy1Arr[i]) !== 0) {
            rows.push([date, client.firstName + ' ' + client.lastName, client.clientId, client.portfolios[0].id, transactionId++, 'change', _this12.customFixed(client.details.ccy1Arr[i], 14), _this12.tableValues[i + 1].baseAsset,
            // this.customFixed(client.details.ccy2Arr[i], 14),
            parseFloat(client.details.ccy2Arr[i]).toFixed(14), _this12.tableValues[0].baseAsset]);
          }
        });
      };

      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = get_iterator_default()(this.computedClients), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var client = _step9.value;

          _loop4(client);
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      return notParsed ? rows : papaparse_min_default.a.unparse(rows, { delimiter: ',' });
    },
    downloadCSV: function downloadCSV(e) {
      e.preventDefault();
      FileSaver_min_default.a.saveAs(new Blob([this.generateCSV()], { type: 'text/csv;charset=utf-8' }), 'Rebalance-' + this.customFormatter(this.date) + '.csv');
    },
    checkValues: function checkValues() {
      var result = true;
      this.tableValues.forEach(function (row, i) {
        if (!i && (isNaN(parseFloat(row.blockchainFee)) || isNaN(parseFloat(row.coldStorage)))) {
          result = false;
        } else if (isNaN(parseFloat(row.ccy1)) || isNaN(parseFloat(row.ccy2)) || isNaN(parseFloat(row.exchangeFee)) || isNaN(parseFloat(row.blockchainFee)) || isNaN(parseFloat(row.coldStorage))) {
          result = false;
        }
      });
      return result;
    },
    downloadTransactions: function downloadTransactions(e) {
      e.preventDefault();

      var rows = [['Asset', 'Before', 'CCY1', 'CCY2', 'Exchange fee', 'FX', 'B Fee', 'After', 'Cold storage', '']];

      // Fees
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = get_iterator_default()(this.tableValues), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var row = _step10.value;

          rows.push([row.baseAsset,
          // parseFloat(row.before).toFixed(9),
          this.customFixed(parseFloat(row.before).toFixed(14), 14), this.customFixed(row.ccy1, 14), this.customFixed(row.ccy2, 14), this.customFixed(row.exchangeFee, 14), this.customFixed(row.fx, 14), this.customFixed(row.blockchainFee, 14), this.customFixed(parseFloat(row.after).toFixed(14), 14), this.customFixed(row.coldStorage, 14)]);
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      rows.push([]);
      rows.push(['', '', '', '', '', '', '', '', '', this.remark]);

      FileSaver_min_default.a.saveAs(new Blob([papaparse_min_default.a.unparse(rows, { delimiter: ',' })], { type: 'text/csv;charset=utf-8' }), 'input-transactions-' + this.customFormatter(this.customFormatter(this.date)) + '.csv');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32634518","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/forms/RebalanceForm.vue
var RebalanceForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)}}},[_c('loading',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"basicinfo col-lg-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"date"}},[_vm._v("Date")]),_vm._v(" "),_c('datepicker',{attrs:{"format":_vm.customFormatter,"id":"date"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-3"},[_c('label',{attrs:{"for":"sid"}},[_vm._v("Starting id")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.transactionId),expression:"transactionId"}],staticClass:"form-control",attrs:{"type":"text","required":"","id":"sid"},domProps:{"value":(_vm.transactionId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.transactionId=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"asset"}},[_vm._v("Base asset")]),_vm._v(" "),_c('multiselect',{attrs:{"id":"asset","options":_vm.baseAssets,"label":"format","track-by":"name","allow-empty":false,"deselect-label":"","select-label":""},on:{"select":_vm.onSelectBaseAsset},model:{value:(_vm.baseAsset),callback:function ($$v) {_vm.baseAsset=$$v},expression:"baseAsset"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"assets"}},[_vm._v("Assets 2")]),_vm._v(" "),_c('multiselect',{attrs:{"id":"assets","options":_vm.pricesSelectArr,"label":"format","track-by":"id","multiple":true,"select-label":"","disabled":!_vm.baseAsset},on:{"select":_vm.onSelectPrice,"remove":_vm.onRemovePrice},model:{value:(_vm.pricesSelect),callback:function ($$v) {_vm.pricesSelect=$$v},expression:"pricesSelect"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"clients"}},[_vm._v("Clients")]),_vm._v(" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();_vm.checkAll($event)}}},[_vm._v(_vm._s(_vm.selectall))]),_vm._v("("+_vm._s(_vm.checkedCount)+"）\n                    "),_c('multiselect',{attrs:{"id":"clients","options":_vm.clientsSelectArr,"multiple":true,"label":"fullName","track-by":"id","select-label":"","disabled":!_vm.baseAsset || !_vm.pricesSelect},on:{"select":_vm.onSelectClient,"remove":_vm.onRemoveClient},model:{value:(_vm.clientsSelect),callback:function ($$v) {_vm.clientsSelect=$$v},expression:"clientsSelect"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"remark"}},[_vm._v("Remark")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.remark),expression:"remark"}],staticClass:"form-control",attrs:{"id":"remark"},domProps:{"value":(_vm.remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.remark=$event.target.value}}})])])])]),_vm._v(" "),(_vm.tableValues[0].isSelected)?_c('div',{staticClass:"row mt-5"},[_c('h1',{staticClass:"h2"},[_vm._v("Input transactions")]),_vm._v(" "),_c('table',{staticClass:"table text-center inputtrans"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.tableValues),function(values,index){return _c('tr',{key:values.baseAsset},[(!index)?[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(values.baseAsset))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"btn-group mt-1",staticStyle:{"vertical-align":"text-top"}},[_vm._v(_vm._s(parseFloat(values.before).toFixed(8))+"\n                            "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"ml-2 copytoclip",attrs:{"size":"sm","variant":"light","title":parseFloat(values.before).toFixed(14)},on:{"click":function($event){$event.stopPropagation();_vm.copyToClipboard(parseFloat(values.before).toFixed(14))}}},[_c('span',[_vm._v("...")]),_c('span',{staticStyle:{"width":"100%","text-align":"left"}},[_vm._v("📋")])])],1)]),_vm._v(" "),_c('td',{class:{ 'table-warning': values.checkLTE }},[_vm._v(_vm._s(_vm.customFixed(values.ccy1)))]),_vm._v(" "),_c('td',[_vm._v("N/A")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(values.baseAsset))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(values.blockchainFee),expression:"values.blockchainFee",modifiers:{"number":true}}],staticClass:"form-control text-right w-100",attrs:{"type":"text"},domProps:{"value":(values.blockchainFee)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(values, "blockchainFee", _vm._n($event.target.value))},_vm.onInput],"keydown":_vm.onInput,"blur":[_vm.onInput,function($event){_vm.$forceUpdate()}]}})])]),_vm._v(" "),_c('td',{class:{ 'table-danger': values.checkneg }},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(values.baseAsset))])]),_vm._v(" "),_c('div',{staticClass:"form-control d-flex justify-content-end w-100"},[_vm._v("\n                                "+_vm._s(_vm.customFixed(values.after))+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"input-group-addon bg-light"},[(values.check)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 green"}},[_vm._v("✔")]):_vm._e(),_vm._v(" "),(!values.check)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 red"}},[_vm._v("✖")]):_vm._e()])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(values.baseAsset))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(values.coldStorage),expression:"values.coldStorage",modifiers:{"number":true}}],staticClass:"form-control text-right w-100",attrs:{"type":"text"},domProps:{"value":(values.coldStorage)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(values, "coldStorage", _vm._n($event.target.value))},_vm.onInput],"keydown":_vm.onInput,"blur":[_vm.onInput,function($event){_vm.$forceUpdate()}]}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon bg-light"},[(values.csCheck)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 green"}},[_vm._v("✔")]):_vm._e(),_vm._v(" "),(!values.csCheck)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 red"}},[_vm._v("✖")]):_vm._e()])])])]:[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(values.baseAsset))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"btn-group mt-1",staticStyle:{"vertical-align":"text-top"}},[_vm._v(_vm._s(parseFloat(values.before).toFixed(8))+"\n                            "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"ml-2 pull-right copytoclip",attrs:{"size":"sm","variant":"light","title":parseFloat(values.before).toFixed(14)},on:{"click":function($event){$event.stopPropagation();_vm.copyToClipboard(parseFloat(values.before).toFixed(14))}}},[_c('span',[_vm._v("...")]),_c('span',{staticStyle:{"width":"100%","text-align":"left"}},[_vm._v("📋")])])],1)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(values.baseAsset))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(values.ccy1),expression:"values.ccy1",modifiers:{"number":true}}],staticClass:"form-control text-right w-100",attrs:{"type":"text"},domProps:{"value":(values.ccy1)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(values, "ccy1", _vm._n($event.target.value))},_vm.onInput],"keydown":_vm.onInput,"blur":[_vm.onInput,function($event){_vm.$forceUpdate()}]}})])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.tableValues[0].baseAsset))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(values.ccy2),expression:"values.ccy2",modifiers:{"number":true}}],staticClass:"form-control text-right w-100",attrs:{"type":"text"},domProps:{"value":(values.ccy2)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(values, "ccy2", _vm._n($event.target.value))},_vm.onInput],"keydown":_vm.onInput,"blur":[_vm.onInput,function($event){_vm.$forceUpdate()}]}})])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"input-group"},[_c('multiselect',{staticClass:"exchangefee",attrs:{"options":values.exchangeFeeOptions,"allow-empty":false,"show-labels":false,"searchable":false},on:{"input":_vm.onInput},model:{value:(values.exchangeFeeValue),callback:function ($$v) {_vm.$set(values, "exchangeFeeValue", $$v)},expression:"values.exchangeFeeValue"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(values.exchangeFee),expression:"values.exchangeFee",modifiers:{"number":true}}],staticClass:"form-control text-right w-100",attrs:{"type":"text"},domProps:{"value":(values.exchangeFee)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(values, "exchangeFee", _vm._n($event.target.value))},_vm.onInput],"keydown":_vm.onInput,"blur":[_vm.onInput,function($event){_vm.$forceUpdate()}]}})],1)]),_vm._v(" "),_c('td',[_vm._v("\n                        "+_vm._s(_vm.customFixed(values.fx))+"\n                    ")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(values.baseAsset))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(values.blockchainFee),expression:"values.blockchainFee",modifiers:{"number":true}}],staticClass:"form-control text-right w-100",attrs:{"type":"text"},domProps:{"value":(values.blockchainFee)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(values, "blockchainFee", _vm._n($event.target.value))},_vm.onInput],"keydown":_vm.onInput,"blur":[_vm.onInput,function($event){_vm.$forceUpdate()}]}})])]),_vm._v(" "),_c('td',{class:{ 'table-danger': values.checkneg }},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(values.baseAsset))])]),_vm._v(" "),_c('div',{staticClass:"form-control d-flex justify-content-end w-100"},[_vm._v(_vm._s(_vm.customFixed(values.after))+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"input-group-addon bg-light"},[(values.check)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 green"}},[_vm._v("✔")]):_vm._e(),_vm._v(" "),(!values.check)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 red"}},[_vm._v("✖")]):_vm._e()])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_c('span',{staticClass:"input-group-text"},[_vm._v(_vm._s(values.baseAsset))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(values.coldStorage),expression:"values.coldStorage",modifiers:{"number":true}}],staticClass:"form-control text-right w-100",attrs:{"type":"text"},domProps:{"value":(values.coldStorage)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(values, "coldStorage", _vm._n($event.target.value))},_vm.onInput],"keydown":_vm.onInput,"blur":[_vm.onInput,function($event){_vm.$forceUpdate()}]}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon bg-light"},[(values.csCheck)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 green"}},[_vm._v("✔")]):_vm._e(),_vm._v(" "),(!values.csCheck)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 red"}},[_vm._v("✖")]):_vm._e()])])])]],2)}))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row pt-3"},[_c('div',{staticClass:"col d-flex justify-content-start"}),_vm._v(" "),_c('div',{staticClass:"col d-flex justify-content-end"},[_c('b',[_vm._v("Client level check:")]),_vm._v(" \n        "),(_vm.checkbaseasseteq)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 green"}},[_vm._v("✔")]):_vm._e(),_vm._v(" "),(!_vm.checkbaseasseteq)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 red"}},[_vm._v("✖")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col d-flex justify-content-end"})]),_vm._v(" "),_vm._l((_vm.getClients),function(values,index){return _c('div',{staticClass:"list-group-item row mt-3"},[_c('div',{staticClass:"row pt-3"},[_c('div',{staticClass:"col d-flex justify-content-start"},[_vm._v(_vm._s(values.fullName))]),_vm._v(" "),_c('div',{staticClass:"col d-flex justify-content-end"},[_vm._v("\n                "+_vm._s(_vm.customFixed(values.details.baseAssetEqual))+" "+_vm._s(values.details.assets[_vm.baseAsset.ticker].ticker)+"   \n              "),(values.details.baseAssetCheck)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 green"}},[_vm._v("✔")]):_vm._e(),_vm._v(" "),(!values.details.baseAssetCheck)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 red"}},[_vm._v("✖")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col d-flex justify-content-end"},[_vm._v("\n                "+_vm._s(parseFloat(values.details.percentage * 100).toFixed(4))+"%\n            ")])]),_vm._v(" "),_c('table',{staticClass:"table text-center table-striped"},[_vm._m(1,true),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(_vm.tableValues[0].baseAsset))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.customFixed(values.details.baseAssetPieces)))]),_vm._v(" "),_c('td',[_vm._v("N/A")]),_vm._v(" "),_c('td',[(values.details.ccy2)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 green"}},[_vm._v("✔")]):_vm._e(),_vm._v(" "),(!values.details.ccy2)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 red"}},[_vm._v("✖")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.customFixed(values.details.blockchainFee)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(parseFloat(values.details.after).toFixed(8)))]),_vm._v(" "),_c('td')]),_vm._v(" "),_vm._l((_vm.getPrices),function(prices,i){return _c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(prices.symbol))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(parseFloat(values.details.pricesPieces[i]).toFixed(8)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.customFixed(values.details.ccy1Arr[i])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(parseFloat(values.details.ccy2Arr[i]).toFixed(8)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.customFixed(values.details.fxArr[i])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.customFixed(values.details.blockchainFees[i])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(parseFloat(values.details.afters[i]).toFixed(8)))]),_vm._v(" "),_c('td',[(values.details.afterCheck)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 green"}},[_vm._v("✔")]):_vm._e(),_vm._v(" "),(!values.details.afterCheck)?_c('span',{staticStyle:{"color":"transparent","text-shadow":"0 0 0 red"}},[_vm._v("✖")]):_vm._e()])])})],2)])])}),_vm._v(" "),(_vm.canSubmit)?_c('div',{staticClass:"list-group-item row mt-5"},[_c('h1',{staticClass:"h3"},[_vm._v("Rebalance CSV Preview")]),_vm._v(" "),_c('table',{staticClass:"table text-center"},[_c('thead',[_vm._l((_vm.getCsvTable),function(row,index){return [(!index)?_c('tr',_vm._l((row),function(col){return _c('th',{attrs:{"scope":"col"}},[_vm._v(_vm._s(col))])})):_vm._e()]})],2),_vm._v(" "),_c('tbody',[_vm._l((_vm.getCsvTable),function(row,index){return [(index)?_c('tr',{class:{ 'table-active': _vm.csvBreakpoints[index] }},_vm._l((row),function(col){return _c('td',[_vm._v(_vm._s(col))])})):_vm._e()]})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mt-5 justify-content-center"},[_c('div',{staticClass:"form-group mr-4"},[_c('button',{staticClass:"btn btn-outline-success",attrs:{"disabled":!_vm.canSubmit || !_vm.date}},[_vm._v("Submit transactions")])]),_vm._v(" "),_c('div',{staticClass:"form-group mr-4"},[_c('button',{staticClass:"btn btn-outline-success",attrs:{"disabled":!_vm.canSubmit || !_vm.date},on:{"click":_vm.downloadCSV}},[_vm._v("Download\n                Rebalance CSV\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-group mr-4"},[_c('button',{staticClass:"btn btn-outline-success",attrs:{"disabled":!_vm.canSubmit || !_vm.date},on:{"click":_vm.downloadTransactions}},[_vm._v("\n                Download Input Transactions CSV\n            ")])])])],2)}
var RebalanceForm_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"1px"},attrs:{"scope":"col"}},[_vm._v("Asset")]),_vm._v(" "),_c('th',{staticStyle:{"width":"200px"},attrs:{"scope":"col"}},[_vm._v("Before")]),_vm._v(" "),_c('th',{staticStyle:{"width":"200px"},attrs:{"scope":"col"}},[_vm._v("CCY1")]),_vm._v(" "),_c('th',{staticStyle:{"width":"200px"},attrs:{"scope":"col"}},[_vm._v("CCY2")]),_vm._v(" "),_c('th',{staticStyle:{"width":"250px"},attrs:{"scope":"col"}},[_vm._v("Exchange fee")]),_vm._v(" "),_c('th',{staticStyle:{"width":"1px"},attrs:{"scope":"col"}},[_vm._v("FX")]),_vm._v(" "),_c('th',{staticStyle:{"width":"200px"},attrs:{"scope":"col"}},[_vm._v("B Fee")]),_vm._v(" "),_c('th',{staticStyle:{"width":"250px"},attrs:{"scope":"col"}},[_vm._v("After")]),_vm._v(" "),_c('th',{staticStyle:{"width":"250px"},attrs:{"scope":"col"}},[_vm._v("Cold storage")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Asset")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Before")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("CCY1 Amount")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("CCY2 Amount")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("FX")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("B Fee")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("After")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Check")])])])}]
var RebalanceForm_esExports = { render: RebalanceForm_render, staticRenderFns: RebalanceForm_staticRenderFns }
/* harmony default export */ var forms_RebalanceForm = (RebalanceForm_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/forms/RebalanceForm.vue
function RebalanceForm_injectStyle (ssrContext) {
  __webpack_require__("cDAa")
  __webpack_require__("2ww/")
}
var RebalanceForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RebalanceForm___vue_template_functional__ = false
/* styles */
var RebalanceForm___vue_styles__ = RebalanceForm_injectStyle
/* scopeId */
var RebalanceForm___vue_scopeId__ = "data-v-32634518"
/* moduleIdentifier (server only) */
var RebalanceForm___vue_module_identifier__ = null
var RebalanceForm_Component = RebalanceForm_normalizeComponent(
  RebalanceForm,
  forms_RebalanceForm,
  RebalanceForm___vue_template_functional__,
  RebalanceForm___vue_styles__,
  RebalanceForm___vue_scopeId__,
  RebalanceForm___vue_module_identifier__
)

/* harmony default export */ var components_forms_RebalanceForm = (RebalanceForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/RebalancePage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var RebalancePage = ({
  components: {
    rebalanceForm: components_forms_RebalanceForm
  },
  data: function data() {
    return {
      showModal: false
    };
  },

  methods: {
    redirect: function redirect() {
      this.showModal = false;
      this.$router.push('/');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27bf6e96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/RebalancePage.vue
var RebalancePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid pt-5"},[_c('div',{staticClass:"d-flex justify-content-center mt-5"},[_c('rebalance-form',{staticClass:"col-lg-12"})],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Successful submit","header-bg-variant":"success","header-text-variant":"light"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('div',{attrs:{"slot":"modal-header-close"},slot:"modal-header-close"}),_vm._v(" "),_c('p',[_vm._v("The transactions were submitted successfully.")]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.redirect}},[_vm._v("OK")])],1)])],1)}
var RebalancePage_staticRenderFns = []
var RebalancePage_esExports = { render: RebalancePage_render, staticRenderFns: RebalancePage_staticRenderFns }
/* harmony default export */ var pages_RebalancePage = (RebalancePage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/RebalancePage.vue
var RebalancePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RebalancePage___vue_template_functional__ = false
/* styles */
var RebalancePage___vue_styles__ = null
/* scopeId */
var RebalancePage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var RebalancePage___vue_module_identifier__ = null
var RebalancePage_Component = RebalancePage_normalizeComponent(
  RebalancePage,
  pages_RebalancePage,
  RebalancePage___vue_template_functional__,
  RebalancePage___vue_styles__,
  RebalancePage___vue_scopeId__,
  RebalancePage___vue_module_identifier__
)

/* harmony default export */ var _service_app_pages_RebalancePage = (RebalancePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/forms/PricesForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var PricesForm_API_V1_URL = "https://updateapi.blockchain.bg/v1";
/* Decimal.set({ rounding: 5 }) */
decimal_default.a.set({ toExpNeg: -14 });

/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-trailing-spaces */
/* harmony default export */ var PricesForm = ({
  components: {
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    Multiselect: vue_multiselect_min_default.a
  },
  data: function data() {
    return {
      loading: false,
      canSubmit: false,
      currencies: {},
      pricesSelectArr: [],
      datechosen: null,
      crypto: null,
      datechosenBGN: false,
      prices: [{
        date: '',
        name: '',
        currency: null,
        priceUSD: '',
        // priceEUR: '',
        priceBGN: '',
        crypto: true
      }]
    };
  },

  computed: {
    getPrices: function getPrices() {
      return this.prices.slice();
    }
  },
  created: function created() {},

  methods: {
    addCurrency: function addCurrency() {
      this.prices.push({
        date: '',
        name: '',
        currency: '',
        priceUSD: '',
        // priceEUR: '',
        priceBGN: '',
        crypto: true
      });
    },

    /**
     * Price select methods
     */
    onSelectDate: function onSelectDate(prices) {
      var _this = this;

      /**
       * Start loading
       */
      this.loading = true;
      axios_default.a.get(PricesForm_API_V1_URL + ('/prices/' + this.customFormatter(this.datechosen, true) + '/BGN')).then(function (res) {
        if (res.success) {
          _this.datechosenBGN = res.data;
          _this.canSubmit = true;
        } else {
          _this.datechosenBGN = false;
        }
      });
      axios_default.a.get(PricesForm_API_V1_URL + '/prices/?limit=4000&offset=0').then(function (res) {
        var prices = [];
        res.data.forEach(function (el) {
          el.format = el.id + ' [' + el.symbol + ']';
          prices.push(el);
        });
        _this.pricesSelectArr = prices;
      })
      /**
       * Stop loading
       */
      .finally(function () {
        _this.loading = false;
      });
      for (var obj in prices) {
        this.onSelectPrice(prices[obj]);
      }
    },
    onSelectPrice: function onSelectPrice(obj) {
      var _this2 = this;

      if (obj && obj.currency) {
        axios_default.a.get(PricesForm_API_V1_URL + ('/prices/' + this.customFormatter(this.datechosen, true) + '/' + obj.currency.symbol)).then(function (res) {
          obj.priceBGN = res.success ? res.data.priceBGN : '';
          // obj.priceEUR = res.success ? res.data.priceEUR : ''
          obj.priceUSD = res.success ? res.data.priceUSD : '';
          obj.isNew = !res.success;
          _this2.onInput();
        });
        // if fiat is chosen
        if (obj.currency.symbol === 'USD' || obj.currency.symbol === 'BGN') {
          obj.crypto = false;
          // if there is a new crypto exchange then we can submit
          // if (this.prices.find(function(el) {
          //   console.log(el.isNew)
          //   return el.isNew === true
          // })) {
          this.canSubmit = true;
          // }
        } else {
          obj.crypto = true;
        }
      }
      this.onInput();
    },
    onRemovePrice: function onRemovePrice(obj) {
      obj.priceBGN = '';
      // obj.priceEUR = ''
      obj.priceUSD = '';
      obj.isNew = false;
    },

    /**
     * Calculations
     */
    onInput: function onInput(e) {
      if (e && e.target) {
        if (!RegExp('^-?[0-9]+([\\.][0-9]+)?$').test(e.target.value)) {
          e.target.value = e.target.value.replace(',', '.');
          e.target.classList.add('bg-warning');
        } else {
          e.target.classList.remove('bg-warning');
        }
      }
    },
    customFixed: function customFixed(str) {
      var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;

      var rgx = new RegExp('-?\\d+\\.?\\d{0,' + num + '}');
      str = ('' + str).match(rgx);
      return str ? parseFloat(str[0]).toFixed(num) : parseFloat(0).toFixed(num);
    },
    customFormatter: function customFormatter(date, isAjax) {
      if (isAjax) {
        return moment_default()(date).format('YYYY-MM-DD');
      }
      return moment_default()(date).format('DD.MM.YYYY');
    },
    onSubmit: function onSubmit(e) {
      var _this3 = this;

      var ans = confirm('Are you sure you want to save the data?');
      if (!ans) {
        return;
      }

      this.loading = true;

      axios_default.a.post(PricesForm_API_V1_URL + '/prices/set', {
        date: this.customFormatter(this.datechosen, true),
        prices: this.prices.map(function (price) {
          price.date = _this3.customFormatter(_this3.datechosen, true);
          price.currency = price.currency.symbol;
          // price.name = price.currency.name
          return price;
        })
      }).then(function (res) {
        _this3.loading = false;
        _this3.prices = [{
          date: '',
          currency: null,
          priceUSD: '',
          // priceEUR: '',
          priceBGN: ''
        }];
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ca87d50","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/forms/PricesForm.vue
var PricesForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)}}},[_c('loading',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"daychosen row mb-3 align-items-center"},[_c('div',{staticClass:"form-group col-md-6 offset-2"},[_c('label',{attrs:{"for":"date"}},[_vm._v("Date")]),_vm._v(" "),_c('datepicker',{attrs:{"format":_vm.customFormatter,"id":"date"},on:{"input":function($event){_vm.onSelectDate(_vm.prices)}},model:{value:(_vm.datechosen),callback:function ($$v) {_vm.datechosen=$$v},expression:"datechosen"}})],1)]),_vm._v(" "),_vm._l((_vm.prices),function(val,i){return [_c('div',{staticClass:"currencies row mb-3 align-items-center"},[_c('div',{staticClass:"form-group col-md-3 offset-2"},[_c('label',{attrs:{"for":"assets"}},[_vm._v("Currency")]),_vm._v(" "),_c('multiselect',{attrs:{"id":"assets","options":_vm.pricesSelectArr,"label":"format","track-by":"id","select-label":"","disabled":!_vm.datechosen},on:{"input":function($event){_vm.onSelectPrice(val)},"remove":function($event){_vm.onRemovePrice(val)}},model:{value:(val.currency),callback:function ($$v) {_vm.$set(val, "currency", $$v)},expression:"val.currency"}})],1),_vm._v(" "),(val.crypto || (val.currency && val.currency.symbol=== 'BGN') || !val.currency)?_c('div',{staticClass:"input-group col-md-5 mt-3"},[_vm._m(0,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(val.priceUSD),expression:"val.priceUSD"}],staticClass:"form-control text-right w-100",attrs:{"type":"text"},domProps:{"value":(val.priceUSD)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(val, "priceUSD", $event.target.value)},_vm.onInput],"keydown":_vm.onInput,"blur":_vm.onInput}})]):_vm._e(),_vm._v(" "),(!val.crypto && (val.currency && val.currency.symbol !== 'BGN'))?_c('div',{staticClass:"input-group col-md-5 mt-3"},[_vm._m(1,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(val.priceBGN),expression:"val.priceBGN"}],staticClass:"form-control text-right w-100",attrs:{"type":"text"},domProps:{"value":(val.priceBGN)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(val, "priceBGN", $event.target.value)},_vm.onInput],"keydown":_vm.onInput,"blur":_vm.onInput}})]):_vm._e(),_vm._v(" "),(i === _vm.prices.length - 1)?_c('span',{staticClass:"mt-3 btn btn-outline-primary",staticStyle:{"cursor":"pointer"},on:{"click":_vm.addCurrency}},[_vm._v("+")]):_vm._e(),_vm._v(" "),(val.isNew && val.crypto && !_vm.datechosenBGN)?_c('span',{staticClass:"col-md-12 text-center"},[_vm._v("Creating a new record for date "+_vm._s(_vm.customFormatter(_vm.datechosen))+". Please include USD/BGN "),_c('b',[_vm._v("or")]),_vm._v(" BGN/USD for this date.")]):_vm._e()])]})],2)]),_vm._v(" "),_c('div',{staticClass:"row mt-5 justify-content-center"},[_c('div',{staticClass:"form-group mr-4"},[_c('button',{staticClass:"btn btn-outline-success",attrs:{"disabled":!_vm.canSubmit || !_vm.datechosen}},[_vm._v("Save data")])])])],1)}
var PricesForm_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-addon"},[_c('span',{staticClass:"input-group-text"},[_vm._v("USD")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-addon"},[_c('span',{staticClass:"input-group-text"},[_vm._v("BGN")])])}]
var PricesForm_esExports = { render: PricesForm_render, staticRenderFns: PricesForm_staticRenderFns }
/* harmony default export */ var forms_PricesForm = (PricesForm_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/forms/PricesForm.vue
function PricesForm_injectStyle (ssrContext) {
  __webpack_require__("PKif")
  __webpack_require__("shdt")
}
var PricesForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PricesForm___vue_template_functional__ = false
/* styles */
var PricesForm___vue_styles__ = PricesForm_injectStyle
/* scopeId */
var PricesForm___vue_scopeId__ = "data-v-6ca87d50"
/* moduleIdentifier (server only) */
var PricesForm___vue_module_identifier__ = null
var PricesForm_Component = PricesForm_normalizeComponent(
  PricesForm,
  forms_PricesForm,
  PricesForm___vue_template_functional__,
  PricesForm___vue_styles__,
  PricesForm___vue_scopeId__,
  PricesForm___vue_module_identifier__
)

/* harmony default export */ var components_forms_PricesForm = (PricesForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/PricesPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var PricesPage = ({
  components: {
    currenciesForm: components_forms_PricesForm
  },
  data: function data() {
    return {
      showModal: false
    };
  },

  methods: {
    redirect: function redirect() {
      this.showModal = false;
      this.$router.push('/');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e7c8a62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/PricesPage.vue
var PricesPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid pt-5"},[_c('div',{staticClass:"d-flex justify-content-center mt-5"},[_c('currencies-form',{staticClass:"col-lg-12"})],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Successful submit","header-bg-variant":"success","header-text-variant":"light"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('div',{attrs:{"slot":"modal-header-close"},slot:"modal-header-close"}),_vm._v(" "),_c('p',[_vm._v("The transactions were submitted successfully.")]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.redirect}},[_vm._v("OK")])],1)])],1)}
var PricesPage_staticRenderFns = []
var PricesPage_esExports = { render: PricesPage_render, staticRenderFns: PricesPage_staticRenderFns }
/* harmony default export */ var pages_PricesPage = (PricesPage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/PricesPage.vue
var PricesPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PricesPage___vue_template_functional__ = false
/* styles */
var PricesPage___vue_styles__ = null
/* scopeId */
var PricesPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PricesPage___vue_module_identifier__ = null
var PricesPage_Component = PricesPage_normalizeComponent(
  PricesPage,
  pages_PricesPage,
  PricesPage___vue_template_functional__,
  PricesPage___vue_styles__,
  PricesPage___vue_scopeId__,
  PricesPage___vue_module_identifier__
)

/* harmony default export */ var _service_app_pages_PricesPage = (PricesPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/tables/CurrenciesTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CurrenciesTable = ({
  props: ['currencies'],
  methods: {
    onDelete: function onDelete(coin) {
      var _this = this;

      var ans = void 0;
      if (coin.intransactions) {
        ans = confirm('There are transactions involving ' + coin.name + '!\nAre you sure you want to delete this currency?');
      } else {
        ans = confirm('Are you sure you want to delete ' + coin.name + '?');
      }
      if (!ans) {
        return;
      }
      this.loading = true;
      this.$store.dispatch('deleteCurrency', coin.id).then(function (res) {
        if (res) {
          _this.$emit('onMessage', coin.name + ' was deleted.');
        } else {
          alert('Error');
        }
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cf1a6c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/tables/CurrenciesTable.vue
var CurrenciesTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-bordered"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.currencies),function(coin){return _c('tr',[_c('td',[_vm._v(_vm._s(coin.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(coin.symbol))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(coin.name))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('b-btn',{staticClass:"btn btn-sm",attrs:{"size":"sm","variant":""},on:{"click":function($event){_vm.onDelete(coin)}}},[_c('span',{staticClass:"grey"},[_vm._v("remove")])])],1)])}))])}
var CurrenciesTable_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Id")]),_vm._v(" "),_c('th',[_vm._v("Ticker")]),_vm._v(" "),_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th')])])}]
var CurrenciesTable_esExports = { render: CurrenciesTable_render, staticRenderFns: CurrenciesTable_staticRenderFns }
/* harmony default export */ var tables_CurrenciesTable = (CurrenciesTable_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/tables/CurrenciesTable.vue
var CurrenciesTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CurrenciesTable___vue_template_functional__ = false
/* styles */
var CurrenciesTable___vue_styles__ = null
/* scopeId */
var CurrenciesTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CurrenciesTable___vue_module_identifier__ = null
var CurrenciesTable_Component = CurrenciesTable_normalizeComponent(
  CurrenciesTable,
  tables_CurrenciesTable,
  CurrenciesTable___vue_template_functional__,
  CurrenciesTable___vue_styles__,
  CurrenciesTable___vue_scopeId__,
  CurrenciesTable___vue_module_identifier__
)

/* harmony default export */ var components_tables_CurrenciesTable = (CurrenciesTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/CurrenciesPage.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var CurrenciesPage_API_V1_URL = "https://updateapi.blockchain.bg/v1";

/* harmony default export */ var CurrenciesPage = ({
  components: {
    CurrenciesTable: components_tables_CurrenciesTable,
    Multiselect: vue_multiselect_min_default.a
  },
  data: function data() {
    return {
      showModal: false,
      optionsLimit: 200,
      currency: null,
      currencyarray: [],
      currenciesAvailable: [],
      baseAsset: null,
      currentPage: 1,
      itemsPerPage: 200,
      successMsg: null
    };
  },
  created: function created() {
    var _this = this;

    fetch('https://api.coingecko.com/api/v3/coins/list', { headers: { 'Accept': '*/*' } }).then(function (resp) {
      return resp.json();
    }).then(function (data) {
      var _currencyarray;

      (_currencyarray = _this.currencyarray).push.apply(_currencyarray, toConsumableArray_default()(data));
    });
    var currencies = this.$store.getters.getCurrencies(this.currentPage);

    if (!currencies.length) {
      this.loadCurrencies(this.currentPage);
    }
    // axios.get(API_V1_URL + '/prices/currencies/?limit=' + this.itemsPerPage + '&offset=0')
    //   .then((res) => {
    //     this.currenciesAvailable = res.data
    //   })
  },

  computed: {
    currencies: function currencies() {
      return this.$store.getters.getCurrencies(this.currentPage);
    },
    total: function total() {
      return this.$store.getters.getCurrenciesTotal;
    }
  },
  methods: {
    loadCurrencies: function loadCurrencies(page) {
      var _this2 = this;

      this.loading = true;
      this.$store.dispatch('getCurrencies', { page: page, itemsPerPage: this.itemsPerPage }).finally(function () {
        _this2.loading = false;
      });
    },
    onSelectCurrency: function onSelectCurrency(obj) {},
    customLabel: function customLabel(_ref) {
      var symbol = _ref.symbol,
          name = _ref.name;

      return '[' + symbol.toUpperCase() + '] ' + name;
    },
    onSubmit: function onSubmit(e) {
      var _this3 = this;

      // submit currency and get response
      // if the id already exist
      // if success add new row in table
      this.loading = true;
      axios_default.a.post(CurrenciesPage_API_V1_URL + '/prices/create', { currency: this.currency }).then(function (res) {
        // console.log(res)
        if (res.success) {
          _this3.showModal = false;
          _this3.onMessage('Successfully added ' + _this3.currency.name);
        } else {
          alert('This currency already exists in the database');
        }
      });
    },
    redirect: function redirect() {
      this.showModal = false;
    },
    onMessage: function onMessage(text) {
      var _this4 = this;

      // console.log(text)
      this.successMsg = text;
      setTimeout(function () {
        _this4.successMsg = null;
      }, 3000);
    }
  },
  watch: {
    currentPage: function currentPage() {
      this.loadCurrencies(this.currentPage);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4558a683","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/CurrenciesPage.vue
var CurrenciesPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid pb-5"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mt-5"},[_c('div',{staticClass:"col-md-10"},[(_vm.successMsg)?_c('div',{staticClass:"alert alert-success text-center"},[_vm._v("\n                "+_vm._s(_vm.successMsg)+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pb-3"},[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Add new")])],1),_vm._v(" "),_c('currencies-table',{attrs:{"currencies":_vm.currencies},on:{"onMessage":_vm.onMessage}}),_vm._v(" "),(_vm.total > _vm.itemsPerPage)?_c('b-pagination',{attrs:{"size":"md","total-rows":_vm.total,"per-page":_vm.itemsPerPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e()],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Add a new currency","header-bg-variant":"","header-text-variant":"dark"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('div',{attrs:{"slot":"modal-header-close"},slot:"modal-header-close"}),_vm._v(" "),_c('p',[_vm._v("Search by '[symbol]' or by 'Name'")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)}}},[_c('multiselect',{attrs:{"id":"currency","options":_vm.currencyarray,"label":"symbol","track-by":"id","optionsLimit":this.optionsLimit,"select-label":"","disabled":false,"custom-label":_vm.customLabel},on:{"input":function($event){_vm.onSelectCurrency(_vm.currency)}},model:{value:(_vm.currency),callback:function ($$v) {_vm.currency=$$v},expression:"currency"}})],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("Save")])],1)])],1)}
var CurrenciesPage_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row py-3"},[_c('div',{staticClass:"col-md-12"},[_c('h1',{staticClass:"text-center"},[_vm._v("Currency list")])])])}]
var CurrenciesPage_esExports = { render: CurrenciesPage_render, staticRenderFns: CurrenciesPage_staticRenderFns }
/* harmony default export */ var pages_CurrenciesPage = (CurrenciesPage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/CurrenciesPage.vue
function CurrenciesPage_injectStyle (ssrContext) {
  __webpack_require__("H1nm")
}
var CurrenciesPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CurrenciesPage___vue_template_functional__ = false
/* styles */
var CurrenciesPage___vue_styles__ = CurrenciesPage_injectStyle
/* scopeId */
var CurrenciesPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CurrenciesPage___vue_module_identifier__ = null
var CurrenciesPage_Component = CurrenciesPage_normalizeComponent(
  CurrenciesPage,
  pages_CurrenciesPage,
  CurrenciesPage___vue_template_functional__,
  CurrenciesPage___vue_styles__,
  CurrenciesPage___vue_scopeId__,
  CurrenciesPage___vue_module_identifier__
)

/* harmony default export */ var _service_app_pages_CurrenciesPage = (CurrenciesPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/tables/GroupsTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var GroupsTable = ({
  props: ['groups'],
  data: function data() {
    return {
      loading: false
    };
  },

  methods: {
    edit: function edit(group) {
      var _this = this;

      var name = window.prompt('Client Group Name:', group.name);
      if (name) {
        this.loading = true;
        this.$store.dispatch('updateGroup', { id: group.id, name: name }).finally(function () {
          _this.loading = false;
        });
      } else if (name === '') {
        window.alert('The name can not be empty!');
      }
    },
    remove: function remove(group) {
      var _this2 = this;

      if (window.confirm('Are you sure you want to delete group ' + group.name)) {
        this.loading = true;
        this.$store.dispatch('deleteGroup', group.id).finally(function () {
          _this2.loading = false;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30f68e60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/tables/GroupsTable.vue
var GroupsTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"table table-bordered"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.groups),function(group){return _c('tr',[_c('td',[_vm._v(_vm._s(group.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-info",attrs:{"type":"button"},on:{"click":function($event){_vm.edit(group)}}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.remove(group)}}},[_vm._v("Delete")])])])}))]),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)}
var GroupsTable_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th')])])}]
var GroupsTable_esExports = { render: GroupsTable_render, staticRenderFns: GroupsTable_staticRenderFns }
/* harmony default export */ var tables_GroupsTable = (GroupsTable_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/tables/GroupsTable.vue
var GroupsTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GroupsTable___vue_template_functional__ = false
/* styles */
var GroupsTable___vue_styles__ = null
/* scopeId */
var GroupsTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GroupsTable___vue_module_identifier__ = null
var GroupsTable_Component = GroupsTable_normalizeComponent(
  GroupsTable,
  tables_GroupsTable,
  GroupsTable___vue_template_functional__,
  GroupsTable___vue_styles__,
  GroupsTable___vue_scopeId__,
  GroupsTable___vue_module_identifier__
)

/* harmony default export */ var components_tables_GroupsTable = (GroupsTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/GroupsPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var GroupsPage = ({
  components: {
    GroupsTable: components_tables_GroupsTable
  },
  created: function created() {
    var _this = this;

    this.loading = true;
    this.$store.dispatch('loadGroups').finally(function () {
      _this.loading = false;
    });
  },
  data: function data() {
    return {
      loading: false
    };
  },

  computed: {
    groups: function groups() {
      return this.$store.getters.getGroups;
    }
  },
  methods: {
    createGroup: function createGroup() {
      var _this2 = this;

      var name = window.prompt('Client Group Name:');
      if (name) {
        this.loading = true;
        this.$store.dispatch('addGroup', name).finally(function () {
          _this2.loading = false;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d144f18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/GroupsPage.vue
var GroupsPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7 mx-auto"},[_c('button',{staticClass:"btn btn-success mb-3",attrs:{"type":"button"},on:{"click":_vm.createGroup}},[_vm._v("Create group")]),_vm._v(" "),(_vm.groups)?_c('groups-table',{attrs:{"groups":_vm.groups}}):_vm._e(),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)])])}
var GroupsPage_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row py-3"},[_c('div',{staticClass:"col-md-12"},[_c('h1',{staticClass:"text-center"},[_vm._v("Groups")])])])}]
var GroupsPage_esExports = { render: GroupsPage_render, staticRenderFns: GroupsPage_staticRenderFns }
/* harmony default export */ var pages_GroupsPage = (GroupsPage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/GroupsPage.vue
var GroupsPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var GroupsPage___vue_template_functional__ = false
/* styles */
var GroupsPage___vue_styles__ = null
/* scopeId */
var GroupsPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GroupsPage___vue_module_identifier__ = null
var GroupsPage_Component = GroupsPage_normalizeComponent(
  GroupsPage,
  pages_GroupsPage,
  GroupsPage___vue_template_functional__,
  GroupsPage___vue_styles__,
  GroupsPage___vue_scopeId__,
  GroupsPage___vue_module_identifier__
)

/* harmony default export */ var _service_app_pages_GroupsPage = (GroupsPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/forms/UploadFileForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UploadFileForm = ({
  data: function data() {
    return {
      file: null,
      loading: false,
      errMsg: null
    };
  },

  methods: {
    uploadFile: function uploadFile() {
      var _this = this;

      this.loading = true;

      var fd = new FormData();
      fd.append('file', this.file);

      uploadService.uploadCSV(fd).then(function () {
        _this.$refs.fileinput.reset();
        _this.$emit('uploadSuccess');
      }).catch(function (errRes) {
        _this.errMsg = errRes.error;
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47d23eee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/forms/UploadFileForm.vue
var UploadFileForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.errMsg)?_c('div',{staticClass:"alert alert-danger text-center pb-3"},[_vm._v("\n    "+_vm._s(_vm.errMsg)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pb-3"},[_c('b-form-file',{ref:"fileinput",attrs:{"required":""},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-block btn-success",attrs:{"disabled":!_vm.file},on:{"click":_vm.uploadFile}},[_vm._v("Upload file")]),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)}
var UploadFileForm_staticRenderFns = []
var UploadFileForm_esExports = { render: UploadFileForm_render, staticRenderFns: UploadFileForm_staticRenderFns }
/* harmony default export */ var forms_UploadFileForm = (UploadFileForm_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/forms/UploadFileForm.vue
var UploadFileForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UploadFileForm___vue_template_functional__ = false
/* styles */
var UploadFileForm___vue_styles__ = null
/* scopeId */
var UploadFileForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UploadFileForm___vue_module_identifier__ = null
var UploadFileForm_Component = UploadFileForm_normalizeComponent(
  UploadFileForm,
  forms_UploadFileForm,
  UploadFileForm___vue_template_functional__,
  UploadFileForm___vue_styles__,
  UploadFileForm___vue_scopeId__,
  UploadFileForm___vue_module_identifier__
)

/* harmony default export */ var components_forms_UploadFileForm = (UploadFileForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/tables/UploadsTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UploadsTable = ({
  props: ['uploads']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-571d21e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/tables/UploadsTable.vue
var UploadsTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-bordered"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.uploads),function(upload){return _c('tr',{class:[{'text-danger': upload.errorMsg}, {'bg-warning': upload.status !== 'success' && upload.status !== 'failed'}]},[_c('td',[_vm._v(_vm._s(upload.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(upload.uploadTime))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(upload.user.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(upload.filename))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(upload.status))]),_vm._v(" "),_c('td',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(upload.errorMsg))])])}))])}
var UploadsTable_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("Time")]),_vm._v(" "),_c('th',[_vm._v("User")]),_vm._v(" "),_c('th',[_vm._v("File")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Notes")])])])}]
var UploadsTable_esExports = { render: UploadsTable_render, staticRenderFns: UploadsTable_staticRenderFns }
/* harmony default export */ var tables_UploadsTable = (UploadsTable_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/tables/UploadsTable.vue
var UploadsTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UploadsTable___vue_template_functional__ = false
/* styles */
var UploadsTable___vue_styles__ = null
/* scopeId */
var UploadsTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UploadsTable___vue_module_identifier__ = null
var UploadsTable_Component = UploadsTable_normalizeComponent(
  UploadsTable,
  tables_UploadsTable,
  UploadsTable___vue_template_functional__,
  UploadsTable___vue_styles__,
  UploadsTable___vue_scopeId__,
  UploadsTable___vue_module_identifier__
)

/* harmony default export */ var components_tables_UploadsTable = (UploadsTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/HomePage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var HomePage = ({
  components: {
    UploadFileForm: components_forms_UploadFileForm,
    UploadsTable: components_tables_UploadsTable
  },
  created: function created() {
    this.loadRecentUploads();
  },
  data: function data() {
    return {
      showModal: false,
      timeoutID: null
    };
  },

  computed: {
    uploads: function uploads() {
      return this.$store.getters.getRecentUploadsSummary;
    }
  },
  methods: {
    onUploadSuccess: function onUploadSuccess() {
      this.showModal = true;
      this.loadRecentUploads();
    },
    loadRecentUploads: function loadRecentUploads() {
      var self = this;
      this.$store.dispatch('loadRecentUploadsSummary').then(function (uploads) {
        window.clearTimeout(self.timeoutID);
        var hasUnprocessedFile = uploads.find(function (upload) {
          return upload.status === 'pending' || upload.status === 'working';
        });
        if (hasUnprocessedFile) {
          self.timeoutID = window.setTimeout(self.loadRecentUploads, 1000);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-348783ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/HomePage.vue
var HomePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid pt-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 mx-auto"},[_c('upload-file-form',{on:{"uploadSuccess":_vm.onUploadSuccess}})],1)]),_vm._v(" "),_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card"},[_c('h3',{staticClass:"card-header"},[_vm._v("Latest actions")]),_vm._v(" "),_c('uploads-table',{attrs:{"uploads":_vm.uploads}})],1)])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Successful Upload","header-bg-variant":"success","header-text-variant":"light"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('div',{attrs:{"slot":"modal-header-close"},slot:"modal-header-close"}),_vm._v(" "),_c('p',[_vm._v("The file was uploaded successfully.")]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.showModal=false}}},[_vm._v("OK")])],1)])],1)}
var HomePage_staticRenderFns = []
var HomePage_esExports = { render: HomePage_render, staticRenderFns: HomePage_staticRenderFns }
/* harmony default export */ var pages_HomePage = (HomePage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/HomePage.vue
var HomePage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HomePage___vue_template_functional__ = false
/* styles */
var HomePage___vue_styles__ = null
/* scopeId */
var HomePage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HomePage___vue_module_identifier__ = null
var HomePage_Component = HomePage_normalizeComponent(
  HomePage,
  pages_HomePage,
  HomePage___vue_template_functional__,
  HomePage___vue_styles__,
  HomePage___vue_scopeId__,
  HomePage___vue_module_identifier__
)

/* harmony default export */ var _service_app_pages_HomePage = (HomePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/tables/UsersTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UsersTable = ({
  props: ['users'],
  methods: {
    resetPass: function resetPass(user) {
      if (confirm('Are you sure you want to reset the password of client ' + user.name + '?')) {
        services_userService.sendMailForNewPass(user.email);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41c4ce8b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/tables/UsersTable.vue
var UsersTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-bordered"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.users),function(user){return _c('tr',[_c('td',[_vm._v(_vm._s(user.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.resetPass(user)}}},[_vm._v("Reset password")])])])}))])}
var UsersTable_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th')])])}]
var UsersTable_esExports = { render: UsersTable_render, staticRenderFns: UsersTable_staticRenderFns }
/* harmony default export */ var tables_UsersTable = (UsersTable_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/tables/UsersTable.vue
var UsersTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UsersTable___vue_template_functional__ = false
/* styles */
var UsersTable___vue_styles__ = null
/* scopeId */
var UsersTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UsersTable___vue_module_identifier__ = null
var UsersTable_Component = UsersTable_normalizeComponent(
  UsersTable,
  tables_UsersTable,
  UsersTable___vue_template_functional__,
  UsersTable___vue_styles__,
  UsersTable___vue_scopeId__,
  UsersTable___vue_module_identifier__
)

/* harmony default export */ var components_tables_UsersTable = (UsersTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/UsersPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UsersPage = ({
  components: {
    UsersTable: components_tables_UsersTable
  },
  created: function created() {
    var users = this.$store.getters.getUsers(this.currentPage);

    if (!users.length) {
      this.loadUsers(this.currentPage);
    }
  },
  data: function data() {
    return {
      loading: false,
      currentPage: 1,
      itemsPerPage: 20
    };
  },

  computed: {
    users: function users() {
      return this.$store.getters.getUsers(this.currentPage);
    },
    total: function total() {
      return this.$store.getters.getUsersTotal;
    }
  },
  methods: {
    loadUsers: function loadUsers(page) {
      var _this = this;

      this.loading = true;
      this.$store.dispatch('getUsers', { page: page, itemsPerPage: this.itemsPerPage }).finally(function () {
        _this.loading = false;
      });
    }
  },
  watch: {
    currentPage: function currentPage() {
      this.loadUsers(this.currentPage);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33f02a3f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/UsersPage.vue
var UsersPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row pb-3"},[_c('div',{staticClass:"col-md-12 d-flex"},[_c('b-button',{attrs:{"variant":"success","to":"/users/create"}},[_vm._v("Create user")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('users-table',{attrs:{"users":_vm.users}}),_vm._v(" "),(_vm.total > _vm.itemsPerPage)?_c('b-pagination',{attrs:{"size":"md","total-rows":_vm.total,"per-page":_vm.itemsPerPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}):_vm._e(),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)])])}
var UsersPage_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row py-3"},[_c('div',{staticClass:"col-md-12"},[_c('h1',{staticClass:"text-center"},[_vm._v("Users")])])])}]
var UsersPage_esExports = { render: UsersPage_render, staticRenderFns: UsersPage_staticRenderFns }
/* harmony default export */ var pages_UsersPage = (UsersPage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/UsersPage.vue
var UsersPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UsersPage___vue_template_functional__ = false
/* styles */
var UsersPage___vue_styles__ = null
/* scopeId */
var UsersPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UsersPage___vue_module_identifier__ = null
var UsersPage_Component = UsersPage_normalizeComponent(
  UsersPage,
  pages_UsersPage,
  UsersPage___vue_template_functional__,
  UsersPage___vue_styles__,
  UsersPage___vue_scopeId__,
  UsersPage___vue_module_identifier__
)

/* harmony default export */ var _service_app_pages_UsersPage = (UsersPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/forms/ChangePasswordForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ChangePasswordForm = ({
  props: {
    csrfToken: {}
  },
  validations: {
    formData: {
      oldPassword: {
        required: validators["required"]
      },
      newPassword: {
        required: validators["required"]
      },
      repNewPassword: {
        required: validators["required"],
        sameAsNewPass: Object(validators["sameAs"])('newPassword')
      }
    }
  },
  data: function data() {
    return {
      formData: {
        oldPassword: null,
        newPassword: null,
        repNewPassword: null
      },
      loading: false,
      errMsg: null
    };
  },

  methods: {
    submitHandler: function submitHandler() {
      var _this = this;

      if (!this.$v.formData.$invalid) {
        this.loading = true;
        services_userService.changePass(this.formData.oldPassword, this.formData.newPassword).then(function (res) {
          _this.$emit('changeSuccess');
        }).catch(function () {
          // TODO: provide a better error message
          _this.errMsg = 'OOPSS! Something goes wrong. Try again.';
        }).finally(function () {
          _this.loading = false;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80a60c36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/forms/ChangePasswordForm.vue
var ChangePasswordForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();_vm.submitHandler($event)}}},[(_vm.errMsg)?_c('div',{staticClass:"alert alert-danger text-center"},[_vm._v("\n    "+_vm._s(_vm.errMsg)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Old password")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.oldPassword),expression:"formData.oldPassword"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': !_vm.$v.formData.oldPassword.required && _vm.$v.formData.oldPassword.$dirty }],attrs:{"type":"password","placeholder":"Old Password"},domProps:{"value":(_vm.formData.oldPassword)},on:{"blur":function($event){_vm.$v.formData.oldPassword.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "oldPassword", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n        Please, enter old password.\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("New Password")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.newPassword),expression:"formData.newPassword"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': !_vm.$v.formData.newPassword.required && _vm.$v.formData.newPassword.$dirty }],attrs:{"type":"password","placeholder":"New Password"},domProps:{"value":(_vm.formData.newPassword)},on:{"blur":function($event){_vm.$v.formData.newPassword.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "newPassword", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n        Please, enter the new password\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Repeat New Password")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.repNewPassword),expression:"formData.repNewPassword"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': (!_vm.$v.formData.repNewPassword.required && _vm.$v.formData.repNewPassword.$dirty) || !_vm.$v.formData.repNewPassword.sameAsNewPass }],attrs:{"type":"password","placeholder":"Repeat New Password"},domProps:{"value":(_vm.formData.repNewPassword)},on:{"blur":function($event){_vm.$v.formData.repNewPassword.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "repNewPassword", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.$v.formData.repNewPassword.sameAsNewPass ? 'Repeated password is not the same' : 'Please, repeat the new password')+"\n      ")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-block btn-success",attrs:{"type":"submit","disabled":_vm.$v.formData.$invalid}},[_vm._v("Change Password")]),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)}
var ChangePasswordForm_staticRenderFns = []
var ChangePasswordForm_esExports = { render: ChangePasswordForm_render, staticRenderFns: ChangePasswordForm_staticRenderFns }
/* harmony default export */ var forms_ChangePasswordForm = (ChangePasswordForm_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/forms/ChangePasswordForm.vue
var ChangePasswordForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangePasswordForm___vue_template_functional__ = false
/* styles */
var ChangePasswordForm___vue_styles__ = null
/* scopeId */
var ChangePasswordForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChangePasswordForm___vue_module_identifier__ = null
var ChangePasswordForm_Component = ChangePasswordForm_normalizeComponent(
  ChangePasswordForm,
  forms_ChangePasswordForm,
  ChangePasswordForm___vue_template_functional__,
  ChangePasswordForm___vue_styles__,
  ChangePasswordForm___vue_scopeId__,
  ChangePasswordForm___vue_module_identifier__
)

/* harmony default export */ var components_forms_ChangePasswordForm = (ChangePasswordForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/auth/ChangePassPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ChangePassPage = ({
  components: {
    changePasswordForm: components_forms_ChangePasswordForm
  },
  data: function data() {
    return {
      changeMode: true
    };
  },

  methods: {
    toggleMode: function toggleMode() {
      this.changeMode = !this.changeMode;
    }
  },
  computed: {
    csrfToken: function csrfToken() {
      return this.$store.getters.getToken;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d20de4f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/auth/ChangePassPage.vue
var ChangePassPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-lg-8 col-xl-6 mx-auto pt-3"},[(_vm.changeMode)?_c('div',[_c('h1',{staticClass:"text-center pb-3"},[_vm._v("Change Password")]),_vm._v(" "),_c('change-password-form',{attrs:{"csrfToken":_vm.csrfToken},on:{"changeSuccess":_vm.toggleMode}})],1):_c('div',{staticClass:"text-center"},[_c('h2',[_vm._v("Password was changed successfully")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success",attrs:{"type":"button"},on:{"click":_vm.toggleMode}},[_vm._v("Back")])])])])])}
var ChangePassPage_staticRenderFns = []
var ChangePassPage_esExports = { render: ChangePassPage_render, staticRenderFns: ChangePassPage_staticRenderFns }
/* harmony default export */ var auth_ChangePassPage = (ChangePassPage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/auth/ChangePassPage.vue
var ChangePassPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChangePassPage___vue_template_functional__ = false
/* styles */
var ChangePassPage___vue_styles__ = null
/* scopeId */
var ChangePassPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChangePassPage___vue_module_identifier__ = null
var ChangePassPage_Component = ChangePassPage_normalizeComponent(
  ChangePassPage,
  auth_ChangePassPage,
  ChangePassPage___vue_template_functional__,
  ChangePassPage___vue_styles__,
  ChangePassPage___vue_scopeId__,
  ChangePassPage___vue_module_identifier__
)

/* harmony default export */ var pages_auth_ChangePassPage = (ChangePassPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/forms/LoginForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LoginForm = ({
  validations: {
    formData: {
      password: {
        required: validators["required"]
      },
      email: {
        required: validators["required"],
        email: validators["email"]
      }
    }
  },
  data: function data() {
    return {
      formData: {
        password: null,
        email: null
      },
      loading: false,
      errMsg: null
    };
  },

  methods: {
    submitHandler: function submitHandler() {
      var _this = this;

      if (!this.$v.formData.$invalid) {
        this.loading = true;
        this.$store.dispatch('login', this.formData).then(function () {
          _this.$emit('loginSuccess');
        }).catch(function (errRes) {
          if (errRes.wrongAppErr) {
            _this.errMsg = errRes.message;
          } else {
            _this.errMsg = errRes.error;
          }
        }).finally(function () {
          _this.loading = false;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79f11f77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/forms/LoginForm.vue
var LoginForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();_vm.submitHandler($event)}}},[(_vm.errMsg)?_c('div',{staticClass:"alert alert-danger text-center"},[_vm._v("\n    "+_vm._s(_vm.errMsg)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.email),expression:"formData.email"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': (!_vm.$v.formData.email.required && _vm.$v.formData.email.$dirty) || !_vm.$v.formData.email.email }],attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.formData.email)},on:{"blur":function($event){_vm.$v.formData.email.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.$v.formData.email.required ? 'Please, enter valid email' : 'Please, enter email')+"\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.password),expression:"formData.password"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': !_vm.$v.formData.password.required && _vm.$v.formData.password.$dirty }],attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.formData.password)},on:{"blur":function($event){_vm.$v.formData.password.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "password", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n        Please, enter password.\n      ")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-block btn-success",attrs:{"type":"submit","disabled":_vm.$v.formData.$invalid}},[_vm._v("Login")]),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)}
var LoginForm_staticRenderFns = []
var LoginForm_esExports = { render: LoginForm_render, staticRenderFns: LoginForm_staticRenderFns }
/* harmony default export */ var forms_LoginForm = (LoginForm_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/forms/LoginForm.vue
var LoginForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LoginForm___vue_template_functional__ = false
/* styles */
var LoginForm___vue_styles__ = null
/* scopeId */
var LoginForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LoginForm___vue_module_identifier__ = null
var LoginForm_Component = LoginForm_normalizeComponent(
  LoginForm,
  forms_LoginForm,
  LoginForm___vue_template_functional__,
  LoginForm___vue_styles__,
  LoginForm___vue_scopeId__,
  LoginForm___vue_module_identifier__
)

/* harmony default export */ var components_forms_LoginForm = (LoginForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/auth/LoginPage.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LoginPage = ({
  components: {
    loginForm: components_forms_LoginForm
  },
  methods: {
    onLoginSuccess: function onLoginSuccess() {
      this.$router.push('/');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ba1db12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/auth/LoginPage.vue
var LoginPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-lg-8 col-xl-6 mx-auto pt-3"},[_c('h1',{staticClass:"text-center pb-3"},[_vm._v("Login")]),_vm._v(" "),_c('login-form',{on:{"loginSuccess":_vm.onLoginSuccess}})],1)])])}
var LoginPage_staticRenderFns = []
var LoginPage_esExports = { render: LoginPage_render, staticRenderFns: LoginPage_staticRenderFns }
/* harmony default export */ var auth_LoginPage = (LoginPage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/auth/LoginPage.vue
var LoginPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var LoginPage___vue_template_functional__ = false
/* styles */
var LoginPage___vue_styles__ = null
/* scopeId */
var LoginPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LoginPage___vue_module_identifier__ = null
var LoginPage_Component = LoginPage_normalizeComponent(
  LoginPage,
  auth_LoginPage,
  LoginPage___vue_template_functional__,
  LoginPage___vue_styles__,
  LoginPage___vue_scopeId__,
  LoginPage___vue_module_identifier__
)

/* harmony default export */ var pages_auth_LoginPage = (LoginPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/components/forms/ResetPasswordForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ResetPasswordForm = ({
  props: ['id', 'token'],
  validations: {
    formData: {
      password: {
        required: validators["required"]
      },
      repPassword: {
        required: validators["required"],
        sameAsPass: Object(validators["sameAs"])('password')
      }
    }
  },
  data: function data() {
    return {
      formData: {
        password: null,
        repPassword: null
      },
      loading: false,
      errMsg: null
    };
  },

  methods: {
    submitHandler: function submitHandler() {
      var _this = this;

      if (!this.$v.formData.$invalid) {
        this.loading = true;
        services_userService.setNewPass(this.token, this.id, this.formData.password).then(function (res) {
          _this.$emit('actionSuccess');
        }).catch(function (errRes) {
          _this.errMsg = errRes.error;
        }).finally(function () {
          _this.loading = false;
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78cd4efb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/components/forms/ResetPasswordForm.vue
var ResetPasswordForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();_vm.submitHandler($event)}}},[(_vm.errMsg)?_c('div',{staticClass:"alert alert-danger text-center"},[_vm._v("\n    "+_vm._s(_vm.errMsg)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.password),expression:"formData.password"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': !_vm.$v.formData.password.required && _vm.$v.formData.password.$dirty }],attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.formData.password)},on:{"blur":function($event){_vm.$v.formData.password.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "password", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n        Please, enter the password\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label col-form-label-sm"},[_vm._v("Repeat Password")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.repPassword),expression:"formData.repPassword"}],staticClass:"form-control form-control-sm",class:[{ 'is-invalid': (!_vm.$v.formData.repPassword.required && _vm.$v.formData.repPassword.$dirty) || !_vm.$v.formData.repPassword.sameAsPass }],attrs:{"type":"password","placeholder":"Repeat Password"},domProps:{"value":(_vm.formData.repPassword)},on:{"blur":function($event){_vm.$v.formData.repPassword.$touch()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "repPassword", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("\n        "+_vm._s(_vm.$v.formData.repPassword.sameAsPass ? 'Repeated password is not the same' : 'Please, repeat the password')+"\n      ")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-block btn-success",attrs:{"type":"submit","disabled":_vm.$v.formData.$invalid}},[_vm._v("Set Password")]),_vm._v(" "),_c('loading',{attrs:{"loading":_vm.loading}})],1)}
var ResetPasswordForm_staticRenderFns = []
var ResetPasswordForm_esExports = { render: ResetPasswordForm_render, staticRenderFns: ResetPasswordForm_staticRenderFns }
/* harmony default export */ var forms_ResetPasswordForm = (ResetPasswordForm_esExports);
// CONCATENATED MODULE: ./src/-service-app/components/forms/ResetPasswordForm.vue
var ResetPasswordForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ResetPasswordForm___vue_template_functional__ = false
/* styles */
var ResetPasswordForm___vue_styles__ = null
/* scopeId */
var ResetPasswordForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ResetPasswordForm___vue_module_identifier__ = null
var ResetPasswordForm_Component = ResetPasswordForm_normalizeComponent(
  ResetPasswordForm,
  forms_ResetPasswordForm,
  ResetPasswordForm___vue_template_functional__,
  ResetPasswordForm___vue_styles__,
  ResetPasswordForm___vue_scopeId__,
  ResetPasswordForm___vue_module_identifier__
)

/* harmony default export */ var components_forms_ResetPasswordForm = (ResetPasswordForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/-service-app/pages/auth/ResetPassPage.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ResetPassPage = ({
  components: {
    resetPasswordForm: components_forms_ResetPasswordForm
  },
  props: ['id', 'token'],
  data: function data() {
    return {
      isActionSuccessful: false
    };
  },

  computed: {
    title: function title() {
      return (this.id && this.token ? 'Set' : 'Reset') + ' Password';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246ccd7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/-service-app/pages/auth/ResetPassPage.vue
var ResetPassPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-lg-8 col-xl-6 mx-auto pt-3"},[(!_vm.isActionSuccessful)?_c('div',[_c('h1',{staticClass:"text-center pb-3"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('reset-password-form',{attrs:{"id":_vm.id,"token":_vm.token},on:{"actionSuccess":function($event){_vm.isActionSuccessful = true}}})],1):_c('div',{staticClass:"text-center"},[_c('h2',[_vm._v(_vm._s(_vm.title)+" was successful")]),_vm._v(" "),_c('b-button',{attrs:{"size":"lg","variant":"success","to":"/login"}},[_vm._v("Log in")])],1)])])])}
var ResetPassPage_staticRenderFns = []
var ResetPassPage_esExports = { render: ResetPassPage_render, staticRenderFns: ResetPassPage_staticRenderFns }
/* harmony default export */ var auth_ResetPassPage = (ResetPassPage_esExports);
// CONCATENATED MODULE: ./src/-service-app/pages/auth/ResetPassPage.vue
var ResetPassPage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ResetPassPage___vue_template_functional__ = false
/* styles */
var ResetPassPage___vue_styles__ = null
/* scopeId */
var ResetPassPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ResetPassPage___vue_module_identifier__ = null
var ResetPassPage_Component = ResetPassPage_normalizeComponent(
  ResetPassPage,
  auth_ResetPassPage,
  ResetPassPage___vue_template_functional__,
  ResetPassPage___vue_styles__,
  ResetPassPage___vue_scopeId__,
  ResetPassPage___vue_module_identifier__
)

/* harmony default export */ var pages_auth_ResetPassPage = (ResetPassPage_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/-service-app/services/groupService.js



var groupService_API_V1_URL = "https://updateapi.blockchain.bg/v1";

/* harmony default export */ var groupService = ({
  create: function create(name) {
    return axios_default.a.post(groupService_API_V1_URL + '/cgroups', { name: name }).then(function (res) {
      return res.data;
    });
  },
  update: function update(_ref) {
    var id = _ref.id,
        name = _ref.name;

    return axios_default.a.patch(groupService_API_V1_URL + '/cgroup/' + id, { name: name });
  },
  delete: function _delete(groupId) {
    return axios_default.a.delete(groupService_API_V1_URL + '/cgroup/' + groupId);
  },
  getList: function getList() {
    return axios_default.a.get(groupService_API_V1_URL + '/cgroups').then(function (res) {
      return res.data.map(apiToGroup);
    });
  },
  getGroupClients: function getGroupClients(groupId) {
    return axios_default.a.get(groupService_API_V1_URL + '/cgroup/' + groupId);
  }
});
// CONCATENATED MODULE: ./src/-service-app/store/modules/groupsStore.js



var groupsStore_state = {
  groups: []
};

var getters = {
  getGroups: function getGroups(state) {
    return state.groups;
  }
};

var mutations = {
  setGroups: function setGroups(state, payload) {
    state.groups = payload;
  },
  addGroup: function addGroup(state, payload) {
    state.groups.push(payload);
  },
  updateGroup: function updateGroup(state, _ref) {
    var id = _ref.id,
        name = _ref.name;

    var group = state.groups.find(function (group) {
      return group.id === id;
    });
    if (group) {
      group.name = name;
    }
  },
  deleteGroup: function deleteGroup(state, payload) {
    var index = state.groups.findIndex(function (group) {
      return group.id === payload;
    });
    if (index > -1) {
      state.groups.splice(index, 1);
    }
  }
};

var actions = {
  loadGroups: function loadGroups(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    if (state.groups.length) {
      return promise_default.a.resolve(state.groups);
    }

    return groupService.getList().then(function (groups) {
      commit('setGroups', groups);
      return groups;
    });
  },
  addGroup: function addGroup(_ref3, name) {
    var commit = _ref3.commit;

    return groupService.create(name).then(function (group) {
      commit('addGroup', group);
      return group;
    });
  },
  updateGroup: function updateGroup(_ref4, group) {
    var commit = _ref4.commit;

    return groupService.update(group).then(function () {
      commit('updateGroup', group);
      return true;
    });
  },
  deleteGroup: function deleteGroup(_ref5, id) {
    var commit = _ref5.commit;

    return groupService.delete(id).then(function () {
      commit('deleteGroup', id);
      return true;
    });
  }
};

/* harmony default export */ var groupsStore = ({
  state: groupsStore_state,
  mutations: mutations,
  actions: actions,
  getters: getters
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./src/services/portfolioService.js




var portfolioService_API_V1_URL = "https://updateapi.blockchain.bg/v1";

/* harmony default export */ var portfolioService = ({
  getPortfolioDetails: function getPortfolioDetails(portfolioId) {
    return axios_default.a.get(portfolioService_API_V1_URL + '/portfolio/' + portfolioId).then(function (res) {
      return apiToPortfolio(res.data);
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj.error);
    });
  },
  getPortfolioTransactions: function getPortfolioTransactions(portfolioId) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

    return axios_default.a.get(portfolioService_API_V1_URL + '/portfolio/' + portfolioId + '/tx?offset=' + offset + '&limit=' + limit).then(function (res) {
      return {
        transactions: res.data.map(apiToTransaction),
        total: res.count
      };
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj.error);
    });
  }
});
// CONCATENATED MODULE: ./src/-service-app/services/portfolioService.js






var services_portfolioService_API_V1_URL = "https://updateapi.blockchain.bg/v1";

/* harmony default export */ var services_portfolioService = (extends_default()({}, portfolioService, {
  createPortfolio: function createPortfolio(userId, portfolioId) {
    var portfolio = {
      id: portfolioId,
      userId: userId
    };
    return axios_default.a.post(services_portfolioService_API_V1_URL + '/portfolios', portfolio).then(function (res) {
      return res.data.id;
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj.response.data.error);
    });
  },
  getTotalPortfolios: function getTotalPortfolios() {
    return axios_default.a.get(services_portfolioService_API_V1_URL + '/portfolio').then(function (res) {
      return apiToPortfolio(res.data);
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj.response.data.error);
    });
  },
  deleteAllTransactions: function deleteAllTransactions() {
    return axios_default.a.delete(services_portfolioService_API_V1_URL + '/tx').catch(function (errObj) {
      return promise_default.a.reject(errObj.response.data.error);
    });
  },
  exportAllTransactions: function exportAllTransactions() {
    return axios_default.a.get(services_portfolioService_API_V1_URL + '/tx/listall').then(function (res) {
      return res.data;
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj.response.data.error);
    });
  }
}));
// CONCATENATED MODULE: ./src/-service-app/store/modules/portfolioStore.js





var INITIAL_PORTFOLIO = {
  id: null,
  stats: null,
  assets: null,
  transactions: null,
  transactionsTotal: null
};

var portfolioStore_state = {
  selectedPortfolio: extends_default()({}, INITIAL_PORTFOLIO),
  totalPortfolios: extends_default()({}, INITIAL_PORTFOLIO),
  updateTime: null
};

var portfolioStore_getters = {
  getUpdateTime: function getUpdateTime(state) {
    return state.updateTime;
  },

  // Selected Portfolio (SP)
  getSPStats: function getSPStats(state) {
    return state.selectedPortfolio.stats;
  },
  getSPAssets: function getSPAssets(state) {
    return state.selectedPortfolio.assets;
  },
  getSPTransactions: function getSPTransactions(state) {
    return state.selectedPortfolio.transactions;
  },
  getSPTransactionsTotal: function getSPTransactionsTotal(state) {
    return state.selectedPortfolio.transactionsTotal;
  },

  // Total Portfolios (TP)
  getTPStats: function getTPStats(state) {
    return state.totalPortfolios.stats;
  },
  getTPAssets: function getTPAssets(state) {
    return state.totalPortfolios.assets;
  }
};

var portfolioStore_mutations = {
  // Selected Portfolio (SP)
  selectPortfolio: function selectPortfolio(state, payload) {
    if (state.selectedPortfolio.id !== payload) {
      // Set a new portfolio or none
      var id = payload || INITIAL_PORTFOLIO.id;
      state.selectedPortfolio = assign_default()({}, INITIAL_PORTFOLIO, { id: id });
    }
  },
  setSPDetails: function setSPDetails(state, payload) {
    var selectedPortfolio = state.selectedPortfolio;
    if (selectedPortfolio.id === payload.id) {
      selectedPortfolio.stats = payload.stats;
      selectedPortfolio.assets = payload.assets;
      state.updateTime = payload.updateTime;
    } else {
      console.error('Selected portfolio is different.');
    }
  },
  setSPTransactions: function setSPTransactions(state, payload) {
    var selectedPortfolio = state.selectedPortfolio;
    if (selectedPortfolio.id === payload.id) {
      selectedPortfolio.transactions = selectedPortfolio.transactions || [];
      selectedPortfolio.transactions[payload.page] = payload.transactions;
      selectedPortfolio.transactionsTotal = payload.total;
    } else {
      console.error('Selected portfolio is different.');
    }
  },

  // Total Portfolios (TP)
  setTotalPortfolios: function setTotalPortfolios(state, payload) {
    state.totalPortfolios = payload;
    state.updateTime = payload.updateTime;
  }
};

var portfolioStore_actions = {
  // Selected Portfolio (SP)
  loadPortfolioDetails: function loadPortfolioDetails(_ref, portfolioId) {
    var commit = _ref.commit;

    var selectedPortfolio = portfolioStore_state.selectedPortfolio;
    if (selectedPortfolio.id === portfolioId && selectedPortfolio.assets && selectedPortfolio.stats) {
      return promise_default.a.resolve();
    }

    commit('selectPortfolio', portfolioId);

    return services_portfolioService.getPortfolioDetails(portfolioId).then(function (data) {
      commit('setSPDetails', data);
      return data;
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj.error);
    });
  },
  loadPortfolioTransactions: function loadPortfolioTransactions(_ref2, _ref3) {
    var commit = _ref2.commit,
        state = _ref2.state;
    var portfolioId = _ref3.portfolioId,
        page = _ref3.page,
        itemsPerPage = _ref3.itemsPerPage;

    var selectedPortfolio = state.selectedPortfolio;
    if (selectedPortfolio.id === portfolioId && selectedPortfolio.transactions && selectedPortfolio.transactions[page]) {
      return promise_default.a.resolve();
    }

    page = page || 1;
    var limit = itemsPerPage || 20;
    var offset = limit * (page - 1);

    commit('selectPortfolio', portfolioId);

    return services_portfolioService.getPortfolioTransactions(portfolioId, offset, limit).then(function (res) {
      var payload = {
        id: portfolioId,
        page: page,
        transactions: res.transactions,
        total: res.total
      };
      commit('setSPTransactions', payload);
      return payload;
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj.error);
    });
  },

  // Total Portfolios (TP)
  loadTotalPortfolios: function loadTotalPortfolios(_ref4) {
    var commit = _ref4.commit;

    return services_portfolioService.getTotalPortfolios().then(function (data) {
      commit('setTotalPortfolios', data);
      return data;
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj.error);
    });
  },

  // !! FOR TESTING PURPOSES ONLY
  deleteAllTransactions: function deleteAllTransactions(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state;

    return services_portfolioService.deleteAllTransactions().then(function () {
      commit('selectPortfolio', state.selectedPortfolio.id);
      commit('setTotalPortfolios', assign_default()({}, INITIAL_PORTFOLIO));
    });
  },
  exportAllTransactions: function exportAllTransactions(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state;

    return services_portfolioService.exportAllTransactions().then(function (data) {
      return data;
    });
  }
};

/* harmony default export */ var portfolioStore = ({
  state: portfolioStore_state,
  mutations: portfolioStore_mutations,
  actions: portfolioStore_actions,
  getters: portfolioStore_getters
});
// CONCATENATED MODULE: ./src/-service-app/store/modules/uploadStore.js


var uploadStore_state = {
  recentUploads: null
};

var uploadStore_getters = {
  getRecentUploadsSummary: function getRecentUploadsSummary(state) {
    return state.recentUploads;
  }
};

var uploadStore_mutations = {
  setRecentUploads: function setRecentUploads(state, payload) {
    state.recentUploads = payload;
  }
};

var uploadStore_actions = {
  loadRecentUploadsSummary: function loadRecentUploadsSummary(_ref) {
    var commit = _ref.commit;

    return uploadService.getRecentUploadsSummary().then(function (uploads) {
      commit('setRecentUploads', uploads);
      return uploads;
    });
  }
};

/* harmony default export */ var uploadStore = ({
  state: uploadStore_state,
  mutations: uploadStore_mutations,
  actions: uploadStore_actions,
  getters: uploadStore_getters
});
// CONCATENATED MODULE: ./src/-service-app/store/modules/usersStore.js






var usersStore_role = 'admin';

var usersStore_state = {
  users: [],
  usersPage: 1,
  usersTotal: 0,
  clients: [],
  clientsPage: 1,
  clientsTotal: 0,
  client: null,
  csrfToken: null,
  loggedUser: null
};

var usersStore_getters = {
  getLoggedUser: function getLoggedUser(state) {
    return state.loggedUser;
  },
  getToken: function getToken(state) {
    return state.csrfToken;
  },
  getUsersTotal: function getUsersTotal(state) {
    return state.usersTotal;
  },
  getUsers: function getUsers(state) {
    return function (page) {
      return page === state.usersPage ? state.users : [];
    };
  },
  getClientsTotal: function getClientsTotal(state) {
    return state.clientsTotal;
  },
  getClients: function getClients(state) {
    return function (page) {
      return page === state.clientsPage ? state.clients : [];
    };
  },
  getClient: function getClient(state) {
    return state.client;
  }
};

var usersStore_mutations = {
  // Becomes complicated when combined with list pagination
  // createUser(state, payload) {
  //   state.users.push(payload)
  // },
  // createClient(state, payload) {
  //   state.clients.push(payload)
  // },
  setUsers: function setUsers(state, _ref) {
    var users = _ref.users,
        total = _ref.total,
        page = _ref.page;

    state.users = users;
    state.usersTotal = total;
    state.usersPage = page;
  },
  setClients: function setClients(state, _ref2) {
    var users = _ref2.users,
        total = _ref2.total,
        page = _ref2.page;

    state.clients = users;
    state.clientsTotal = total;
    state.clientsPage = page;
  },
  setClient: function setClient(state, payload) {
    state.client = payload;
  },
  login: function login(state, payload) {
    state.csrfToken = payload.csrfToken;
    state.loggedUser = payload.user;
  },
  logout: function logout(state) {
    state.csrfToken = null;
    state.loggedUser = null;
  },
  setClientGroups: function setClientGroups(state, payload) {
    state.client.cgroups = payload;
  }
};

var usersStore_actions = {
  loadUsersCash: function loadUsersCash(_ref3) {
    var commit = _ref3.commit;

    var auth = JSON.parse(sessionStorage.getItem('auth'));
    if (auth && auth.user.role === usersStore_role) {
      commit('login', auth);
    }
  },
  login: function login(_ref4, credentials) {
    var commit = _ref4.commit;

    return services_userService.login(credentials.email, credentials.password, usersStore_role).then(function (res) {
      sessionStorage.setItem('auth', stringify_default()(res));
      commit('login', res);
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj);
    });
  },
  logout: function logout(_ref5, credentials) {
    var commit = _ref5.commit;

    commit('logout');
    router.push('/login');
    sessionStorage.clear();
    return services_userService.logout();
  },
  createClient: function createClient(_ref6, clientData) {
    var commit = _ref6.commit;

    var createUserType = 'createClient';
    var client = void 0;

    return services_userService[createUserType](clientData).then(function (resUser) {
      client = resUser;
      // Read the comment in mutations
      // commit(createUserType, client)
      return services_portfolioService.createPortfolio(client.id, clientData.portfolioId);
    }).then(function (resPortdolioID) {
      client.portfolios = [resPortdolioID];
      return client;
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj);
    });
  },
  createUser: function createUser(_ref7, user) {
    var commit = _ref7.commit;

    var createUserType = 'createUser';

    return services_userService[createUserType](user).then(function (resUser) {
      // Read the comment in mutations
      // commit(createUserType, resUser)
      return resUser;
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj);
    });
  },
  getUsers: function getUsers(_ref8, _ref9) {
    var commit = _ref8.commit;
    var page = _ref9.page,
        itemsPerPage = _ref9.itemsPerPage;

    page = page || 1;
    var limit = itemsPerPage || 20;
    var offset = limit * (page - 1);

    return services_userService.getUsers(offset, limit).then(function (_ref10) {
      var users = _ref10.users,
          total = _ref10.total;

      commit('setUsers', { users: users, total: total, page: page });
      return { users: users, total: total };
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj);
    });
  },
  getClients: function getClients(_ref11, _ref12) {
    var commit = _ref11.commit;
    var page = _ref12.page,
        itemsPerPage = _ref12.itemsPerPage;

    page = page || 1;
    var limit = itemsPerPage || 20;
    var offset = limit * (page - 1);

    return services_userService.getClients(offset, limit).then(function (_ref13) {
      var users = _ref13.users,
          total = _ref13.total;

      commit('setClients', { users: users, total: total, page: page });
      return { users: users, total: total };
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj);
    });
  },
  getClient: function getClient(_ref14, clientId) {
    var commit = _ref14.commit;

    return services_userService.getUser(clientId).then(function (client) {
      commit('setClient', client);
      return client;
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj);
    });
  },
  setClient: function setClient(_ref15, client) {
    var commit = _ref15.commit;

    commit('setClient', client);
    return promise_default.a.resolve(client);
  },
  updateClientGroups: function updateClientGroups(_ref16, _ref17) {
    var commit = _ref16.commit;
    var id = _ref17.id,
        cgroups = _ref17.cgroups;

    return services_userService.updateClientGroups(id, cgroups).then(function () {
      commit('setClientGroups', cgroups);
    });
  }
};

/* harmony default export */ var usersStore = ({
  state: usersStore_state,
  mutations: usersStore_mutations,
  actions: usersStore_actions,
  getters: usersStore_getters
});
// CONCATENATED MODULE: ./src/-service-app/services/currencyService.js


var currencyService_API_V1_URL = "https://updateapi.blockchain.bg/v1";

/* harmony default export */ var currencyService = ({
  getCurrencies: function getCurrencies(offset, limit) {
    // return axios.get(API_V1_URL + '/prices/currencies/?limit=40000')
    //   .then(res => res.data)
    //   .catch(errObj => Promise.reject(errObj.response.data.error))
    var query = [['offset', offset], ['limit', limit]].map(function (pair) {
      return pair.join('=');
    }).join('&');

    return axios_default.a.get(currencyService_API_V1_URL + '/prices/currencies?' + query).then(function (res) {
      return {
        currencies: res.data,
        total: res.count
      };
    });
  },
  getCurrenciesTotal: function getCurrenciesTotal() {
    return axios_default.a.get(currencyService_API_V1_URL + '/prices/currencies').then(function (res) {
      return res.count;
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj.response.data.error);
    });
  },
  deleteCurrency: function deleteCurrency(id) {
    return axios_default.a.delete(currencyService_API_V1_URL + '/prices/' + id);
  }
});
// CONCATENATED MODULE: ./src/-service-app/store/modules/currenciesStore.js



var currenciesStore_state = {
  currencies: [],
  currenciesPage: 1,
  currenciesTotal: 0
};

var currenciesStore_getters = {
  getCurrenciesTotal: function getCurrenciesTotal(state) {
    return state.currenciesTotal;
  },
  getCurrencies: function getCurrencies(state) {
    return function (page) {
      return page === state.currenciesPage ? state.currencies : [];
    };
  }
};

var currenciesStore_mutations = {
  setCurrencies: function setCurrencies(state, _ref) {
    var currencies = _ref.currencies,
        total = _ref.total,
        page = _ref.page;

    state.currencies = currencies;
    state.currenciesTotal = total;
    state.currenciesPage = page;
  },
  deleteCurrency: function deleteCurrency(state, payload) {
    var index = state.currencies.findIndex(function (currencies) {
      return currencies.id === payload;
    });
    if (index > -1) {
      state.currencies.splice(index, 1);
    }
  }
};

var currenciesStore_actions = {
  getCurrencies: function getCurrencies(_ref2, _ref3) {
    var commit = _ref2.commit;
    var page = _ref3.page,
        itemsPerPage = _ref3.itemsPerPage;

    page = page || 1;
    var limit = itemsPerPage || 20;
    var offset = limit * (page - 1);

    return currencyService.getCurrencies(offset, limit).then(function (_ref4) {
      var currencies = _ref4.currencies,
          total = _ref4.total;

      commit('setCurrencies', { currencies: currencies, total: total, page: page });
      return { currencies: currencies, total: total };
    }).catch(function (errObj) {
      return promise_default.a.reject(errObj);
    });
  },
  deleteCurrency: function deleteCurrency(_ref5, id) {
    var commit = _ref5.commit;

    return currencyService.deleteCurrency(id).then(function () {
      commit('deleteCurrency', id);
      return true;
    });
  }
};

/* harmony default export */ var currenciesStore = ({
  state: currenciesStore_state,
  mutations: currenciesStore_mutations,
  actions: currenciesStore_actions,
  getters: currenciesStore_getters
});
// CONCATENATED MODULE: ./src/-service-app/store/index.js








vue_runtime_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var store_store = new vuex_esm["a" /* default */].Store({
  modules: {
    groups: groupsStore,
    portfolio: portfolioStore,
    upload: uploadStore,
    users: usersStore,
    currencies: currenciesStore
  }
});
// CONCATENATED MODULE: ./src/router/guard.js
/* harmony default export */ var guard = (function (store) {
  return {
    requireGuest: function requireGuest(to, from, next) {
      // Will stop the routing
      next(store.state.users.csrfToken ? {
        path: '/',
        query: {
          redirect: to.fullPath
        }
      } : true);
    },
    requireUser: function requireUser(to, from, next) {
      // Will login and come back
      next(store.state.users.csrfToken ? true : {
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    }
  };
});
// CONCATENATED MODULE: ./src/-service-app/router/index.js
/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true } }] */



// Pages












// AUTH Pages






var routerGuard = guard(store_store);

vue_runtime_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: _service_app_pages_HomePage,
    beforeEnter: routerGuard.requireUser
  }, {
    path: '/clients',
    name: 'Clients',
    component: _service_app_pages_ClientsPage,
    beforeEnter: routerGuard.requireUser
  }, {
    path: '/clients/create',
    name: 'Create Client',
    component: _service_app_pages_CreateClientPage,
    beforeEnter: routerGuard.requireUser
  }, {
    path: '/clients/:id',
    name: 'Client',
    component: _service_app_pages_ClientPage,
    beforeEnter: routerGuard.requireUser,
    props: true
  }, {
    path: '/users',
    name: 'Users',
    beforeEnter: routerGuard.requireUser,
    component: _service_app_pages_UsersPage
  }, {
    path: '/users/create',
    name: 'CreateUser',
    component: _service_app_pages_CreateUserPage,
    beforeEnter: routerGuard.requireUser
  }, {
    path: '/groups',
    name: 'Groups',
    beforeEnter: routerGuard.requireUser,
    component: _service_app_pages_GroupsPage
  },
  // {
  //   path: '/users/create',
  //   name: 'CreateUser',
  //   component: CreateUser,
  //   beforeEnter: routerGuard.requireUser,
  // },
  {
    path: '/fund',
    name: 'Fund',
    component: _service_app_pages_FundPage,
    beforeEnter: routerGuard.requireUser
  }, {
    path: '/rebalance',
    name: 'Rebalance',
    component: _service_app_pages_RebalancePage,
    beforeEnter: routerGuard.requireUser
  }, {
    path: '/prices',
    name: 'Prices',
    component: _service_app_pages_PricesPage,
    beforeEnter: routerGuard.requireUser
  }, {
    path: '/currencies',
    name: 'Currencies',
    component: _service_app_pages_CurrenciesPage,
    beforeEnter: routerGuard.requireUser
  },
  // AUTH
  {
    path: '/login',
    name: 'Login',
    component: pages_auth_LoginPage,
    beforeEnter: routerGuard.requireGuest
  }, {
    path: '/change',
    name: 'Change',
    component: pages_auth_ChangePassPage,
    beforeEnter: routerGuard.requireUser
  }, {
    path: '/reset/:id/:token',
    name: 'Reset',
    component: pages_auth_ResetPassPage,
    props: true,
    beforeEnter: routerGuard.requireGuest
  }, {
    path: '/setup/:id/:token',
    name: 'Setup',
    component: pages_auth_ResetPassPage,
    props: true,
    beforeEnter: routerGuard.requireGuest
  }, {
    path: '*',
    redirect: '/'
  }],
  mode: 'history'
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Loading.vue
//
//
//
//
//
//

/* harmony default export */ var Loading = ({
  props: {
    loading: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-129d7abb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
var Loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":"/static/images/loading.gif"}})]):_vm._e()}
var Loading_staticRenderFns = []
var Loading_esExports = { render: Loading_render, staticRenderFns: Loading_staticRenderFns }
/* harmony default export */ var components_Loading = (Loading_esExports);
// CONCATENATED MODULE: ./src/components/Loading.vue
var Loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Loading___vue_template_functional__ = false
/* styles */
var Loading___vue_styles__ = null
/* scopeId */
var Loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Loading___vue_module_identifier__ = null
var Loading_Component = Loading_normalizeComponent(
  Loading,
  components_Loading,
  Loading___vue_template_functional__,
  Loading___vue_styles__,
  Loading___vue_scopeId__,
  Loading___vue_module_identifier__
)

/* harmony default export */ var src_components_Loading = (Loading_Component.exports);

// EXTERNAL MODULE: ./src/-service-app/styles/main-end.scss
var main_end = __webpack_require__("HKQM");
var main_end_default = /*#__PURE__*/__webpack_require__.n(main_end);

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// EXTERNAL MODULE: ./src/-service-app/i18n/en.json
var en = __webpack_require__("ppdy");
var en_default = /*#__PURE__*/__webpack_require__.n(en);

// EXTERNAL MODULE: ./src/-service-app/i18n/bg.json
var bg = __webpack_require__("cO4Z");
var bg_default = /*#__PURE__*/__webpack_require__.n(bg);

// CONCATENATED MODULE: ./src/-service-app/i18n/index.js



/* harmony default export */ var i18n = ({
  en: en_default.a,
  bg: bg_default.a
});
// CONCATENATED MODULE: ./src/-service-app/main.js


// Import always before all components












// Import always after all components




vue_runtime_esm["a" /* default */].config.productionTip = !true;

store_store.dispatch('loadUsersCash');

configAxios(store_store);

vue_runtime_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);
vue_runtime_esm["a" /* default */].use(es["a" /* default */]);
vue_runtime_esm["a" /* default */].use(lib_default.a);
vue_runtime_esm["a" /* default */].use(vue_charts_common_default.a);
vue_runtime_esm["a" /* default */].component('loading', src_components_Loading);

/* eslint-disable no-new */
new vue_runtime_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store_store,
  i18n: new vue_i18n_esm["a" /* default */]({
    locale: 'en',
    messages: i18n,
    fallbackLocale: 'en'
  }),
  render: function render(h) {
    return h(src__service_app_App);
  }
});

/***/ }),

/***/ "cDAa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cO4Z":
/***/ (function(module, exports) {

module.exports = {"lang":"БГ","Client ID":"Клиентски номер","Name":"Име","Email":"Имейл","Phone":"Телефон","Contract Id":"Договор номер","Portfolio Id":"Клиентска сметка","Password":"Парола","Transaction number":"Номер на транзакция","Logout":"Изход","ROI":"Възвращаемост в лева","Portfolio":"Клиентска сметка","Cryptocurrency":"Криптовалута","Ticker":"Код","Share":"Дял","Value (BGN)":"Стойност в лева","Number of coins":"Брой койни","Price (BGN)":"Цена в лева","Total Deposits":"Общо депозити","Total Withdrawals":"Общо тегления","Total Commissions":"Общо комисионни","Net Profit":"Печалба","loginPageTitle":"Вход в системата","loginFormSubmit":"Вход","BGN":"лева","on":"към","Average cost basis":"Средна цена на придобиване","roiTable30days":"За последните 30 дена","roiTableYear":"От началото на годината","roiTableContract":"От началото на договора","Type":"Тип","Date":"Дата","Currency N Amount":"Брой койни валута {num}","Quantity":"Количество","Currency":"Валута","currency":"валута","Value in BGN":"Стойност в лева","There are no any transactions":"Не са налични транзакции","Change Password":"Промени паролата","priceUpdateInfo":"* Цените са взети от {source} на {updateTime} UTC.","noData":"Няма данни","overview":"Моментно състояние","transactions":"Транзакции","transaction type":"Вид транзакция","Sold currency amount":"Количество продадена валута","Sold currency":"Продадена валута","amount":"количество","Set Password":"Създай парола","Please, repeat the password":"Повторете паролата","Repeated password is not the same":"Паролите не съвпадат","Repeat Password":"Повторете паролата","Please, enter the password":"Моля, въведете паролата","Repeat New Password":"Повторете новата парола","Please, enter the new password":"Моля, въведете новата парола","Please, enter old password":"Моля, въведете старата парола","Old password":"Стара парола","New Password":"Нова парола","Password was changed successfully":"Паролата беше променена успешно","deposit":"депозит","withdrawal":"теглене","change":"обмен","commission":"комисионна","blockchain fee":"блокчейн такса","noUserErr":"Няма такъв потребител","invalid user and/or password":"Грешен потребител и/или парола","taxmodule":"Данъчна информация","Select a tax year":"Изберете данъчна година","Tax result by transactions":"Данъчен резултат по сделка","Tax result by date":"Данъчен резултат по дата","Sale proceeds":"Продажна цена","Cost basis":"Цена на придобиване","Profit/Loss":"Резултат от сделката","Net result":"Нетен резултат","Total profit":"Обща печалба","Total loss":"Обща загуба","Download as PDF":"Свали PDF файл","Download as CSV":"Свали CSV файл","bgn":"лв.","There is no tax event in the selected tax year":"Няма продажби или замяна на криптовалути през избраната данъчна година"}

/***/ }),

/***/ "dW2o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n9mN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ppdy":
/***/ (function(module, exports) {

module.exports = {"lang":"EN","Client ID":"Client ID","Name":"Name","Email":"Email","Phone":"Phone","Contract Id":"Contract Id","Portfolio Id":"Portfolio Id","Password":"Password","Transaction number":"Transaction number","Logout":"Logout","ROI":"Return on Investment (BGN)","Portfolio":"Portfolio","Cryptocurrency":"Cryptocurrency","Ticker":"Ticker","Share":"Share","Value (BGN)":"Value (BGN)","Number of coins":"Number of coins","Price (BGN)":"Price (BGN)","Total Deposits":"Total Deposits","Total Withdrawals":"Total Withdrawals","Total Commissions":"Total Commissions","Net Profit":"Net Profit","loginPageTitle":"Login","loginFormSubmit":"Login","BGN":"BGN","on":"on","Average cost basis":"Average cost basis","roiTable30days":"Last 30 days","roiTableYear":"From the begining of the year","roiTableContract":"From the begining of the contract","Type":"Type","Date":"Date","Currency N Amount":"Currency {num} Amount","Quantity":"Quantity","Currency":"Currency","currency":"currency","Value in BGN":"Value in BGN","There are no any transactions":"There are no any transactions","Change Password":"Change Password","priceUpdateInfo":"* The prices are taken from {source} on {updateTime} UTC.","noData":"No data","overview":"Overview","transactions":"Transactions","transaction type":"Transaction type","Sold currency":"Sold currency","Sold currency amount":"Sold currency amount","amount":"amount","Set Password":"Set Password","Please, repeat the password":"Please, repeat the password","Repeated password is not the same":"Repeated password is not the same","Repeat Password":"Repeat Password","Please, enter the password":"Please, enter the password","Repeat New Password":"Repeat New Password","Please, enter the new password":"Please, enter the new password","Please, enter old password":"Please, enter old password","Old password":"Old password","New Password":"New Password","Password was changed successfully":"Password was changed successfully","deposit":"deposit","withdrawal":"withdrawal","change":"change","commission":"commission","blockchain fee":"blockchain fee","noUserErr":"There is no such user","invalid user and/or password":"Invalid user and/or password","taxmodule":"Tax info","year":"Year","Select a tax year":"Select a tax year","Tax result by transactions":"Tax result by transactions","Tax result by date":"Tax result by date","Sale proceeds":"Sale proceeds","Cost basis":"Cost basis","Profit/Loss":"Profit/Loss","Net result":"Net result","Total profit":"Total profit","Total loss":"Total loss","Download as PDF":"Download as PDF","Download as CSV":"Download as CSV","bgn":"BGN","There is no tax event in the selected tax year":"There is no tax event in the selected tax year"}

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/progress/_progress.js
var _progress = __webpack_require__("E9Zr");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/progress/progress.vue
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var progress = (_progress["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/progress/progress.vue
function injectStyle (ssrContext) {
  __webpack_require__("dW2o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  progress,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var progress_progress = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "shdt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "ww1v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xBwK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zoSq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["Zr7l"]);


// WEBPACK FOOTER //
// static/js/app.6d6a59e7a6cbc9cd36c5.js